import { createStaticVNode as Ie, defineComponent as x, createElementBlock as m, openBlock as u, Fragment as U, renderList as ne, unref as p, normalizeClass as L, createElementVNode as d, createVNode as M, toDisplayString as k, createTextVNode as J, computed as w, watch as be, h as fe, createBlock as D, createCommentVNode as T, toRefs as st, withDirectives as We, mergeProps as ge, vModelDynamic as lo, vModelText as Sn, getCurrentScope as Ss, onScopeDispose as Ts, getCurrentInstance as Ca, hasInjectionContext as co, inject as lt, shallowRef as Cn, watchEffect as yn, toValue as Je, onMounted as Ct, ref as N, withModifiers as Pn, withKeys as fa, renderSlot as pe, vShow as Ms, vModelRadio as Is, vModelCheckbox as Ls, isRef as Xi, resolveComponent as _s, withCtx as le, resolveDynamicComponent as ht, provide as Ai, onBeforeMount as Os, KeepAlive as Ps, Suspense as Bs, onUnmounted as ya, shallowReactive as Wa, onBeforeUnmount as uo, reactive as oa, useId as Rs, onUpdated as Ns, cloneVNode as Ds, normalizeStyle as bi, nextTick as wi, useSlots as fo, createSlots as Hs, normalizeProps as Fs, guardReactiveProps as Vs } from "vue";
import { defineStore as zs, storeToRefs as mo, getActivePinia as Us, createPinia as Qs } from "pinia";
import js from "axios";
const tn = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [a, i] of e)
    n[a] = i;
  return n;
}, Zs = {};
function Gs(t, e) {
  return e[0] || (e[0] = Ie('<div class="mb-3 p-4 text-center"><span class="md:hidden">Mobile (100%)</span><span class="hidden md:block xl:hidden">Tablet vertical (768px)</span><span class="hidden xl:block 2xl:hidden">Tablet horizontal (1024px)</span><span class="hidden 2xl:block 3xl:hidden">Desktop (1366px)</span><span class="hidden 3xl:block">HD Desktop (1440px)</span></div><div class="anw-container bg-success-100"><div class="anw-grid relative z-0"><div class="anw-grid absolute bottom-0 left-0 right-0 top-0 -z-10 text-center text-white"><div class="bg-error-50 p-2 font-bold text-black">1</div><div class="bg-error-50 p-2 font-bold text-black">2</div><div class="bg-error-50 p-2 font-bold text-black">3</div><div class="bg-error-50 p-2 font-bold text-black">4</div><div class="hidden bg-error-50 p-2 font-bold text-black md:block">5</div><div class="hidden bg-error-50 p-2 font-bold text-black md:block">6</div><div class="hidden bg-error-50 p-2 font-bold text-black md:block">7</div><div class="hidden bg-error-50 p-2 font-bold text-black md:block">8</div><div class="hidden bg-error-50 p-2 font-bold text-black xl:block">9</div><div class="hidden bg-error-50 p-2 font-bold text-black xl:block">10</div><div class="hidden bg-error-50 p-2 font-bold text-black xl:block">11</div><div class="hidden bg-error-50 p-2 font-bold text-black xl:block">12</div></div><main class="col-span-4 md:col-span-8"><div class="flex min-h-[450px] items-center justify-center bg-success-600/30 p-4 text-center text-5xl font-bold text-success-700"> Main Content </div></main><aside class="col-span-4 md:col-span-8 xl:col-span-4 xl:col-start-9"><div class="flex h-full items-center justify-center bg-success-600/30 p-4 text-center text-5xl font-bold text-success-700"> Aside Content </div></aside></div></div>', 2));
}
const Ys = /* @__PURE__ */ tn(Zs, [["render", Gs]]), po = 5, go = ["Ungenügend", "Ausreichend", "Befriedigend", "Gut", "Sehr gut"], er = ["Bewertung", "Bewertungen"], Ks = { class: "my-1 flex text-neutral-300" }, je = /* @__PURE__ */ x({
  __name: "AnwRatingStars",
  props: {
    ratingAverage: {}
  },
  setup(t) {
    const e = t, n = (a) => a <= e.ratingAverage || a - 0.29 < e.ratingAverage ? "filled" : a - 0.8 < e.ratingAverage ? "half" : "";
    return (a, i) => (u(), m("div", Ks, [
      (u(!0), m(U, null, ne(p(po), (r, o) => (u(), m("svg", {
        key: o,
        class: L(["anw-rating h-5 w-auto", n(r)]),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 42 42"
      }, i[0] || (i[0] = [
        d("path", {
          class: "half-star-1",
          d: "M8.65653 37.9894L21 29.925V0L15.754 13.7795L1.02783 14.5106L12.5118 23.758L8.65653 37.9894Z"
        }, null, -1),
        d("path", {
          class: "half-star-2",
          d: "M33.3435 37.9894L21 29.925V0L26.246 13.7795L40.9722 14.5106L29.4882 23.758L33.3435 37.9894Z"
        }, null, -1)
      ]), 2))), 128))
    ]));
  }
}), $s = { class: "inline-flex items-center gap-4" }, Js = { class: "grid justify-items-start" }, Ws = { class: "flex gap-1.5" }, qs = { class: "text-lg font-bold text-neutral-900" }, Xs = { class: "text-xs font-semibold text-neutral-900" }, Ci = /* @__PURE__ */ x({
  __name: "AnwGoogleRating",
  props: {
    ratingAverage: { default: 4.7 },
    ratingCount: { default: 324 }
  },
  setup(t) {
    return (e, n) => (u(), m("div", $s, [
      n[1] || (n[1] = Ie('<svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"><rect x="0.818359" y="0.105469" width="55" height="56" fill="url(#pattern0)"></rect><defs><pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_4418_10983" transform="matrix(0.00195312 0 0 0.00191825 0 -0.000662667)"></use></pattern><image id="image0_4418_10983" width="512" height="522" xlink:href="data:image/png;base64,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"></image></defs></svg>', 1)),
      d("div", Js, [
        n[0] || (n[0] = d("div", { class: "text-xs text-neutral-900" }, "Google Bewertungen", -1)),
        d("div", Ws, [
          d("span", qs, k(e.ratingAverage), 1),
          M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"])
        ]),
        d("div", Xs, k(`Basierend auf ${e.ratingCount} Bewertungen`), 1)
      ])
    ]));
  }
}), el = {
  id: "footer",
  "data-test-id": "footer"
}, tl = { class: "anw-column-screen anw-grid-layout gap-4 bg-info-900 py-8 md:py-12" }, nl = { class: "anw-column-full" }, al = { class: "mt-8 flex flex-col gap-4 md:mt-12 xl:mt-16 xl:flex-row xl:items-center xl:gap-8" }, il = { class: "xl:shrink-0" }, rl = { class: "mt-8 flex flex-col items-center gap-y-6 md:mt-[60px] xl:mt-32 xl:flex-row xl:justify-between" }, ol = { class: "text-base text-neutral-400" }, sl = { class: "anw-column-screen anw-grid-layout bg-info-50 pt-4 md:gap-4 md:pb-4 xl:py-3 2xl:bg-white" }, ll = { class: "anw-column-full" }, cl = { class: "flex flex-col items-center gap-4 md:flex-row md:justify-between" }, ul = { class: "flex w-full justify-center bg-white px-4 py-3 text-center md:w-auto md:bg-inherit md:p-0" }, dl = /* @__PURE__ */ x({
  __name: "AnwGridFooter",
  props: {
    ratingAverage: { default: 4.7 },
    ratingCount: { default: 324 }
  },
  setup(t) {
    const e = () => `© 2004-${(/* @__PURE__ */ new Date()).getFullYear()}`;
    return (n, a) => (u(), m("footer", el, [
      d("div", tl, [
        d("div", nl, [
          a[2] || (a[2] = Ie('<div class="grid grid-cols-1 gap-x-4 xl:grid-cols-3 xl:gap-y-16"><div class="xl:col-span-1"><a href="https://www.anwalt.de/" class="group flex h-[41px] w-[160px] rounded-md focus-visible:outline-none focus-visible:ring focus-visible:ring-white md:w-[215px]"><span class="sr-only">Anwalt suchen und finden bei anwalt.de</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 371.34 70.81" class="fill-white group-hover:fill-warning-400" aria-hidden="true"><path d="M103.12,48.56h-17.71l-3.52,9.66h-5.14l15.02-39.66h4.86l15.14,39.66h-5.14l-3.52-9.66Zm-1.56-4.25l-7.26-19.83h-.11l-7.21,19.83h14.58Z"></path><path d="M149.93,18.56V58.22h-4.97l-22.23-31.28h-.11v31.28h-4.86V18.56h4.8l22.4,31.61h.11V18.56h4.86Z"></path><path d="M208.09,18.56l-12.68,39.66h-4.69l-9.16-32.51h-.06l-9.33,32.51h-4.69l-12.68-39.66h5.19l9.77,31.67h.11l8.94-31.67h5.31l8.94,31.78h.06l9.77-31.78h5.19Z"></path><path d="M233.18,48.56h-17.71l-3.52,9.66h-5.14l15.02-39.66h4.86l15.14,39.66h-5.14l-3.52-9.66Zm-1.56-4.25l-7.26-19.83h-.11l-7.21,19.83h14.58Z"></path><path class="cls-1" d="M247.81,18.56h4.86V53.75h19.66v4.47h-24.52V18.56Z"></path><path class="cls-1" d="M277.86,23.03h-11.9v-4.47h28.71v4.47h-11.95V58.22h-4.86V23.03Z"></path><path d="M293.41,54.37c0-2.2,1.69-3.92,3.92-3.92,2.09,0,3.85,1.72,3.85,3.92s-1.76,3.85-3.85,3.85c-2.23,0-3.92-1.72-3.92-3.85Z"></path><path d="M308.75,18.56h11.9c12.57,0,20.56,8.15,20.56,19.88s-7.76,19.77-20.39,19.77h-12.07V18.56Zm11.73,35.24c9.55,0,15.75-6.42,15.75-15.36s-6.26-15.47-15.53-15.47h-7.09v30.83h6.87Z"></path><path d="M345.87,18.56h24.3v4.47h-19.38v13.24h15.92v4.47h-15.92v13.01h20.55v4.47h-25.47V18.56Z"></path><circle cx="35.41" cy="35.41" r="35.41"></circle><g class="fill-info-900"><path d="M42.65,39.13l6.62-12.98c.19-.38,.73-.38,.92,0l6.62,12.98s0,.02,0,.03h.55c-.67,3.61-3.83,6.35-7.63,6.35s-6.96-2.74-7.63-6.35h.55s0-.02,0-.03Zm11.53,.03l-3.99-8.12c-.19-.38-.74-.38-.92,0l-3.99,8.12h8.91Z"></path><path d="M14.44,46.03s0-.02,0-.03l6.62-12.98c.19-.38,.73-.38,.92,0l6.62,12.98s0,.02,0,.03h.55c-.67,3.61-3.83,6.35-7.63,6.35s-6.96-2.74-7.63-6.35h.55Zm11.54,0l-3.99-8.12c-.19-.38-.74-.38-.92,0l-3.99,8.12h8.91Z"></path><rect x="18.13" y="24.08" width="33.15" height="3.56" rx=".92" ry=".92" transform="translate(-5.07 8.79) rotate(-13.46)"></rect></g></svg></a></div><nav class="mt-8 xl:col-span-2 xl:mt-0 xl:flex xl:justify-end"><ul class="anw-footer-list"><li><a href="https://team.anwalt.de" class="anw-footer-link anw-default">Über uns</a></li><li><a href="https://www.anwalt.de/unternehmen/kontakt.php" class="anw-footer-link anw-default">Kontakt</a></li><li><a href="https://www.anwalt.de/jobs" class="anw-footer-link anw-default">Jobs und Karriere</a></li><li><a href="https://www.anwalt.de/impressum" class="anw-footer-link anw-default">Impressum</a></li><li><a href="https://www.anwalt.de/pdf/AGB_anwalt.de.pdf" class="anw-footer-link anw-default">AGB</a><span class="text-sm text-white"> &amp; </span><a href="https://www.anwalt.de/pdf/DSA_anwalt.de.pdf" class="anw-footer-link anw-default">DSA</a></li><li><a href="https://www.anwalt.de/pdf/anwalt.de_preisliste.pdf" class="anw-footer-link anw-default">Preisliste</a></li><li><a href="https://www.anwalt.de/pdf/anwalt.de_bewertungsrichtlinien.pdf" class="anw-footer-link anw-default">Bewertungsrichtlinien</a></li><li><a href="https://www.anwalt.de/pdf/DSE_anwalt.de.pdf" class="anw-footer-link anw-default">Datenschutz</a></li><li><a href="javascript:Cookiebot?.renew()" class="anw-footer-link anw-default">Cookies</a></li></ul></nav></div>', 1)),
          d("div", al, [
            a[0] || (a[0] = d("p", { class: "text-sm/[22px] text-neutral-400 xl:order-last 2xl:text-lg/[24px]" }, [
              J(" Hier bekommen Sie Recht – aktuell und schnell: Bleiben Sie auf dem Laufenden"),
              d("br", { class: "hidden xl:block" }),
              J(" und erhalten Sie hilfreiche Infos zu rechtlichen Fallen des Alltags. ")
            ], -1)),
            d("div", il, [
              M(p(_a), {
                "data-ga-trackingtype": "event",
                "data-ga-category": "UX",
                "data-ga-action": "Klick auf NL-Abo-Button in Footer",
                href: "https://www.anwalt.de/rechtstipps/newsletter.php",
                label: "Zum anwalt.de-Newsletter",
                appearance: "block-outline",
                "font-weight": "semibold"
              })
            ])
          ]),
          d("div", rl, [
            a[1] || (a[1] = Ie('<ul class="flex gap-x-4 xl:order-last"><li><a href="https://twitter.com/anwaltde" class="anw-footer-social-media anw-footer-social-media-x anw-default" target="_blank"><span class="sr-only">X</span><span class="sr-only">Link in einem neuen Tab öffnen</span><svg width="24" height="24" viewBox="0 -3 18 25" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10.7124 8.0452L17.4133 0H15.8254L10.0071 6.98554L5.35992 0H0L7.02738 10.5634L0 19H1.58799L7.73237 11.623L12.6401 19H18L10.7121 8.0452H10.7124ZM8.53747 10.6564L7.82546 9.60456L2.16017 1.2347H4.59922L9.17118 7.98944L9.8832 9.04132L15.8262 17.8215H13.3871L8.53747 10.6568V10.6564Z" fill="currentColor"></path></svg></a></li><li><a href="https://de.linkedin.com/company/anwaltde" class="anw-footer-social-media anw-default group" target="_blank"><span class="sr-only">LinkedIn</span><span class="sr-only">Link in einem neuen Tab öffnen</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="group-hover:hidden" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.22222 22H19.7778C21.0051 22 22 21.0051 22 19.7778V4.22222C22 2.99492 21.0051 2 19.7778 2H4.22222C2.99492 2 2 2.99492 2 4.22222V19.7778C2 21.0051 2.99492 22 4.22222 22ZM19.2222 19.2222H16.2543V14.1672C16.2543 12.7813 15.7277 12.0068 14.6307 12.0068C13.4374 12.0068 12.8139 12.8128 12.8139 14.1672V19.2222H9.9537V9.59259H12.8139V10.8897C12.8139 10.8897 13.6739 9.29839 15.7174 9.29839C17.7599 9.29839 19.2222 10.5457 19.2222 13.1253V19.2222ZM6.54148 8.33166C5.56723 8.33166 4.77777 7.53601 4.77777 6.55472C4.77777 5.57343 5.56723 4.77777 6.54148 4.77777C7.51573 4.77777 8.30472 5.57343 8.30472 6.55472C8.30472 7.53601 7.51573 8.33166 6.54148 8.33166ZM5.06459 19.2222H8.04705V9.59259H5.06459V19.2222Z" class="fill-current"></path></svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hidden group-hover:block" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.22222 22H19.7778C21.0051 22 22 21.0051 22 19.7778V4.22222C22 2.99492 21.0051 2 19.7778 2H4.22222C2.99492 2 2 2.99492 2 4.22222V19.7778C2 21.0051 2.99492 22 4.22222 22Z" fill="#007EBB"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2218 19.2223H16.2539V14.1673C16.2539 12.7814 15.7273 12.0069 14.6303 12.0069C13.437 12.0069 12.8135 12.8129 12.8135 14.1673V19.2223H9.95327V9.59265H12.8135V10.8898C12.8135 10.8898 13.6735 9.29845 15.7169 9.29845C17.7595 9.29845 19.2218 10.5457 19.2218 13.1254V19.2223ZM6.54105 8.33172C5.5668 8.33172 4.77734 7.53607 4.77734 6.55478C4.77734 5.57349 5.5668 4.77783 6.54105 4.77783C7.5153 4.77783 8.30429 5.57349 8.30429 6.55478C8.30429 7.53607 7.5153 8.33172 6.54105 8.33172ZM5.06416 19.2223H8.04662V9.59265H5.06416V19.2223Z" fill="white"></path></svg></a></li><li><a href="https://www.facebook.com/anwalt.de" class="anw-footer-social-media anw-default group" target="_blank"><span class="sr-only">Facebook</span><span class="sr-only">Link in einem neuen Tab öffnen</span><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="group-hover:hidden" aria-hidden="true"><path class="fill-current" d="M16.4398 13.0198L16.9798 9.65984H13.7998V7.31984C13.7998 6.35984 14.1598 5.63984 15.5998 5.63984H17.1598V2.57984C16.3198 2.45984 15.3598 2.33984 14.5198 2.33984C11.7598 2.33984 9.83984 4.01984 9.83984 7.01984V9.65984H6.83984V13.0198H9.83984V21.4798C10.4998 21.5998 11.1598 21.6598 11.8198 21.6598C12.4798 21.6598 13.1398 21.5998 13.7998 21.4798V13.0198H16.4398Z"></path></svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="hidden group-hover:block" aria-hidden="true"><path d="M16.4398 13.0201L16.9798 9.66009H13.7998V7.32009C13.7998 6.36009 14.1598 5.64009 15.5998 5.64009H17.1598V2.58009C16.3198 2.46009 15.3598 2.34009 14.5198 2.34009C11.7598 2.34009 9.83984 4.02009 9.83984 7.02009V9.66009H6.83984V13.0201H9.83984V21.4801C10.4998 21.6001 11.1598 21.6601 11.8198 21.6601C12.4798 21.6601 13.1398 21.6001 13.7998 21.4801V13.0201H16.4398Z" fill="#4267B2"></path></svg></a></li><li><a href="https://www.instagram.com/anwalt.de" class="anw-footer-social-media anw-default group" target="_blank"><span class="sr-only">Instagram</span><span class="sr-only">Link in einem neuen Tab öffnen</span><svg width="24" height="24" viewBox="-2 -2 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="group-hover:hidden"><path d="M14.4807 0H5.5192C2.47591 0 0 2.47603 0 5.51932V14.4808C0 17.5242 2.47591 20.0001 5.5192 20.0001H14.4807C17.5242 20.0001 20.0001 17.5241 20.0001 14.4808V5.51932C20.0003 2.47603 17.5242 0 14.4807 0ZM18.2258 14.4808C18.2258 16.5458 16.5458 18.2256 14.4808 18.2256H5.5192C3.45438 18.2258 1.77451 16.5458 1.77451 14.4808V5.51932C1.77451 3.4545 3.45438 1.77451 5.5192 1.77451H14.4807C16.5456 1.77451 18.2256 3.4545 18.2256 5.51932V14.4808H18.2258Z" fill="white"></path><path d="M10.0012 4.84668C7.15949 4.84668 4.84766 7.15851 4.84766 10.0002C4.84766 12.8418 7.15949 15.1535 10.0012 15.1535C12.8429 15.1535 15.1547 12.8418 15.1547 10.0002C15.1547 7.15851 12.8429 4.84668 10.0012 4.84668ZM10.0012 13.3789C8.13807 13.3789 6.62217 11.8632 6.62217 10.0001C6.62217 8.13686 8.13795 6.62107 10.0012 6.62107C11.8644 6.62107 13.3802 8.13686 13.3802 10.0001C13.3802 11.8632 11.8643 13.3789 10.0012 13.3789Z" fill="white"></path><path d="M15.3677 3.3418C15.0258 3.3418 14.69 3.48021 14.4485 3.72273C14.2059 3.96406 14.0664 4.30003 14.0664 4.6431C14.0664 4.98511 14.206 5.32097 14.4485 5.56348C14.6899 5.80482 15.0258 5.94441 15.3677 5.94441C15.7108 5.94441 16.0456 5.80482 16.2881 5.56348C16.5306 5.32097 16.669 4.98499 16.669 4.6431C16.669 4.30003 16.5306 3.96406 16.2881 3.72273C16.0468 3.48021 15.7108 3.3418 15.3677 3.3418Z" fill="white"></path></svg><svg class="hidden group-hover:block" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g><path d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(.instagram-gradient-0)"></path><path d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(.instagram-gradient-1)"></path><path d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(.instagram-gradient-2)"></path><path d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(.instagram-gradient-3)"></path><path d="M12.0041 4.56804C9.98453 4.56804 9.73108 4.57686 8.93788 4.61293C8.14625 4.64916 7.60589 4.77439 7.13307 4.95815C6.64399 5.14794 6.22911 5.40182 5.81579 5.81499C5.40216 6.22802 5.14808 6.64258 4.95753 7.13114C4.77318 7.60376 4.64769 8.14387 4.61206 8.93462C4.57659 9.72722 4.56729 9.98063 4.56729 11.9987C4.56729 14.0167 4.57628 14.2692 4.61221 15.0618C4.64863 15.8528 4.77396 16.3928 4.95769 16.8653C5.14777 17.354 5.40184 17.7685 5.81532 18.1816C6.2285 18.5949 6.64337 18.8494 7.13214 19.0392C7.60526 19.2229 8.14579 19.3482 8.93726 19.3844C9.73046 19.4205 9.98375 19.4293 12.0031 19.4293C14.0228 19.4293 14.2755 19.4205 15.0687 19.3844C15.8603 19.3482 16.4013 19.2229 16.8744 19.0392C17.3634 18.8494 17.7776 18.5949 18.1908 18.1816C18.6044 17.7685 18.8585 17.354 19.049 16.8654C19.2318 16.3928 19.3573 15.8527 19.3945 15.0619C19.4301 14.2693 19.4394 14.0167 19.4394 11.9987C19.4394 9.98063 19.4301 9.72737 19.3945 8.93477C19.3573 8.14371 19.2318 7.60376 19.049 7.1313C18.8585 6.64258 18.6044 6.22801 18.1908 5.81499C17.7771 5.40166 17.3635 5.14778 16.874 4.95815C16.3999 4.77439 15.8592 4.64916 15.0676 4.61293C14.2744 4.57686 14.0219 4.56804 12.0017 4.56804H12.0041ZM11.337 5.9071C11.535 5.90679 11.7559 5.9071 12.0041 5.9071C13.9895 5.9071 14.2248 5.91422 15.0089 5.94983C15.7339 5.98296 16.1274 6.10401 16.3895 6.20572C16.7365 6.3404 16.984 6.5014 17.2441 6.76147C17.5043 7.02154 17.6654 7.26923 17.8005 7.61599C17.9023 7.87761 18.0236 8.27081 18.0566 8.9953C18.0922 9.77861 18.1 10.0139 18.1 11.997C18.1 13.98 18.0922 14.2153 18.0566 14.9986C18.0235 15.7231 17.9023 16.1163 17.8005 16.3779C17.6658 16.7247 17.5043 16.9716 17.2441 17.2315C16.9838 17.4916 16.7367 17.6526 16.3895 17.7873C16.1277 17.8895 15.7339 18.0102 15.0089 18.0433C14.225 18.0789 13.9895 18.0867 12.0041 18.0867C10.0185 18.0867 9.78313 18.0789 8.99923 18.0433C8.27421 18.0099 7.88072 17.8888 7.61844 17.7871C7.27141 17.6524 7.02354 17.4914 6.76328 17.2314C6.50301 16.9713 6.3419 16.7242 6.20681 16.3773C6.10502 16.1157 5.98372 15.7225 5.95073 14.998C5.91509 14.2147 5.90797 13.9794 5.90797 11.9951C5.90797 10.0108 5.91509 9.77675 5.95073 8.99344C5.98388 8.26895 6.10502 7.87575 6.20681 7.61382C6.34158 7.26706 6.50301 7.01937 6.76328 6.7593C7.02354 6.49923 7.27141 6.33823 7.61844 6.20324C7.88056 6.10107 8.27421 5.98033 8.99923 5.94704C9.68522 5.91608 9.95106 5.90679 11.337 5.90524L11.337 5.9071ZM15.9734 7.14089C15.4808 7.14089 15.0811 7.53983 15.0811 8.03226C15.0811 8.52454 15.4808 8.92394 15.9734 8.92394C16.4661 8.92394 16.8658 8.52454 16.8658 8.03226C16.8658 7.53998 16.4661 7.14059 15.9734 7.14059L15.9734 7.14089ZM12.0041 8.18273C9.89513 8.18273 8.18529 9.89131 8.18529 11.9987C8.18529 14.106 9.89513 15.8138 12.0041 15.8138C14.113 15.8138 15.8222 14.106 15.8222 11.9987C15.8222 9.89131 14.1128 8.18273 12.0039 8.18273H12.0041ZM12.0041 9.52179C13.3729 9.52179 14.4828 10.6307 14.4828 11.9987C14.4828 13.3665 13.3729 14.4755 12.0041 14.4755C10.635 14.4755 9.52534 13.3665 9.52534 11.9987C9.52534 10.6307 10.635 9.52179 12.0041 9.52179Z" fill="white"></path></g><defs><radialGradient class="instagram-gradient-0" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21.3542 11.3742) rotate(164.25) scale(12.7789 9.20656)"><stop stop-color="#FF005F" offset="0"></stop><stop offset="1" stop-color="#FC01D8"></stop></radialGradient><radialGradient class="instagram-gradient-1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.31232 23.5404) rotate(-90) scale(15.9644 16.9379)"><stop stop-color="#FFCC00" offset="0"></stop><stop offset="0.1242" stop-color="#FFCC00"></stop><stop offset="0.5672" stop-color="#FE4A05"></stop><stop offset="0.6942" stop-color="#FF0F3F"></stop><stop offset="1" stop-color="#FE0657" stop-opacity="0"></stop></radialGradient><radialGradient class="instagram-gradient-2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.5054 21.7179) rotate(-59.8703) scale(6.60141 8.59429)"><stop stop-color="#FFCC00"></stop><stop offset="1" stop-color="#FFCC00" stop-opacity="0"></stop></radialGradient><radialGradient class="instagram-gradient-3" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4.71354 2.81439) rotate(164.274) scale(12.6371 4.30546)"><stop stop-color="#780CFF"></stop><stop offset="1" stop-color="#820BFF" stop-opacity="0"></stop></radialGradient></defs></svg></a></li></ul>', 1)),
            d("p", ol, k(e()), 1)
          ])
        ])
      ]),
      d("div", sl, [
        d("div", ll, [
          d("div", cl, [
            a[3] || (a[3] = Ie('<div class="flex items-center justify-center px-4 md:order-last md:px-0"><svg width="134" height="46" viewBox="0 0 134 46" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><g clip-path="url(#clip0_3728_36910)"><mask id="mask0_3728_36910" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="0" y="0" width="134" height="46"><path d="M133.636 0.464355H0V45.4644H133.636V0.464355Z" fill="white"></path></mask><g mask="url(#mask0_3728_36910)"><path d="M0.832033 0.820801L0.832031 15.5441H3.68002V0.820801H0.832033Z" fill="black"></path><path d="M0.863281 15.5596V30.2829H3.71126V15.5596H0.863281Z" fill="#C60202"></path><path d="M0.847656 30.2959V45.0192H3.69565V30.2959H0.847656Z" fill="#F4BA00"></path><path d="M15.6051 19.4266C13.5896 19.4266 12.2313 18.2907 12.1875 16.7179H13.2391C13.3267 17.5479 13.9401 18.5528 15.5613 18.5528C16.9634 18.5528 17.7959 17.7228 17.7959 16.6743C17.7959 13.7033 12.2313 15.582 12.2313 11.781C12.2313 10.2082 13.5019 9.07227 15.4736 9.07227C17.4015 9.07227 18.5407 10.1208 18.7159 11.5189H17.6205C17.4892 10.8198 16.8319 9.94606 15.4298 9.94606C14.2469 9.94606 13.2391 10.6014 13.2391 11.7373C13.2391 14.6645 18.8036 12.8732 18.8036 16.6305C18.8474 18.0286 17.752 19.4266 15.6051 19.4266Z" fill="black"></path><path d="M26.0743 10.0764H21.8241V13.8337H25.636V14.6639H21.8241V18.4647H26.0743V19.2949H20.8164V9.20264H26.0743V10.0764Z" fill="black"></path><path d="M31.1169 9.24805C33.4391 9.24805 34.5784 10.515 34.5784 12.1752C34.5784 13.5733 33.7897 14.7093 32.0809 15.0588L34.6659 19.3403H33.4392L30.9417 15.146H29.1015V19.3403H28.0938V9.24805H31.1169ZM31.1169 10.0781H29.1015V14.2724H31.1607C32.8257 14.2724 33.5267 13.3985 33.5267 12.1315C33.5267 10.9082 32.8257 10.0781 31.1169 10.0781Z" fill="black"></path><path d="M43.5201 9.24805H44.5716L40.7597 19.3403H39.6205L35.8086 9.24805H36.904L40.2339 18.248L43.5201 9.24805Z" fill="black"></path><path d="M51.3632 10.0764H47.1132V13.8337H50.9251V14.6639H47.1132V18.4647H51.3632V19.2949H46.1055V9.20264H51.3632V10.0764Z" fill="black"></path><path d="M56.399 9.24805C58.7213 9.24805 59.8604 10.515 59.8604 12.1752C59.8604 13.5733 59.0717 14.7093 57.3629 15.0588L59.9481 19.3403H58.7213L56.2238 15.146H54.3398V19.3403H53.332V9.24805H56.399ZM56.399 10.0781H54.3835V14.2724H56.4429C58.1079 14.2724 58.8089 13.3985 58.8089 12.1315C58.8089 10.9082 58.1079 10.0781 56.399 10.0781Z" fill="black"></path><path d="M64.941 19.4266C62.9255 19.4266 61.5672 18.2907 61.5234 16.7179H62.5749C62.6626 17.5479 63.276 18.5528 64.8972 18.5528C66.2993 18.5528 67.1318 17.7228 67.1318 16.6743C67.1318 13.7033 61.5672 15.582 61.5672 11.781C61.5672 10.2082 62.8378 9.07227 64.8095 9.07227C66.7374 9.07227 67.8766 10.1208 68.0518 11.5189H66.9564C66.825 10.8198 66.1678 9.94606 64.7658 9.94606C63.5827 9.94606 62.5749 10.6014 62.5749 11.7373C62.5749 14.6645 68.1395 12.8732 68.1395 16.6305C68.1833 18.0286 67.0441 19.4266 64.941 19.4266Z" fill="black"></path><path d="M69.4141 9.24805H76.0302V10.0781H73.226V19.3403H72.2182V10.0781H69.4141V9.24805Z" fill="black"></path><path d="M83.5207 16.9366H78.9201L78.0438 19.3396H76.9922L80.6726 9.37842H81.812L85.4924 19.3396H84.4408L83.5207 16.9366ZM81.1985 10.6454L79.183 16.1066H83.1701L81.1985 10.6454Z" fill="black"></path><path d="M94.6941 9.24805V19.3403H93.6864L88.078 10.8645V19.3403H87.0703V9.24805H88.078L93.6864 17.7237V9.24805H94.6941Z" fill="black"></path><path d="M105.34 14.316C105.34 17.4616 103.369 19.3403 99.995 19.3403H97.0156V9.24805H99.995C103.369 9.24805 105.34 11.1267 105.34 14.316ZM99.995 18.4665C102.843 18.4665 104.333 16.8937 104.333 14.2724C104.333 11.651 102.887 10.0345 99.995 10.0345H98.0234V18.4229H99.995V18.4665Z" fill="black"></path><path d="M111.737 19.4254C108.889 19.4254 106.742 17.2846 106.742 14.27C106.742 11.2555 108.933 9.11475 111.737 9.11475C114.585 9.11475 116.732 11.2555 116.732 14.27C116.732 17.2846 114.585 19.4254 111.737 19.4254ZM111.737 18.5516C113.972 18.5516 115.681 16.9351 115.681 14.27C115.681 11.6487 113.972 10.0322 111.737 10.0322C109.503 10.0322 107.794 11.6487 107.794 14.27C107.794 16.8915 109.503 18.5516 111.737 18.5516Z" fill="black"></path><path d="M121.641 9.24805C123.963 9.24805 125.103 10.515 125.103 12.1752C125.103 13.5733 124.314 14.7093 122.605 15.0588L125.19 19.3403H123.963L121.466 15.146H119.582V19.3403H118.574V9.24805H121.641ZM121.641 10.0781H119.626V14.2724H121.685C123.35 14.2724 124.051 13.3985 124.051 12.1315C124.051 10.9082 123.35 10.0781 121.641 10.0781Z" fill="black"></path><path d="M126.371 9.24805H132.987V10.0781H130.183V19.3403H129.175V10.0781H126.371V9.24805Z" fill="black"></path><path d="M21.0808 31.6593C21.0808 34.7611 18.9776 36.6398 15.7353 36.6398H12.4492V26.5913H15.7353C18.9776 26.5913 21.0808 28.5573 21.0808 31.6593ZM15.7353 35.2854C18.1014 35.2854 19.372 33.9311 19.372 31.6593C19.372 29.3873 18.1014 27.9457 15.7353 27.9457H14.1142V35.2854H15.7353Z" fill="black"></path><path d="M28.2677 27.9457H24.3681V30.8729H27.8296V32.2272H24.3681V35.2854H28.2677V36.6398H22.7031V26.5913H28.2677V27.9457Z" fill="black"></path><path d="M30.2852 26.5913H31.9502V32.9699C31.9502 34.5427 32.8264 35.2417 34.2285 35.2417C35.6306 35.2417 36.5069 34.499 36.5069 32.9699V26.5913H38.1719V32.9699C38.1719 35.5039 36.3317 36.7272 34.2285 36.7272C32.1254 36.7272 30.3291 35.5039 30.3291 32.9699V26.5913H30.2852Z" fill="black"></path><path d="M39.75 26.5913H46.7605V27.9457H44.0877V36.6398H42.4227V27.9457H39.75V26.5913Z" fill="black"></path><path d="M51.7523 36.7279C49.7367 36.7279 48.2031 35.6356 48.2031 33.8443H49.9558C50.0435 34.6745 50.6131 35.3298 51.7523 35.3298C52.8914 35.3298 53.5486 34.7182 53.5486 33.8443C53.5486 31.4415 48.2031 33.0143 48.2031 29.3007C48.2031 27.5531 49.6052 26.4609 51.6646 26.4609C53.5925 26.4609 54.9507 27.4657 55.0821 29.1697H53.2419C53.1981 28.4705 52.5848 27.8589 51.5331 27.8589C50.5692 27.8153 49.8244 28.2958 49.8244 29.2569C49.8244 31.5289 55.126 30.0871 55.126 33.7569C55.2136 35.2861 53.9869 36.7279 51.7523 36.7279Z" fill="black"></path><path d="M61.7436 26.4609C63.8468 26.4609 65.6431 27.5094 66.4318 29.4754H64.4601C63.9343 28.4269 62.9704 27.9026 61.7874 27.9026C59.772 27.9026 58.326 29.3007 58.326 31.5725C58.326 33.8443 59.772 35.2425 61.7874 35.2425C62.9704 35.2425 63.9343 34.7182 64.4601 33.6697H66.4318C65.687 35.6356 63.8468 36.6841 61.7436 36.6841C58.8956 36.6841 56.6172 34.5871 56.6172 31.5725C56.6172 28.6017 58.8956 26.4609 61.7436 26.4609Z" fill="black"></path><path d="M74.7135 32.2272H69.9814V36.596H68.3164V26.5913H69.9814V30.8729H74.7135V26.5913H76.3785V36.596H74.7135V32.2272Z" fill="black"></path><path d="M80.1914 26.5913V35.2854H83.6091V36.596H78.5703V26.5913H80.1914Z" fill="black"></path><path d="M91.0153 34.5864H86.8091L86.0642 36.6398H84.3555L87.9482 26.5913H89.8762L93.4689 36.6398H91.7164L91.0153 34.5864ZM88.9122 28.5573L87.2472 33.2321H90.5334L88.9122 28.5573Z" fill="black"></path><path d="M103.277 26.5913V36.6398H101.612L96.6611 29.1689V36.6398H94.9961V26.5913H96.6611L101.612 34.0621V26.5913H103.277Z" fill="black"></path><path d="M114.057 31.6593C114.057 34.7611 111.954 36.6398 108.712 36.6398H105.426V26.5913H108.712C111.954 26.5913 114.057 28.5573 114.057 31.6593ZM108.712 35.2854C111.078 35.2854 112.349 33.9311 112.349 31.6593C112.349 29.3873 111.078 27.9457 108.712 27.9457H107.091V35.2854H108.712Z" fill="black"></path></g></g><defs><clipPath id="clip0_3728_36910"><rect width="133.636" height="45" fill="white" transform="translate(0.183594 0.464355)"></rect></clipPath></defs></svg></div>', 1)),
            d("div", ul, [
              M(Ci, {
                "rating-average": n.ratingAverage,
                "rating-count": n.ratingCount
              }, null, 8, ["rating-average", "rating-count"])
            ])
          ])
        ])
      ])
    ]));
  }
});
function tr(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function O(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? tr(Object(n), !0).forEach(function(a) {
      me(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : tr(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function ma(t) {
  "@babel/helpers - typeof";
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ma(t);
}
function fl(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ml(t, e) {
  for (var n = 0; n < e.length; n++) {
    var a = e[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
  }
}
function pl(t, e, n) {
  return e && ml(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function me(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function yi(t, e) {
  return hl(t) || Al(t, e) || ho(t, e) || wl();
}
function Bn(t) {
  return gl(t) || vl(t) || ho(t) || bl();
}
function gl(t) {
  if (Array.isArray(t)) return qa(t);
}
function hl(t) {
  if (Array.isArray(t)) return t;
}
function vl(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Al(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var a = [], i = !0, r = !1, o, s;
    try {
      for (n = n.call(t); !(i = (o = n.next()).done) && (a.push(o.value), !(e && a.length === e)); i = !0)
        ;
    } catch (l) {
      r = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (r) throw s;
      }
    }
    return a;
  }
}
function ho(t, e) {
  if (t) {
    if (typeof t == "string") return qa(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return qa(t, e);
  }
}
function qa(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, a = new Array(e); n < e; n++) a[n] = t[n];
  return a;
}
function bl() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wl() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var nr = function() {
}, ki = {}, vo = {}, Ao = null, bo = {
  mark: nr,
  measure: nr
};
try {
  typeof window < "u" && (ki = window), typeof document < "u" && (vo = document), typeof MutationObserver < "u" && (Ao = MutationObserver), typeof performance < "u" && (bo = performance);
} catch {
}
var Cl = ki.navigator || {}, ar = Cl.userAgent, ir = ar === void 0 ? "" : ar, vt = ki, ae = vo, rr = Ao, Zn = bo;
vt.document;
var ct = !!ae.documentElement && !!ae.head && typeof ae.addEventListener == "function" && typeof ae.createElement == "function", wo = ~ir.indexOf("MSIE") || ~ir.indexOf("Trident/"), Gn, Yn, Kn, $n, Jn, it = "___FONT_AWESOME___", Xa = 16, Co = "fa", yo = "svg-inline--fa", Bt = "data-fa-i2svg", ei = "data-fa-pseudo-element", yl = "data-fa-pseudo-element-pending", xi = "data-prefix", Ei = "data-icon", or = "fontawesome-i2svg", kl = "async", xl = ["HTML", "HEAD", "STYLE", "SCRIPT"], ko = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), te = "classic", se = "sharp", Si = [te, se];
function Rn(t) {
  return new Proxy(t, {
    get: function(n, a) {
      return a in n ? n[a] : n[te];
    }
  });
}
var Tn = Rn((Gn = {}, me(Gn, te, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), me(Gn, se, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), Gn)), Mn = Rn((Yn = {}, me(Yn, te, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), me(Yn, se, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), Yn)), In = Rn((Kn = {}, me(Kn, te, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), me(Kn, se, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), Kn)), El = Rn(($n = {}, me($n, te, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), me($n, se, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), $n)), Sl = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, xo = "fa-layers-text", Tl = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, Ml = Rn((Jn = {}, me(Jn, te, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), me(Jn, se, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), Jn)), Eo = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Il = Eo.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Ll = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], _t = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, Ln = /* @__PURE__ */ new Set();
Object.keys(Mn[te]).map(Ln.add.bind(Ln));
Object.keys(Mn[se]).map(Ln.add.bind(Ln));
var _l = [].concat(Si, Bn(Ln), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", _t.GROUP, _t.SWAP_OPACITY, _t.PRIMARY, _t.SECONDARY]).concat(Eo.map(function(t) {
  return "".concat(t, "x");
})).concat(Il.map(function(t) {
  return "w-".concat(t);
})), kn = vt.FontAwesomeConfig || {};
function Ol(t) {
  var e = ae.querySelector("script[" + t + "]");
  if (e)
    return e.getAttribute(t);
}
function Pl(t) {
  return t === "" ? !0 : t === "false" ? !1 : t === "true" ? !0 : t;
}
if (ae && typeof ae.querySelector == "function") {
  var Bl = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Bl.forEach(function(t) {
    var e = yi(t, 2), n = e[0], a = e[1], i = Pl(Ol(n));
    i != null && (kn[a] = i);
  });
}
var So = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: Co,
  replacementClass: yo,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
kn.familyPrefix && (kn.cssPrefix = kn.familyPrefix);
var Xt = O(O({}, So), kn);
Xt.autoReplaceSvg || (Xt.observeMutations = !1);
var B = {};
Object.keys(So).forEach(function(t) {
  Object.defineProperty(B, t, {
    enumerable: !0,
    set: function(n) {
      Xt[t] = n, xn.forEach(function(a) {
        return a(B);
      });
    },
    get: function() {
      return Xt[t];
    }
  });
});
Object.defineProperty(B, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Xt.cssPrefix = e, xn.forEach(function(n) {
      return n(B);
    });
  },
  get: function() {
    return Xt.cssPrefix;
  }
});
vt.FontAwesomeConfig = B;
var xn = [];
function Rl(t) {
  return xn.push(t), function() {
    xn.splice(xn.indexOf(t), 1);
  };
}
var jt = Xa, $e = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Nl(t) {
  if (!(!t || !ct)) {
    var e = ae.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = t;
    for (var n = ae.head.childNodes, a = null, i = n.length - 1; i > -1; i--) {
      var r = n[i], o = (r.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (a = r);
    }
    return ae.head.insertBefore(e, a), t;
  }
}
var Dl = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function _n() {
  for (var t = 12, e = ""; t-- > 0; )
    e += Dl[Math.random() * 62 | 0];
  return e;
}
function nn(t) {
  for (var e = [], n = (t || []).length >>> 0; n--; )
    e[n] = t[n];
  return e;
}
function Ti(t) {
  return t.classList ? nn(t.classList) : (t.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function To(t) {
  return "".concat(t).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Hl(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e + "".concat(n, '="').concat(To(t[n]), '" ');
  }, "").trim();
}
function ka(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e + "".concat(n, ": ").concat(t[n].trim(), ";");
  }, "");
}
function Mi(t) {
  return t.size !== $e.size || t.x !== $e.x || t.y !== $e.y || t.rotate !== $e.rotate || t.flipX || t.flipY;
}
function Fl(t) {
  var e = t.transform, n = t.containerWidth, a = t.iconWidth, i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, r = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), o = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), s = "rotate(".concat(e.rotate, " 0 0)"), l = {
    transform: "".concat(r, " ").concat(o, " ").concat(s)
  }, c = {
    transform: "translate(".concat(a / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: c
  };
}
function Vl(t) {
  var e = t.transform, n = t.width, a = n === void 0 ? Xa : n, i = t.height, r = i === void 0 ? Xa : i, o = "";
  return wo ? o += "translate(".concat(e.x / jt - a / 2, "em, ").concat(e.y / jt - r / 2, "em) ") : o += "translate(calc(-50% + ".concat(e.x / jt, "em), calc(-50% + ").concat(e.y / jt, "em)) "), o += "scale(".concat(e.size / jt * (e.flipX ? -1 : 1), ", ").concat(e.size / jt * (e.flipY ? -1 : 1), ") "), o += "rotate(".concat(e.rotate, "deg) "), o;
}
var zl = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, 0));
          transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Mo() {
  var t = Co, e = yo, n = B.cssPrefix, a = B.replacementClass, i = zl;
  if (n !== t || a !== e) {
    var r = new RegExp("\\.".concat(t, "\\-"), "g"), o = new RegExp("\\--".concat(t, "\\-"), "g"), s = new RegExp("\\.".concat(e), "g");
    i = i.replace(r, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(s, ".".concat(a));
  }
  return i;
}
var sr = !1;
function Da() {
  B.autoAddCss && !sr && (Nl(Mo()), sr = !0);
}
var Ul = {
  mixout: function() {
    return {
      dom: {
        css: Mo,
        insertCss: Da
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Da();
      },
      beforeI2svg: function() {
        Da();
      }
    };
  }
}, rt = vt || {};
rt[it] || (rt[it] = {});
rt[it].styles || (rt[it].styles = {});
rt[it].hooks || (rt[it].hooks = {});
rt[it].shims || (rt[it].shims = []);
var ze = rt[it], Io = [], Ql = function t() {
  ae.removeEventListener("DOMContentLoaded", t), pa = 1, Io.map(function(e) {
    return e();
  });
}, pa = !1;
ct && (pa = (ae.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(ae.readyState), pa || ae.addEventListener("DOMContentLoaded", Ql));
function jl(t) {
  ct && (pa ? setTimeout(t, 0) : Io.push(t));
}
function Nn(t) {
  var e = t.tag, n = t.attributes, a = n === void 0 ? {} : n, i = t.children, r = i === void 0 ? [] : i;
  return typeof t == "string" ? To(t) : "<".concat(e, " ").concat(Hl(a), ">").concat(r.map(Nn).join(""), "</").concat(e, ">");
}
function lr(t, e, n) {
  if (t && t[e] && t[e][n])
    return {
      prefix: e,
      iconName: n,
      icon: t[e][n]
    };
}
var Ha = function(e, n, a, i) {
  var r = Object.keys(e), o = r.length, s = n, l, c, f;
  for (a === void 0 ? (l = 1, f = e[r[0]]) : (l = 0, f = a); l < o; l++)
    c = r[l], f = s(f, e[c], c, e);
  return f;
};
function Zl(t) {
  for (var e = [], n = 0, a = t.length; n < a; ) {
    var i = t.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < a) {
      var r = t.charCodeAt(n++);
      (r & 64512) == 56320 ? e.push(((i & 1023) << 10) + (r & 1023) + 65536) : (e.push(i), n--);
    } else
      e.push(i);
  }
  return e;
}
function ti(t) {
  var e = Zl(t);
  return e.length === 1 ? e[0].toString(16) : null;
}
function Gl(t, e) {
  var n = t.length, a = t.charCodeAt(e), i;
  return a >= 55296 && a <= 56319 && n > e + 1 && (i = t.charCodeAt(e + 1), i >= 56320 && i <= 57343) ? (a - 55296) * 1024 + i - 56320 + 65536 : a;
}
function cr(t) {
  return Object.keys(t).reduce(function(e, n) {
    var a = t[n], i = !!a.icon;
    return i ? e[a.iconName] = a.icon : e[n] = a, e;
  }, {});
}
function ni(t, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = n.skipHooks, i = a === void 0 ? !1 : a, r = cr(e);
  typeof ze.hooks.addPack == "function" && !i ? ze.hooks.addPack(t, cr(e)) : ze.styles[t] = O(O({}, ze.styles[t] || {}), r), t === "fas" && ni("fa", e);
}
var Wn, qn, Xn, Gt = ze.styles, Yl = ze.shims, Kl = (Wn = {}, me(Wn, te, Object.values(In[te])), me(Wn, se, Object.values(In[se])), Wn), Ii = null, Lo = {}, _o = {}, Oo = {}, Po = {}, Bo = {}, $l = (qn = {}, me(qn, te, Object.keys(Tn[te])), me(qn, se, Object.keys(Tn[se])), qn);
function Jl(t) {
  return ~_l.indexOf(t);
}
function Wl(t, e) {
  var n = e.split("-"), a = n[0], i = n.slice(1).join("-");
  return a === t && i !== "" && !Jl(i) ? i : null;
}
var Ro = function() {
  var e = function(r) {
    return Ha(Gt, function(o, s, l) {
      return o[l] = Ha(s, r, {}), o;
    }, {});
  };
  Lo = e(function(i, r, o) {
    if (r[3] && (i[r[3]] = o), r[2]) {
      var s = r[2].filter(function(l) {
        return typeof l == "number";
      });
      s.forEach(function(l) {
        i[l.toString(16)] = o;
      });
    }
    return i;
  }), _o = e(function(i, r, o) {
    if (i[o] = o, r[2]) {
      var s = r[2].filter(function(l) {
        return typeof l == "string";
      });
      s.forEach(function(l) {
        i[l] = o;
      });
    }
    return i;
  }), Bo = e(function(i, r, o) {
    var s = r[2];
    return i[o] = o, s.forEach(function(l) {
      i[l] = o;
    }), i;
  });
  var n = "far" in Gt || B.autoFetchSvg, a = Ha(Yl, function(i, r) {
    var o = r[0], s = r[1], l = r[2];
    return s === "far" && !n && (s = "fas"), typeof o == "string" && (i.names[o] = {
      prefix: s,
      iconName: l
    }), typeof o == "number" && (i.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: l
    }), i;
  }, {
    names: {},
    unicodes: {}
  });
  Oo = a.names, Po = a.unicodes, Ii = xa(B.styleDefault, {
    family: B.familyDefault
  });
};
Rl(function(t) {
  Ii = xa(t.styleDefault, {
    family: B.familyDefault
  });
});
Ro();
function Li(t, e) {
  return (Lo[t] || {})[e];
}
function ql(t, e) {
  return (_o[t] || {})[e];
}
function Ot(t, e) {
  return (Bo[t] || {})[e];
}
function No(t) {
  return Oo[t] || {
    prefix: null,
    iconName: null
  };
}
function Xl(t) {
  var e = Po[t], n = Li("fas", t);
  return e || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function At() {
  return Ii;
}
var _i = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function xa(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.family, a = n === void 0 ? te : n, i = Tn[a][t], r = Mn[a][t] || Mn[a][i], o = t in ze.styles ? t : null;
  return r || o || null;
}
var ur = (Xn = {}, me(Xn, te, Object.keys(In[te])), me(Xn, se, Object.keys(In[se])), Xn);
function Ea(t) {
  var e, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.skipLookups, i = a === void 0 ? !1 : a, r = (e = {}, me(e, te, "".concat(B.cssPrefix, "-").concat(te)), me(e, se, "".concat(B.cssPrefix, "-").concat(se)), e), o = null, s = te;
  (t.includes(r[te]) || t.some(function(c) {
    return ur[te].includes(c);
  })) && (s = te), (t.includes(r[se]) || t.some(function(c) {
    return ur[se].includes(c);
  })) && (s = se);
  var l = t.reduce(function(c, f) {
    var g = Wl(B.cssPrefix, f);
    if (Gt[f] ? (f = Kl[s].includes(f) ? El[s][f] : f, o = f, c.prefix = f) : $l[s].indexOf(f) > -1 ? (o = f, c.prefix = xa(f, {
      family: s
    })) : g ? c.iconName = g : f !== B.replacementClass && f !== r[te] && f !== r[se] && c.rest.push(f), !i && c.prefix && c.iconName) {
      var v = o === "fa" ? No(c.iconName) : {}, A = Ot(c.prefix, c.iconName);
      v.prefix && (o = null), c.iconName = v.iconName || A || c.iconName, c.prefix = v.prefix || c.prefix, c.prefix === "far" && !Gt.far && Gt.fas && !B.autoFetchSvg && (c.prefix = "fas");
    }
    return c;
  }, _i());
  return (t.includes("fa-brands") || t.includes("fab")) && (l.prefix = "fab"), (t.includes("fa-duotone") || t.includes("fad")) && (l.prefix = "fad"), !l.prefix && s === se && (Gt.fass || B.autoFetchSvg) && (l.prefix = "fass", l.iconName = Ot(l.prefix, l.iconName) || l.iconName), (l.prefix === "fa" || o === "fa") && (l.prefix = At() || "fas"), l;
}
var e1 = /* @__PURE__ */ function() {
  function t() {
    fl(this, t), this.definitions = {};
  }
  return pl(t, [{
    key: "add",
    value: function() {
      for (var n = this, a = arguments.length, i = new Array(a), r = 0; r < a; r++)
        i[r] = arguments[r];
      var o = i.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        n.definitions[s] = O(O({}, n.definitions[s] || {}), o[s]), ni(s, o[s]);
        var l = In[te][s];
        l && ni(l, o[s]), Ro();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, a) {
      var i = a.prefix && a.iconName && a.icon ? {
        0: a
      } : a;
      return Object.keys(i).map(function(r) {
        var o = i[r], s = o.prefix, l = o.iconName, c = o.icon, f = c[2];
        n[s] || (n[s] = {}), f.length > 0 && f.forEach(function(g) {
          typeof g == "string" && (n[s][g] = c);
        }), n[s][l] = c;
      }), n;
    }
  }]), t;
}(), dr = [], Yt = {}, Jt = {}, t1 = Object.keys(Jt);
function n1(t, e) {
  var n = e.mixoutsTo;
  return dr = t, Yt = {}, Object.keys(Jt).forEach(function(a) {
    t1.indexOf(a) === -1 && delete Jt[a];
  }), dr.forEach(function(a) {
    var i = a.mixout ? a.mixout() : {};
    if (Object.keys(i).forEach(function(o) {
      typeof i[o] == "function" && (n[o] = i[o]), ma(i[o]) === "object" && Object.keys(i[o]).forEach(function(s) {
        n[o] || (n[o] = {}), n[o][s] = i[o][s];
      });
    }), a.hooks) {
      var r = a.hooks();
      Object.keys(r).forEach(function(o) {
        Yt[o] || (Yt[o] = []), Yt[o].push(r[o]);
      });
    }
    a.provides && a.provides(Jt);
  }), n;
}
function ai(t, e) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  var r = Yt[t] || [];
  return r.forEach(function(o) {
    e = o.apply(null, [e].concat(a));
  }), e;
}
function Rt(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), a = 1; a < e; a++)
    n[a - 1] = arguments[a];
  var i = Yt[t] || [];
  i.forEach(function(r) {
    r.apply(null, n);
  });
}
function ot() {
  var t = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return Jt[t] ? Jt[t].apply(null, e) : void 0;
}
function ii(t) {
  t.prefix === "fa" && (t.prefix = "fas");
  var e = t.iconName, n = t.prefix || At();
  if (e)
    return e = Ot(n, e) || e, lr(Do.definitions, n, e) || lr(ze.styles, n, e);
}
var Do = new e1(), a1 = function() {
  B.autoReplaceSvg = !1, B.observeMutations = !1, Rt("noAuto");
}, i1 = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return ct ? (Rt("beforeI2svg", e), ot("pseudoElements2svg", e), ot("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot;
    B.autoReplaceSvg === !1 && (B.autoReplaceSvg = !0), B.observeMutations = !0, jl(function() {
      o1({
        autoReplaceSvgRoot: n
      }), Rt("watch", e);
    });
  }
}, r1 = {
  icon: function(e) {
    if (e === null)
      return null;
    if (ma(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: Ot(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var n = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], a = xa(e[0]);
      return {
        prefix: a,
        iconName: Ot(a, n) || n
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(B.cssPrefix, "-")) > -1 || e.match(Sl))) {
      var i = Ea(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: i.prefix || At(),
        iconName: Ot(i.prefix, i.iconName) || i.iconName
      };
    }
    if (typeof e == "string") {
      var r = At();
      return {
        prefix: r,
        iconName: Ot(r, e) || e
      };
    }
  }
}, Oe = {
  noAuto: a1,
  config: B,
  dom: i1,
  parse: r1,
  library: Do,
  findIconDefinition: ii,
  toHtml: Nn
}, o1 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot, a = n === void 0 ? ae : n;
  (Object.keys(ze.styles).length > 0 || B.autoFetchSvg) && ct && B.autoReplaceSvg && Oe.dom.i2svg({
    node: a
  });
};
function Sa(t, e) {
  return Object.defineProperty(t, "abstract", {
    get: e
  }), Object.defineProperty(t, "html", {
    get: function() {
      return t.abstract.map(function(a) {
        return Nn(a);
      });
    }
  }), Object.defineProperty(t, "node", {
    get: function() {
      if (ct) {
        var a = ae.createElement("div");
        return a.innerHTML = t.html, a.children;
      }
    }
  }), t;
}
function s1(t) {
  var e = t.children, n = t.main, a = t.mask, i = t.attributes, r = t.styles, o = t.transform;
  if (Mi(o) && n.found && !a.found) {
    var s = n.width, l = n.height, c = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = ka(O(O({}, r), {}, {
      "transform-origin": "".concat(c.x + o.x / 16, "em ").concat(c.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: e
  }];
}
function l1(t) {
  var e = t.prefix, n = t.iconName, a = t.children, i = t.attributes, r = t.symbol, o = r === !0 ? "".concat(e, "-").concat(B.cssPrefix, "-").concat(n) : r;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: O(O({}, i), {}, {
        id: o
      }),
      children: a
    }]
  }];
}
function Oi(t) {
  var e = t.icons, n = e.main, a = e.mask, i = t.prefix, r = t.iconName, o = t.transform, s = t.symbol, l = t.title, c = t.maskId, f = t.titleId, g = t.extra, v = t.watchable, A = v === void 0 ? !1 : v, y = a.found ? a : n, _ = y.width, C = y.height, b = i === "fak", S = [B.replacementClass, r ? "".concat(B.cssPrefix, "-").concat(r) : ""].filter(function(ce) {
    return g.classes.indexOf(ce) === -1;
  }).filter(function(ce) {
    return ce !== "" || !!ce;
  }).concat(g.classes).join(" "), F = {
    children: [],
    attributes: O(O({}, g.attributes), {}, {
      "data-prefix": i,
      "data-icon": r,
      class: S,
      role: g.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(_, " ").concat(C)
    })
  }, V = b && !~g.classes.indexOf("fa-fw") ? {
    width: "".concat(_ / C * 16 * 0.0625, "em")
  } : {};
  A && (F.attributes[Bt] = ""), l && (F.children.push({
    tag: "title",
    attributes: {
      id: F.attributes["aria-labelledby"] || "title-".concat(f || _n())
    },
    children: [l]
  }), delete F.attributes.title);
  var j = O(O({}, F), {}, {
    prefix: i,
    iconName: r,
    main: n,
    mask: a,
    maskId: c,
    transform: o,
    symbol: s,
    styles: O(O({}, V), g.styles)
  }), q = a.found && n.found ? ot("generateAbstractMask", j) || {
    children: [],
    attributes: {}
  } : ot("generateAbstractIcon", j) || {
    children: [],
    attributes: {}
  }, X = q.children, we = q.attributes;
  return j.children = X, j.attributes = we, s ? l1(j) : s1(j);
}
function fr(t) {
  var e = t.content, n = t.width, a = t.height, i = t.transform, r = t.title, o = t.extra, s = t.watchable, l = s === void 0 ? !1 : s, c = O(O(O({}, o.attributes), r ? {
    title: r
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  l && (c[Bt] = "");
  var f = O({}, o.styles);
  Mi(i) && (f.transform = Vl({
    transform: i,
    width: n,
    height: a
  }), f["-webkit-transform"] = f.transform);
  var g = ka(f);
  g.length > 0 && (c.style = g);
  var v = [];
  return v.push({
    tag: "span",
    attributes: c,
    children: [e]
  }), r && v.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [r]
  }), v;
}
function c1(t) {
  var e = t.content, n = t.title, a = t.extra, i = O(O(O({}, a.attributes), n ? {
    title: n
  } : {}), {}, {
    class: a.classes.join(" ")
  }), r = ka(a.styles);
  r.length > 0 && (i.style = r);
  var o = [];
  return o.push({
    tag: "span",
    attributes: i,
    children: [e]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
var Fa = ze.styles;
function ri(t) {
  var e = t[0], n = t[1], a = t.slice(4), i = yi(a, 1), r = i[0], o = null;
  return Array.isArray(r) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(B.cssPrefix, "-").concat(_t.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(B.cssPrefix, "-").concat(_t.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(B.cssPrefix, "-").concat(_t.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: e,
    height: n,
    icon: o
  };
}
var u1 = {
  found: !1,
  width: 512,
  height: 512
};
function d1(t, e) {
  !ko && !B.showMissingIcons && t && console.error('Icon with name "'.concat(t, '" and prefix "').concat(e, '" is missing.'));
}
function oi(t, e) {
  var n = e;
  return e === "fa" && B.styleDefault !== null && (e = At()), new Promise(function(a, i) {
    if (ot("missingIconAbstract"), n === "fa") {
      var r = No(t) || {};
      t = r.iconName || t, e = r.prefix || e;
    }
    if (t && e && Fa[e] && Fa[e][t]) {
      var o = Fa[e][t];
      return a(ri(o));
    }
    d1(t, e), a(O(O({}, u1), {}, {
      icon: B.showMissingIcons && t ? ot("missingIconAbstract") || {} : {}
    }));
  });
}
var mr = function() {
}, si = B.measurePerformance && Zn && Zn.mark && Zn.measure ? Zn : {
  mark: mr,
  measure: mr
}, bn = 'FA "6.5.2"', f1 = function(e) {
  return si.mark("".concat(bn, " ").concat(e, " begins")), function() {
    return Ho(e);
  };
}, Ho = function(e) {
  si.mark("".concat(bn, " ").concat(e, " ends")), si.measure("".concat(bn, " ").concat(e), "".concat(bn, " ").concat(e, " begins"), "".concat(bn, " ").concat(e, " ends"));
}, Pi = {
  begin: f1,
  end: Ho
}, sa = function() {
};
function pr(t) {
  var e = t.getAttribute ? t.getAttribute(Bt) : null;
  return typeof e == "string";
}
function m1(t) {
  var e = t.getAttribute ? t.getAttribute(xi) : null, n = t.getAttribute ? t.getAttribute(Ei) : null;
  return e && n;
}
function p1(t) {
  return t && t.classList && t.classList.contains && t.classList.contains(B.replacementClass);
}
function g1() {
  if (B.autoReplaceSvg === !0)
    return la.replace;
  var t = la[B.autoReplaceSvg];
  return t || la.replace;
}
function h1(t) {
  return ae.createElementNS("http://www.w3.org/2000/svg", t);
}
function v1(t) {
  return ae.createElement(t);
}
function Fo(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.ceFn, a = n === void 0 ? t.tag === "svg" ? h1 : v1 : n;
  if (typeof t == "string")
    return ae.createTextNode(t);
  var i = a(t.tag);
  Object.keys(t.attributes || []).forEach(function(o) {
    i.setAttribute(o, t.attributes[o]);
  });
  var r = t.children || [];
  return r.forEach(function(o) {
    i.appendChild(Fo(o, {
      ceFn: a
    }));
  }), i;
}
function A1(t) {
  var e = " ".concat(t.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var la = {
  replace: function(e) {
    var n = e[0];
    if (n.parentNode)
      if (e[1].forEach(function(i) {
        n.parentNode.insertBefore(Fo(i), n);
      }), n.getAttribute(Bt) === null && B.keepOriginalSource) {
        var a = ae.createComment(A1(n));
        n.parentNode.replaceChild(a, n);
      } else
        n.remove();
  },
  nest: function(e) {
    var n = e[0], a = e[1];
    if (~Ti(n).indexOf(B.replacementClass))
      return la.replace(e);
    var i = new RegExp("".concat(B.cssPrefix, "-.*"));
    if (delete a[0].attributes.id, a[0].attributes.class) {
      var r = a[0].attributes.class.split(" ").reduce(function(s, l) {
        return l === B.replacementClass || l.match(i) ? s.toSvg.push(l) : s.toNode.push(l), s;
      }, {
        toNode: [],
        toSvg: []
      });
      a[0].attributes.class = r.toSvg.join(" "), r.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", r.toNode.join(" "));
    }
    var o = a.map(function(s) {
      return Nn(s);
    }).join(`
`);
    n.setAttribute(Bt, ""), n.innerHTML = o;
  }
};
function gr(t) {
  t();
}
function Vo(t, e) {
  var n = typeof e == "function" ? e : sa;
  if (t.length === 0)
    n();
  else {
    var a = gr;
    B.mutateApproach === kl && (a = vt.requestAnimationFrame || gr), a(function() {
      var i = g1(), r = Pi.begin("mutate");
      t.map(i), r(), n();
    });
  }
}
var Bi = !1;
function zo() {
  Bi = !0;
}
function li() {
  Bi = !1;
}
var ga = null;
function hr(t) {
  if (rr && B.observeMutations) {
    var e = t.treeCallback, n = e === void 0 ? sa : e, a = t.nodeCallback, i = a === void 0 ? sa : a, r = t.pseudoElementsCallback, o = r === void 0 ? sa : r, s = t.observeMutationsRoot, l = s === void 0 ? ae : s;
    ga = new rr(function(c) {
      if (!Bi) {
        var f = At();
        nn(c).forEach(function(g) {
          if (g.type === "childList" && g.addedNodes.length > 0 && !pr(g.addedNodes[0]) && (B.searchPseudoElements && o(g.target), n(g.target)), g.type === "attributes" && g.target.parentNode && B.searchPseudoElements && o(g.target.parentNode), g.type === "attributes" && pr(g.target) && ~Ll.indexOf(g.attributeName))
            if (g.attributeName === "class" && m1(g.target)) {
              var v = Ea(Ti(g.target)), A = v.prefix, y = v.iconName;
              g.target.setAttribute(xi, A || f), y && g.target.setAttribute(Ei, y);
            } else p1(g.target) && i(g.target);
        });
      }
    }), ct && ga.observe(l, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function b1() {
  ga && ga.disconnect();
}
function w1(t) {
  var e = t.getAttribute("style"), n = [];
  return e && (n = e.split(";").reduce(function(a, i) {
    var r = i.split(":"), o = r[0], s = r.slice(1);
    return o && s.length > 0 && (a[o] = s.join(":").trim()), a;
  }, {})), n;
}
function C1(t) {
  var e = t.getAttribute("data-prefix"), n = t.getAttribute("data-icon"), a = t.innerText !== void 0 ? t.innerText.trim() : "", i = Ea(Ti(t));
  return i.prefix || (i.prefix = At()), e && n && (i.prefix = e, i.iconName = n), i.iconName && i.prefix || (i.prefix && a.length > 0 && (i.iconName = ql(i.prefix, t.innerText) || Li(i.prefix, ti(t.innerText))), !i.iconName && B.autoFetchSvg && t.firstChild && t.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = t.firstChild.data)), i;
}
function y1(t) {
  var e = nn(t.attributes).reduce(function(i, r) {
    return i.name !== "class" && i.name !== "style" && (i[r.name] = r.value), i;
  }, {}), n = t.getAttribute("title"), a = t.getAttribute("data-fa-title-id");
  return B.autoA11y && (n ? e["aria-labelledby"] = "".concat(B.replacementClass, "-title-").concat(a || _n()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function k1() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: $e,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function vr(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = C1(t), a = n.iconName, i = n.prefix, r = n.rest, o = y1(t), s = ai("parseNodeAttributes", {}, t), l = e.styleParser ? w1(t) : [];
  return O({
    iconName: a,
    title: t.getAttribute("title"),
    titleId: t.getAttribute("data-fa-title-id"),
    prefix: i,
    transform: $e,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: r,
      styles: l,
      attributes: o
    }
  }, s);
}
var x1 = ze.styles;
function Uo(t) {
  var e = B.autoReplaceSvg === "nest" ? vr(t, {
    styleParser: !1
  }) : vr(t);
  return ~e.extra.classes.indexOf(xo) ? ot("generateLayersText", t, e) : ot("generateSvgReplacementMutation", t, e);
}
var bt = /* @__PURE__ */ new Set();
Si.map(function(t) {
  bt.add("fa-".concat(t));
});
Object.keys(Tn[te]).map(bt.add.bind(bt));
Object.keys(Tn[se]).map(bt.add.bind(bt));
bt = Bn(bt);
function Ar(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!ct) return Promise.resolve();
  var n = ae.documentElement.classList, a = function(g) {
    return n.add("".concat(or, "-").concat(g));
  }, i = function(g) {
    return n.remove("".concat(or, "-").concat(g));
  }, r = B.autoFetchSvg ? bt : Si.map(function(f) {
    return "fa-".concat(f);
  }).concat(Object.keys(x1));
  r.includes("fa") || r.push("fa");
  var o = [".".concat(xo, ":not([").concat(Bt, "])")].concat(r.map(function(f) {
    return ".".concat(f, ":not([").concat(Bt, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = nn(t.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    a("pending"), i("complete");
  else
    return Promise.resolve();
  var l = Pi.begin("onTree"), c = s.reduce(function(f, g) {
    try {
      var v = Uo(g);
      v && f.push(v);
    } catch (A) {
      ko || A.name === "MissingIcon" && console.error(A);
    }
    return f;
  }, []);
  return new Promise(function(f, g) {
    Promise.all(c).then(function(v) {
      Vo(v, function() {
        a("active"), a("complete"), i("pending"), typeof e == "function" && e(), l(), f();
      });
    }).catch(function(v) {
      l(), g(v);
    });
  });
}
function E1(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  Uo(t).then(function(n) {
    n && Vo([n], e);
  });
}
function S1(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = (e || {}).icon ? e : ii(e || {}), i = n.mask;
    return i && (i = (i || {}).icon ? i : ii(i || {})), t(a, O(O({}, n), {}, {
      mask: i
    }));
  };
}
var T1 = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.transform, i = a === void 0 ? $e : a, r = n.symbol, o = r === void 0 ? !1 : r, s = n.mask, l = s === void 0 ? null : s, c = n.maskId, f = c === void 0 ? null : c, g = n.title, v = g === void 0 ? null : g, A = n.titleId, y = A === void 0 ? null : A, _ = n.classes, C = _ === void 0 ? [] : _, b = n.attributes, S = b === void 0 ? {} : b, F = n.styles, V = F === void 0 ? {} : F;
  if (e) {
    var j = e.prefix, q = e.iconName, X = e.icon;
    return Sa(O({
      type: "icon"
    }, e), function() {
      return Rt("beforeDOMElementCreation", {
        iconDefinition: e,
        params: n
      }), B.autoA11y && (v ? S["aria-labelledby"] = "".concat(B.replacementClass, "-title-").concat(y || _n()) : (S["aria-hidden"] = "true", S.focusable = "false")), Oi({
        icons: {
          main: ri(X),
          mask: l ? ri(l.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: j,
        iconName: q,
        transform: O(O({}, $e), i),
        symbol: o,
        title: v,
        maskId: f,
        titleId: y,
        extra: {
          attributes: S,
          styles: V,
          classes: C
        }
      });
    });
  }
}, M1 = {
  mixout: function() {
    return {
      icon: S1(T1)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = Ar, n.nodeCallback = E1, n;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(n) {
      var a = n.node, i = a === void 0 ? ae : a, r = n.callback, o = r === void 0 ? function() {
      } : r;
      return Ar(i, o);
    }, e.generateSvgReplacementMutation = function(n, a) {
      var i = a.iconName, r = a.title, o = a.titleId, s = a.prefix, l = a.transform, c = a.symbol, f = a.mask, g = a.maskId, v = a.extra;
      return new Promise(function(A, y) {
        Promise.all([oi(i, s), f.iconName ? oi(f.iconName, f.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(_) {
          var C = yi(_, 2), b = C[0], S = C[1];
          A([n, Oi({
            icons: {
              main: b,
              mask: S
            },
            prefix: s,
            iconName: i,
            transform: l,
            symbol: c,
            maskId: g,
            title: r,
            titleId: o,
            extra: v,
            watchable: !0
          })]);
        }).catch(y);
      });
    }, e.generateAbstractIcon = function(n) {
      var a = n.children, i = n.attributes, r = n.main, o = n.transform, s = n.styles, l = ka(s);
      l.length > 0 && (i.style = l);
      var c;
      return Mi(o) && (c = ot("generateAbstractTransformGrouping", {
        main: r,
        transform: o,
        containerWidth: r.width,
        iconWidth: r.width
      })), a.push(c || r.icon), {
        children: a,
        attributes: i
      };
    };
  }
}, I1 = {
  mixout: function() {
    return {
      layer: function(n) {
        var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.classes, r = i === void 0 ? [] : i;
        return Sa({
          type: "layer"
        }, function() {
          Rt("beforeDOMElementCreation", {
            assembler: n,
            params: a
          });
          var o = [];
          return n(function(s) {
            Array.isArray(s) ? s.map(function(l) {
              o = o.concat(l.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(B.cssPrefix, "-layers")].concat(Bn(r)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, L1 = {
  mixout: function() {
    return {
      counter: function(n) {
        var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.title, r = i === void 0 ? null : i, o = a.classes, s = o === void 0 ? [] : o, l = a.attributes, c = l === void 0 ? {} : l, f = a.styles, g = f === void 0 ? {} : f;
        return Sa({
          type: "counter",
          content: n
        }, function() {
          return Rt("beforeDOMElementCreation", {
            content: n,
            params: a
          }), c1({
            content: n.toString(),
            title: r,
            extra: {
              attributes: c,
              styles: g,
              classes: ["".concat(B.cssPrefix, "-layers-counter")].concat(Bn(s))
            }
          });
        });
      }
    };
  }
}, _1 = {
  mixout: function() {
    return {
      text: function(n) {
        var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = a.transform, r = i === void 0 ? $e : i, o = a.title, s = o === void 0 ? null : o, l = a.classes, c = l === void 0 ? [] : l, f = a.attributes, g = f === void 0 ? {} : f, v = a.styles, A = v === void 0 ? {} : v;
        return Sa({
          type: "text",
          content: n
        }, function() {
          return Rt("beforeDOMElementCreation", {
            content: n,
            params: a
          }), fr({
            content: n,
            transform: O(O({}, $e), r),
            title: s,
            extra: {
              attributes: g,
              styles: A,
              classes: ["".concat(B.cssPrefix, "-layers-text")].concat(Bn(c))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(n, a) {
      var i = a.title, r = a.transform, o = a.extra, s = null, l = null;
      if (wo) {
        var c = parseInt(getComputedStyle(n).fontSize, 10), f = n.getBoundingClientRect();
        s = f.width / c, l = f.height / c;
      }
      return B.autoA11y && !i && (o.attributes["aria-hidden"] = "true"), Promise.resolve([n, fr({
        content: n.innerHTML,
        width: s,
        height: l,
        transform: r,
        title: i,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, O1 = new RegExp('"', "ug"), br = [1105920, 1112319];
function P1(t) {
  var e = t.replace(O1, ""), n = Gl(e, 0), a = n >= br[0] && n <= br[1], i = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: ti(i ? e[0] : e),
    isSecondary: a || i
  };
}
function wr(t, e) {
  var n = "".concat(yl).concat(e.replace(":", "-"));
  return new Promise(function(a, i) {
    if (t.getAttribute(n) !== null)
      return a();
    var r = nn(t.children), o = r.filter(function(X) {
      return X.getAttribute(ei) === e;
    })[0], s = vt.getComputedStyle(t, e), l = s.getPropertyValue("font-family").match(Tl), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (o && !l)
      return t.removeChild(o), a();
    if (l && f !== "none" && f !== "") {
      var g = s.getPropertyValue("content"), v = ~["Sharp"].indexOf(l[2]) ? se : te, A = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(l[2]) ? Mn[v][l[2].toLowerCase()] : Ml[v][c], y = P1(g), _ = y.value, C = y.isSecondary, b = l[0].startsWith("FontAwesome"), S = Li(A, _), F = S;
      if (b) {
        var V = Xl(_);
        V.iconName && V.prefix && (S = V.iconName, A = V.prefix);
      }
      if (S && !C && (!o || o.getAttribute(xi) !== A || o.getAttribute(Ei) !== F)) {
        t.setAttribute(n, F), o && t.removeChild(o);
        var j = k1(), q = j.extra;
        q.attributes[ei] = e, oi(S, A).then(function(X) {
          var we = Oi(O(O({}, j), {}, {
            icons: {
              main: X,
              mask: _i()
            },
            prefix: A,
            iconName: F,
            extra: q,
            watchable: !0
          })), ce = ae.createElementNS("http://www.w3.org/2000/svg", "svg");
          e === "::before" ? t.insertBefore(ce, t.firstChild) : t.appendChild(ce), ce.outerHTML = we.map(function(Pe) {
            return Nn(Pe);
          }).join(`
`), t.removeAttribute(n), a();
        }).catch(i);
      } else
        a();
    } else
      a();
  });
}
function B1(t) {
  return Promise.all([wr(t, "::before"), wr(t, "::after")]);
}
function R1(t) {
  return t.parentNode !== document.head && !~xl.indexOf(t.tagName.toUpperCase()) && !t.getAttribute(ei) && (!t.parentNode || t.parentNode.tagName !== "svg");
}
function Cr(t) {
  if (ct)
    return new Promise(function(e, n) {
      var a = nn(t.querySelectorAll("*")).filter(R1).map(B1), i = Pi.begin("searchPseudoElements");
      zo(), Promise.all(a).then(function() {
        i(), li(), e();
      }).catch(function() {
        i(), li(), n();
      });
    });
}
var N1 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = Cr, n;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(n) {
      var a = n.node, i = a === void 0 ? ae : a;
      B.searchPseudoElements && Cr(i);
    };
  }
}, yr = !1, D1 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          zo(), yr = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        hr(ai("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        b1();
      },
      watch: function(n) {
        var a = n.observeMutationsRoot;
        yr ? li() : hr(ai("mutationObserverCallbacks", {
          observeMutationsRoot: a
        }));
      }
    };
  }
}, kr = function(e) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(a, i) {
    var r = i.toLowerCase().split("-"), o = r[0], s = r.slice(1).join("-");
    if (o && s === "h")
      return a.flipX = !0, a;
    if (o && s === "v")
      return a.flipY = !0, a;
    if (s = parseFloat(s), isNaN(s))
      return a;
    switch (o) {
      case "grow":
        a.size = a.size + s;
        break;
      case "shrink":
        a.size = a.size - s;
        break;
      case "left":
        a.x = a.x - s;
        break;
      case "right":
        a.x = a.x + s;
        break;
      case "up":
        a.y = a.y - s;
        break;
      case "down":
        a.y = a.y + s;
        break;
      case "rotate":
        a.rotate = a.rotate + s;
        break;
    }
    return a;
  }, n);
}, H1 = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return kr(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, a) {
        var i = a.getAttribute("data-fa-transform");
        return i && (n.transform = kr(i)), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(n) {
      var a = n.main, i = n.transform, r = n.containerWidth, o = n.iconWidth, s = {
        transform: "translate(".concat(r / 2, " 256)")
      }, l = "translate(".concat(i.x * 32, ", ").concat(i.y * 32, ") "), c = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), f = "rotate(".concat(i.rotate, " 0 0)"), g = {
        transform: "".concat(l, " ").concat(c, " ").concat(f)
      }, v = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, A = {
        outer: s,
        inner: g,
        path: v
      };
      return {
        tag: "g",
        attributes: O({}, A.outer),
        children: [{
          tag: "g",
          attributes: O({}, A.inner),
          children: [{
            tag: a.icon.tag,
            children: a.icon.children,
            attributes: O(O({}, a.icon.attributes), A.path)
          }]
        }]
      };
    };
  }
}, Va = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function xr(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return t.attributes && (t.attributes.fill || e) && (t.attributes.fill = "black"), t;
}
function F1(t) {
  return t.tag === "g" ? t.children : [t];
}
var V1 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, a) {
        var i = a.getAttribute("data-fa-mask"), r = i ? Ea(i.split(" ").map(function(o) {
          return o.trim();
        })) : _i();
        return r.prefix || (r.prefix = At()), n.mask = r, n.maskId = a.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(n) {
      var a = n.children, i = n.attributes, r = n.main, o = n.mask, s = n.maskId, l = n.transform, c = r.width, f = r.icon, g = o.width, v = o.icon, A = Fl({
        transform: l,
        containerWidth: g,
        iconWidth: c
      }), y = {
        tag: "rect",
        attributes: O(O({}, Va), {}, {
          fill: "white"
        })
      }, _ = f.children ? {
        children: f.children.map(xr)
      } : {}, C = {
        tag: "g",
        attributes: O({}, A.inner),
        children: [xr(O({
          tag: f.tag,
          attributes: O(O({}, f.attributes), A.path)
        }, _))]
      }, b = {
        tag: "g",
        attributes: O({}, A.outer),
        children: [C]
      }, S = "mask-".concat(s || _n()), F = "clip-".concat(s || _n()), V = {
        tag: "mask",
        attributes: O(O({}, Va), {}, {
          id: S,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [y, b]
      }, j = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: F
          },
          children: F1(v)
        }, V]
      };
      return a.push(j, {
        tag: "rect",
        attributes: O({
          fill: "currentColor",
          "clip-path": "url(#".concat(F, ")"),
          mask: "url(#".concat(S, ")")
        }, Va)
      }), {
        children: a,
        attributes: i
      };
    };
  }
}, z1 = {
  provides: function(e) {
    var n = !1;
    vt.matchMedia && (n = vt.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var a = [], i = {
        fill: "currentColor"
      }, r = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      a.push({
        tag: "path",
        attributes: O(O({}, i), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = O(O({}, r), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: O(O({}, i), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || s.children.push({
        tag: "animate",
        attributes: O(O({}, r), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: O(O({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), a.push(s), a.push({
        tag: "path",
        attributes: O(O({}, i), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: O(O({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || a.push({
        tag: "path",
        attributes: O(O({}, i), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: O(O({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: a
      };
    };
  }
}, U1 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, a) {
        var i = a.getAttribute("data-fa-symbol"), r = i === null ? !1 : i === "" ? !0 : i;
        return n.symbol = r, n;
      }
    };
  }
}, Q1 = [Ul, M1, I1, L1, _1, N1, D1, H1, V1, z1, U1];
n1(Q1, {
  mixoutsTo: Oe
});
Oe.noAuto;
var Qo = Oe.config;
Oe.library;
Oe.dom;
var ha = Oe.parse;
Oe.findIconDefinition;
Oe.toHtml;
var j1 = Oe.icon;
Oe.layer;
var Z1 = Oe.text;
Oe.counter;
function Er(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    e && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Ve(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Er(Object(n), !0).forEach(function(a) {
      Me(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Er(Object(n)).forEach(function(a) {
      Object.defineProperty(t, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return t;
}
function va(t) {
  "@babel/helpers - typeof";
  return va = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, va(t);
}
function Me(t, e, n) {
  return e = X1(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function G1(t, e) {
  if (t == null) return {};
  var n = {}, a = Object.keys(t), i, r;
  for (r = 0; r < a.length; r++)
    i = a[r], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Y1(t, e) {
  if (t == null) return {};
  var n = G1(t, e), a, i;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    for (i = 0; i < r.length; i++)
      a = r[i], !(e.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(t, a) && (n[a] = t[a]);
  }
  return n;
}
function ci(t) {
  return K1(t) || $1(t) || J1(t) || W1();
}
function K1(t) {
  if (Array.isArray(t)) return ui(t);
}
function $1(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function J1(t, e) {
  if (t) {
    if (typeof t == "string") return ui(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ui(t, e);
  }
}
function ui(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, a = new Array(e); n < e; n++) a[n] = t[n];
  return a;
}
function W1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function q1(t, e) {
  if (typeof t != "object" || t === null) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var a = n.call(t, e);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function X1(t) {
  var e = q1(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var ec = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, jo = { exports: {} };
(function(t) {
  (function(e) {
    var n = function(b, S, F) {
      if (!c(S) || g(S) || v(S) || A(S) || l(S))
        return S;
      var V, j = 0, q = 0;
      if (f(S))
        for (V = [], q = S.length; j < q; j++)
          V.push(n(b, S[j], F));
      else {
        V = {};
        for (var X in S)
          Object.prototype.hasOwnProperty.call(S, X) && (V[b(X, F)] = n(b, S[X], F));
      }
      return V;
    }, a = function(b, S) {
      S = S || {};
      var F = S.separator || "_", V = S.split || /(?=[A-Z])/;
      return b.split(V).join(F);
    }, i = function(b) {
      return y(b) ? b : (b = b.replace(/[\-_\s]+(.)?/g, function(S, F) {
        return F ? F.toUpperCase() : "";
      }), b.substr(0, 1).toLowerCase() + b.substr(1));
    }, r = function(b) {
      var S = i(b);
      return S.substr(0, 1).toUpperCase() + S.substr(1);
    }, o = function(b, S) {
      return a(b, S).toLowerCase();
    }, s = Object.prototype.toString, l = function(b) {
      return typeof b == "function";
    }, c = function(b) {
      return b === Object(b);
    }, f = function(b) {
      return s.call(b) == "[object Array]";
    }, g = function(b) {
      return s.call(b) == "[object Date]";
    }, v = function(b) {
      return s.call(b) == "[object RegExp]";
    }, A = function(b) {
      return s.call(b) == "[object Boolean]";
    }, y = function(b) {
      return b = b - 0, b === b;
    }, _ = function(b, S) {
      var F = S && "process" in S ? S.process : S;
      return typeof F != "function" ? b : function(V, j) {
        return F(V, b, j);
      };
    }, C = {
      camelize: i,
      decamelize: o,
      pascalize: r,
      depascalize: o,
      camelizeKeys: function(b, S) {
        return n(_(i, S), b);
      },
      decamelizeKeys: function(b, S) {
        return n(_(o, S), b, S);
      },
      pascalizeKeys: function(b, S) {
        return n(_(r, S), b);
      },
      depascalizeKeys: function() {
        return this.decamelizeKeys.apply(this, arguments);
      }
    };
    t.exports ? t.exports = C : e.humps = C;
  })(ec);
})(jo);
var tc = jo.exports, nc = ["class", "style"];
function ac(t) {
  return t.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, n) {
    var a = n.indexOf(":"), i = tc.camelize(n.slice(0, a)), r = n.slice(a + 1).trim();
    return e[i] = r, e;
  }, {});
}
function ic(t) {
  return t.split(/\s+/).reduce(function(e, n) {
    return e[n] = !0, e;
  }, {});
}
function Ri(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var a = (t.children || []).map(function(l) {
    return Ri(l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, c) {
    var f = t.attributes[c];
    switch (c) {
      case "class":
        l.class = ic(f);
        break;
      case "style":
        l.style = ac(f);
        break;
      default:
        l.attrs[c] = f;
    }
    return l;
  }, {
    attrs: {},
    class: {},
    style: {}
  });
  n.class;
  var r = n.style, o = r === void 0 ? {} : r, s = Y1(n, nc);
  return fe(t.tag, Ve(Ve(Ve({}, e), {}, {
    class: i.class,
    style: Ve(Ve({}, i.style), o)
  }, i.attrs), s), a);
}
var Zo = !1;
try {
  Zo = process.env.NODE_ENV === "production";
} catch {
}
function rc() {
  if (!Zo && console && typeof console.error == "function") {
    var t;
    (t = console).error.apply(t, arguments);
  }
}
function En(t, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? Me({}, t, e) : {};
}
function oc(t) {
  var e, n = (e = {
    "fa-spin": t.spin,
    "fa-pulse": t.pulse,
    "fa-fw": t.fixedWidth,
    "fa-border": t.border,
    "fa-li": t.listItem,
    "fa-inverse": t.inverse,
    "fa-flip": t.flip === !0,
    "fa-flip-horizontal": t.flip === "horizontal" || t.flip === "both",
    "fa-flip-vertical": t.flip === "vertical" || t.flip === "both"
  }, Me(e, "fa-".concat(t.size), t.size !== null), Me(e, "fa-rotate-".concat(t.rotation), t.rotation !== null), Me(e, "fa-pull-".concat(t.pull), t.pull !== null), Me(e, "fa-swap-opacity", t.swapOpacity), Me(e, "fa-bounce", t.bounce), Me(e, "fa-shake", t.shake), Me(e, "fa-beat", t.beat), Me(e, "fa-fade", t.fade), Me(e, "fa-beat-fade", t.beatFade), Me(e, "fa-flash", t.flash), Me(e, "fa-spin-pulse", t.spinPulse), Me(e, "fa-spin-reverse", t.spinReverse), e);
  return Object.keys(n).map(function(a) {
    return n[a] ? a : null;
  }).filter(function(a) {
    return a;
  });
}
function Sr(t) {
  if (t && va(t) === "object" && t.prefix && t.iconName && t.icon)
    return t;
  if (ha.icon)
    return ha.icon(t);
  if (t === null)
    return null;
  if (va(t) === "object" && t.prefix && t.iconName)
    return t;
  if (Array.isArray(t) && t.length === 2)
    return {
      prefix: t[0],
      iconName: t[1]
    };
  if (typeof t == "string")
    return {
      prefix: "fas",
      iconName: t
    };
}
var Q = x({
  name: "FontAwesomeIcon",
  props: {
    border: {
      type: Boolean,
      default: !1
    },
    fixedWidth: {
      type: Boolean,
      default: !1
    },
    flip: {
      type: [Boolean, String],
      default: !1,
      validator: function(e) {
        return [!0, !1, "horizontal", "vertical", "both"].indexOf(e) > -1;
      }
    },
    icon: {
      type: [Object, Array, String],
      required: !0
    },
    mask: {
      type: [Object, Array, String],
      default: null
    },
    maskId: {
      type: String,
      default: null
    },
    listItem: {
      type: Boolean,
      default: !1
    },
    pull: {
      type: String,
      default: null,
      validator: function(e) {
        return ["right", "left"].indexOf(e) > -1;
      }
    },
    pulse: {
      type: Boolean,
      default: !1
    },
    rotation: {
      type: [String, Number],
      default: null,
      validator: function(e) {
        return [90, 180, 270].indexOf(Number.parseInt(e, 10)) > -1;
      }
    },
    swapOpacity: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null,
      validator: function(e) {
        return ["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(e) > -1;
      }
    },
    spin: {
      type: Boolean,
      default: !1
    },
    transform: {
      type: [String, Object],
      default: null
    },
    symbol: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: String,
      default: null
    },
    titleId: {
      type: String,
      default: null
    },
    inverse: {
      type: Boolean,
      default: !1
    },
    bounce: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    beat: {
      type: Boolean,
      default: !1
    },
    fade: {
      type: Boolean,
      default: !1
    },
    beatFade: {
      type: Boolean,
      default: !1
    },
    flash: {
      type: Boolean,
      default: !1
    },
    spinPulse: {
      type: Boolean,
      default: !1
    },
    spinReverse: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, n) {
    var a = n.attrs, i = w(function() {
      return Sr(e.icon);
    }), r = w(function() {
      return En("classes", oc(e));
    }), o = w(function() {
      return En("transform", typeof e.transform == "string" ? ha.transform(e.transform) : e.transform);
    }), s = w(function() {
      return En("mask", Sr(e.mask));
    }), l = w(function() {
      return j1(i.value, Ve(Ve(Ve(Ve({}, r.value), o.value), s.value), {}, {
        symbol: e.symbol,
        title: e.title,
        titleId: e.titleId,
        maskId: e.maskId
      }));
    });
    be(l, function(f) {
      if (!f)
        return rc("Could not find one or more icon(s)", i.value, s.value);
    }, {
      immediate: !0
    });
    var c = w(function() {
      return l.value ? Ri(l.value.abstract[0], {}, a) : null;
    });
    return function() {
      return c.value;
    };
  }
});
x({
  name: "FontAwesomeLayers",
  props: {
    fixedWidth: {
      type: Boolean,
      default: !1
    }
  },
  setup: function(e, n) {
    var a = n.slots, i = Qo.familyPrefix, r = w(function() {
      return ["".concat(i, "-layers")].concat(ci(e.fixedWidth ? ["".concat(i, "-fw")] : []));
    });
    return function() {
      return fe("div", {
        class: r.value
      }, a.default ? a.default() : []);
    };
  }
});
x({
  name: "FontAwesomeLayersText",
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    transform: {
      type: [String, Object],
      default: null
    },
    counter: {
      type: Boolean,
      default: !1
    },
    position: {
      type: String,
      default: null,
      validator: function(e) {
        return ["bottom-left", "bottom-right", "top-left", "top-right"].indexOf(e) > -1;
      }
    }
  },
  setup: function(e, n) {
    var a = n.attrs, i = Qo.familyPrefix, r = w(function() {
      return En("classes", [].concat(ci(e.counter ? ["".concat(i, "-layers-counter")] : []), ci(e.position ? ["".concat(i, "-layers-").concat(e.position)] : [])));
    }), o = w(function() {
      return En("transform", typeof e.transform == "string" ? ha.transform(e.transform) : e.transform);
    }), s = w(function() {
      var c = Z1(e.value.toString(), Ve(Ve({}, o.value), r.value)), f = c.abstract;
      return e.counter && (f[0].attributes.class = f[0].attributes.class.replace("fa-layers-text", "")), f[0];
    }), l = w(function() {
      return Ri(s.value, {}, a);
    });
    return function() {
      return l.value;
    };
  }
});
const sc = {}, lc = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 371.34 70.81"
};
function cc(t, e) {
  return u(), m("svg", lc, e[0] || (e[0] = [
    Ie('<path fill="#e95a0c" d="M103.12,48.56h-17.71l-3.52,9.66h-5.14l15.02-39.66h4.86l15.14,39.66h-5.14l-3.52-9.66Zm-1.56-4.25l-7.26-19.83h-.11l-7.21,19.83h14.58Z"></path><path fill="#e95a0c" d="M149.93,18.56V58.22h-4.97l-22.23-31.28h-.11v31.28h-4.86V18.56h4.8l22.4,31.61h.11V18.56h4.86Z"></path><path fill="#e95a0c" d="M208.09,18.56l-12.68,39.66h-4.69l-9.16-32.51h-.06l-9.33,32.51h-4.69l-12.68-39.66h5.19l9.77,31.67h.11l8.94-31.67h5.31l8.94,31.78h.06l9.77-31.78h5.19Z"></path><path fill="#e95a0c" d="M233.18,48.56h-17.71l-3.52,9.66h-5.14l15.02-39.66h4.86l15.14,39.66h-5.14l-3.52-9.66Zm-1.56-4.25l-7.26-19.83h-.11l-7.21,19.83h14.58Z"></path><path fill="#e95a0c" d="M247.81,18.56h4.86V53.75h19.66v4.47h-24.52V18.56Z"></path><path fill="#e95a0c" d="M277.86,23.03h-11.9v-4.47h28.71v4.47h-11.95V58.22h-4.86V23.03Z"></path><path fill="#385171" d="M293.41,54.37c0-2.2,1.69-3.92,3.92-3.92,2.09,0,3.85,1.72,3.85,3.92s-1.76,3.85-3.85,3.85c-2.23,0-3.92-1.72-3.92-3.85Z"></path><path fill="#385171" d="M308.75,18.56h11.9c12.57,0,20.56,8.15,20.56,19.88s-7.76,19.77-20.39,19.77h-12.07V18.56Zm11.73,35.24c9.55,0,15.75-6.42,15.75-15.36s-6.26-15.47-15.53-15.47h-7.09v30.83h6.87Z"></path><path fill="#385171" d="M345.87,18.56h24.3v4.47h-19.38v13.24h15.92v4.47h-15.92v13.01h20.55v4.47h-25.47V18.56Z"></path><circle fill="#385171" cx="35.41" cy="35.41" r="35.41"></circle><g><path fill="#fff" d="M42.65,39.13l6.62-12.98c.19-.38,.73-.38,.92,0l6.62,12.98s0,.02,0,.03h.55c-.67,3.61-3.83,6.35-7.63,6.35s-6.96-2.74-7.63-6.35h.55s0-.02,0-.03Zm11.53,.03l-3.99-8.12c-.19-.38-.74-.38-.92,0l-3.99,8.12h8.91Z"></path><path fill="#fff" d="M14.44,46.03s0-.02,0-.03l6.62-12.98c.19-.38,.73-.38,.92,0l6.62,12.98s0,.02,0,.03h.55c-.67,3.61-3.83,6.35-7.63,6.35s-6.96-2.74-7.63-6.35h.55Zm11.54,0l-3.99-8.12c-.19-.38-.74-.38-.92,0l-3.99,8.12h8.91Z"></path><rect fill="#fff" x="18.13" y="24.08" width="33.15" height="3.56" rx=".92" ry=".92" transform="translate(-5.07 8.79) rotate(-13.46)"></rect></g>', 11)
  ]));
}
const uc = /* @__PURE__ */ tn(sc, [["render", cc]]);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const dc = {
  prefix: "fab",
  iconName: "facebook-f",
  icon: [320, 512, [], "f39e", "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"]
}, fc = {
  prefix: "fab",
  iconName: "x-twitter",
  icon: [512, 512, [], "e61b", "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"]
}, Go = {
  prefix: "fab",
  iconName: "linkedin",
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
}, mc = {
  prefix: "fab",
  iconName: "instagram",
  icon: [448, 512, [], "f16d", "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"]
}, pc = {
  prefix: "fab",
  iconName: "facebook",
  icon: [512, 512, [62e3], "f09a", "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"]
}, gc = {
  prefix: "fab",
  iconName: "whatsapp",
  icon: [448, 512, [], "f232", "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"]
}, hc = {
  prefix: "fab",
  iconName: "youtube",
  icon: [576, 512, [61802], "f167", "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"]
}, vc = [
  {
    label: "Facebook",
    link: "https://www.facebook.com/anwalt.de",
    icon: pc,
    eventAction: "Klick auf 'Facebook'"
  },
  {
    label: "Instagram",
    link: "https://www.instagram.com/anwalt.de",
    icon: mc,
    eventAction: "Klick auf 'Instagram'"
  },
  {
    label: "Linkedin",
    link: "https://de.linkedin.com/company/anwaltde",
    icon: Go,
    eventAction: "Klick auf 'Linkedin'"
  }
], Kt = {
  TYPE: "event",
  CATEGORY: "Aktionen auf Footer"
}, Tr = [
  {
    groupTitle: "Unternehmen",
    id: "footer-nav-company",
    links: [
      {
        url: "https://team.anwalt.de/",
        label: "Über uns",
        tracking: {
          eventAction: "Klick auf 'Über uns'"
        }
      },
      {
        url: "/unternehmen/kontakt.php",
        label: "Kontakt",
        tracking: {
          eventAction: "Klick auf 'Kontakt'"
        }
      },
      {
        url: "/jobs",
        label: "Jobs",
        tracking: {
          eventAction: "Klick auf 'Jobs'"
        }
      }
    ]
  },
  {
    groupTitle: "Produkte für Anwälte",
    id: "footer-nav-products",
    links: [
      {
        url: "https://jetzt-mitmachen.anwalt.de/mitmachen/mitmachen#pricing ",
        label: "Produktstufen",
        tracking: {
          eventAction: "Klick auf 'Produktstufen'"
        }
      },
      {
        url: "/pdf/anwalt.de_preisliste.pdf",
        label: "Preisliste",
        tracking: {
          eventAction: "Klick auf 'Preisliste'"
        }
      },
      {
        url: "https://jetzt-mitmachen.anwalt.de/mitmachen/mitmachen",
        label: "Kostenlos anmelden",
        tracking: {
          eventAction: "Klick auf 'Kostenlos anmelden'"
        }
      },
      {
        url: "https://www.anwalt.de/kanzleiundklient",
        label: "Magazin Kanzlei & Klient",
        tracking: {
          eventAction: "Klick auf 'Kanzlei & Klient'"
        }
      }
    ]
  },
  {
    groupTitle: "Bewertungen",
    id: "footer-nav-reviews",
    links: [
      {
        url: "/pdf/anwalt.de_bewertungsrichtlinien.pdf",
        label: "Bewertungsrichtlinien",
        tracking: {
          eventAction: "Klick auf 'Bewertungsrichtlinien'"
        }
      },
      {
        url: "https://www.anwalt.de/bestbewertet-score",
        label: "Bestbewertet-Score",
        tracking: {
          eventAction: "Klick auf 'Bestbewertet-Score'"
        }
      }
    ]
  },
  {
    groupTitle: "Rechtliches",
    id: "",
    links: [
      {
        url: "/impressum",
        label: "Impressum",
        tracking: {
          eventAction: "Klick auf 'Impressum'"
        }
      },
      {
        sublinks: [
          {
            url: "/pdf/AGB_anwalt.de.pdf",
            label: "AGB",
            tracking: {
              eventAction: "Klick auf 'AGB'"
            }
          },
          {
            url: "/pdf/DSA_anwalt.de.pdf",
            label: "DSA",
            tracking: {
              eventAction: "Klick auf 'DSA'"
            }
          }
        ]
      },
      {
        url: "/pdf/DSE_anwalt.de.pdf",
        label: "Datenschutz",
        tracking: {
          eventAction: "Klick auf 'Datenschutz'"
        }
      },
      {
        url: "javascript:Cookiebot?.renew()",
        label: "Cookies",
        tracking: {
          eventAction: "Klick auf 'Cookies'"
        }
      }
    ]
  }
], Ac = ["href", "data-ga-trackingtype", "data-ga-event-category", "data-ga-event-action"], Mr = /* @__PURE__ */ x({
  __name: "AnwFooterLink",
  props: {
    link: {
      type: Object,
      required: !0,
      default: () => ({
        url: "",
        label: "",
        target: "",
        tracking: {
          eventAction: ""
        }
      })
    }
  },
  setup(t) {
    return (e, n) => {
      var a;
      return u(), m("a", {
        href: t.link.url,
        class: "!text-neutral-600 hover:!text-info-500",
        "data-ga-trackingtype": p(Kt).TYPE,
        "data-ga-event-category": p(Kt).CATEGORY,
        "data-ga-event-action": (a = t.link.tracking) == null ? void 0 : a.eventAction
      }, k(t.link.label), 9, Ac);
    };
  }
}), bc = {}, wc = {
  width: "98",
  height: "34",
  class: "mt-6 md:mr-12",
  viewBox: "0 0 98 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Cc(t, e) {
  return u(), m("svg", wc, e[0] || (e[0] = [
    Ie('<g clip-path="url(#clip0_318_1061)"><mask id="mask0_318_1061" style="mask-type:luminance;" maskUnits="userSpaceOnUse" x="0" y="0" width="99" height="34"><path d="M98.1819 0.5H0.181885V33.5H98.1819V0.5Z" fill="white"></path></mask><g mask="url(#mask0_318_1061)"><path d="M0.658448 0.761719L0.658447 11.5588H2.74698V0.761719H0.658448Z" fill="black"></path><path d="M0.681885 11.5703V22.3674H2.7704V11.5703H0.681885Z" fill="#C60202"></path><path d="M0.670166 22.377V33.1741H2.75869V22.377H0.670166Z" fill="#F4BA00"></path><path d="M11.4928 14.4057C10.0148 14.4057 9.0187 13.5727 8.98657 12.4193H9.75771C9.82198 13.028 10.2718 13.7649 11.4607 13.7649C12.4889 13.7649 13.0994 13.1562 13.0994 12.3873C13.0994 10.2086 9.0187 11.5863 9.0187 8.79891C9.0187 7.64551 9.9505 6.8125 11.3964 6.8125C12.8102 6.8125 13.6456 7.58143 13.7741 8.60667H12.9708C12.8745 8.09405 12.3925 7.45328 11.3643 7.45328C10.4968 7.45328 9.75771 7.93386 9.75771 8.76687C9.75771 10.9135 13.8384 9.59988 13.8384 12.3552C13.8705 13.3805 13.0672 14.4057 11.4928 14.4057Z" fill="#0F172A"></path><path d="M19.1705 7.54898H16.0537V10.3043H18.8491V10.9131H16.0537V13.7004H19.1705V14.3092H15.3147V6.9082H19.1705V7.54898Z" fill="#0F172A"></path><path d="M22.8677 6.94141C24.5706 6.94141 25.4061 7.87053 25.4061 9.08801C25.4061 10.1132 24.8277 10.9463 23.5746 11.2026L25.4703 14.3424H24.5707L22.7392 11.2666H21.3897V14.3424H20.6507V6.94141H22.8677ZM22.8677 7.55014H21.3897V10.6259H22.8998C24.1208 10.6259 24.6349 9.9851 24.6349 9.05597C24.6349 8.15888 24.1208 7.55014 22.8677 7.55014Z" fill="#0F172A"></path><path d="M31.962 6.94141H32.7331L29.9377 14.3424H29.1023L26.3069 6.94141H27.1102L29.5521 13.5414L31.962 6.94141Z" fill="#0F172A"></path><path d="M37.7134 7.54898H34.5967V10.3043H37.3921V10.9131H34.5967V13.7004H37.7134V14.3092H33.8577V6.9082H37.7134V7.54898Z" fill="#0F172A"></path><path d="M41.4076 6.94141C43.1106 6.94141 43.946 7.87053 43.946 9.08801C43.946 10.1132 43.3676 10.9463 42.1145 11.2026L44.0103 14.3424H43.1106L41.2791 11.2666H39.8975V14.3424H39.1585V6.94141H41.4076ZM41.4076 7.55014H39.9296V10.6259H41.4398C42.6608 10.6259 43.1749 9.9851 43.1749 9.05597C43.1749 8.15888 42.6608 7.55014 41.4076 7.55014Z" fill="#0F172A"></path><path d="M47.6725 14.4057C46.1945 14.4057 45.1984 13.5727 45.1663 12.4193H45.9374C46.0017 13.028 46.4515 13.7649 47.6404 13.7649C48.6686 13.7649 49.2791 13.1562 49.2791 12.3873C49.2791 10.2086 45.1984 11.5863 45.1984 8.79891C45.1984 7.64551 46.1302 6.8125 47.5761 6.8125C48.9899 6.8125 49.8253 7.58143 49.9538 8.60667H49.1505C49.0541 8.09405 48.5722 7.45328 47.544 7.45328C46.6764 7.45328 45.9374 7.93386 45.9374 8.76687C45.9374 10.9135 50.0181 9.59988 50.0181 12.3552C50.0502 13.3805 49.2148 14.4057 47.6725 14.4057Z" fill="#0F172A"></path><path d="M50.9514 6.94141H55.8032V7.55014H53.7468V14.3424H53.0078V7.55014H50.9514V6.94141Z" fill="#0F172A"></path><path d="M61.2976 12.5798H57.9238L57.2812 14.342H56.51L59.209 7.03711H60.0445L62.7435 14.342H61.9723L61.2976 12.5798ZM59.5946 7.96624L58.1166 11.9711H61.0405L59.5946 7.96624Z" fill="#0F172A"></path><path d="M69.4915 6.94141V14.3424H68.7525L64.6397 8.12684V14.3424H63.9007V6.94141H64.6397L68.7525 13.1569V6.94141H69.4915Z" fill="#0F172A"></path><path d="M77.2985 10.6579C77.2985 12.9647 75.8526 14.3424 73.3785 14.3424H71.1936V6.94141H73.3785C75.8526 6.94141 77.2985 8.31908 77.2985 10.6579ZM73.3785 13.7016C75.4671 13.7016 76.5595 12.5482 76.5595 10.6259C76.5595 8.70354 75.4992 7.51811 73.3785 7.51811H71.9326V13.6696H73.3785V13.7016Z" fill="#0F172A"></path><path d="M81.9894 14.4049C79.9009 14.4049 78.3264 12.835 78.3264 10.6243C78.3264 8.41365 79.933 6.84375 81.9894 6.84375C84.0779 6.84375 85.6523 8.41365 85.6523 10.6243C85.6523 12.835 84.0779 14.4049 81.9894 14.4049ZM81.9894 13.7641C83.6281 13.7641 84.8812 12.5787 84.8812 10.6243C84.8812 8.702 83.6281 7.51657 81.9894 7.51657C80.3507 7.51657 79.0976 8.702 79.0976 10.6243C79.0976 12.5467 80.3507 13.7641 81.9894 13.7641Z" fill="#0F172A"></path><path d="M89.2514 6.94141C90.9543 6.94141 91.7898 7.87053 91.7898 9.08801C91.7898 10.1132 91.2114 10.9463 89.9583 11.2026L91.854 14.3424H90.9543L89.1229 11.2666H87.7412V14.3424H87.0022V6.94141H89.2514ZM89.2514 7.55014H87.7734V10.6259H89.2835C90.5045 10.6259 91.0186 9.9851 91.0186 9.05597C91.0186 8.15888 90.5045 7.55014 89.2514 7.55014Z" fill="#0F172A"></path><path d="M92.721 6.94141H97.5728V7.55014H95.5164V14.3424H94.7774V7.55014H92.721V6.94141Z" fill="#0F172A"></path><path d="M15.5078 23.3767C15.5078 25.6514 13.9655 27.0291 11.5878 27.0291H9.17798V19.6602H11.5878C13.9655 19.6602 15.5078 21.1019 15.5078 23.3767ZM11.5878 26.0359C13.3229 26.0359 14.2547 25.0427 14.2547 23.3767C14.2547 21.7106 13.3229 20.6534 11.5878 20.6534H10.399V26.0359H11.5878Z" fill="#0F172A"></path><path d="M20.7782 20.6534H17.9185V22.8H20.4569V23.7932H17.9185V26.0359H20.7782V27.0291H16.6975V19.6602H20.7782V20.6534Z" fill="#0F172A"></path><path d="M22.2561 19.6602H23.4771V24.3378C23.4771 25.4912 24.1197 26.0038 25.1479 26.0038C26.1761 26.0038 26.8187 25.4592 26.8187 24.3378V19.6602H28.0397V24.3378C28.0397 26.1961 26.6902 27.0932 25.1479 27.0932C23.6056 27.0932 22.2883 26.1961 22.2883 24.3378V19.6602H22.2561Z" fill="#0F172A"></path><path d="M29.1975 19.6602H34.3385V20.6534H32.3785V27.0291H31.1575V20.6534H29.1975V19.6602Z" fill="#0F172A"></path><path d="M37.9994 27.0936C36.5213 27.0936 35.3967 26.2926 35.3967 24.979H36.682C36.7463 25.5878 37.164 26.0683 37.9994 26.0683C38.8348 26.0683 39.3167 25.6198 39.3167 24.979C39.3167 23.2169 35.3967 24.3703 35.3967 21.647C35.3967 20.3654 36.4249 19.5645 37.9351 19.5645C39.3489 19.5645 40.3449 20.3013 40.4413 21.5509H39.0918C39.0597 21.0382 38.6099 20.5897 37.8387 20.5897C37.1318 20.5577 36.5856 20.9101 36.5856 21.6149C36.5856 23.281 40.4735 22.2237 40.4735 24.9149C40.5377 26.0363 39.6381 27.0936 37.9994 27.0936Z" fill="#0F172A"></path><path d="M45.328 19.5645C46.8703 19.5645 48.1876 20.3334 48.766 21.7751H47.3201C46.9345 21.0062 46.2276 20.6217 45.3601 20.6217C43.8821 20.6217 42.8217 21.647 42.8217 23.313C42.8217 24.979 43.8821 26.0043 45.3601 26.0043C46.2276 26.0043 46.9345 25.6198 47.3201 24.8509H48.766C48.2198 26.2926 46.8703 27.0615 45.328 27.0615C43.2394 27.0615 41.5686 25.5237 41.5686 23.313C41.5686 21.1344 43.2394 19.5645 45.328 19.5645Z" fill="#0F172A"></path><path d="M54.8379 23.7932H51.3677V26.997H50.1467V19.6602H51.3677V22.8H54.8379V19.6602H56.0589V26.997H54.8379V23.7932Z" fill="#0F172A"></path><path d="M58.8551 19.6602V26.0359H61.3614V26.997H57.6663V19.6602H58.8551Z" fill="#0F172A"></path><path d="M66.7923 25.5233H63.7077L63.1615 27.0291H61.9084L64.5431 19.6602H65.9569L68.5916 27.0291H67.3064L66.7923 25.5233ZM65.25 21.1019L64.029 24.5301H66.4389L65.25 21.1019Z" fill="#0F172A"></path><path d="M75.7859 19.6602V27.0291H74.565L70.9341 21.5504V27.0291H69.7131V19.6602H70.9341L74.565 25.1388V19.6602H75.7859Z" fill="#0F172A"></path><path d="M83.6914 23.3767C83.6914 25.6514 82.1491 27.0291 79.7714 27.0291H77.3616V19.6602H79.7714C82.1491 19.6602 83.6914 21.1019 83.6914 23.3767ZM79.7714 26.0359C81.5065 26.0359 82.4383 25.0427 82.4383 23.3767C82.4383 21.7106 81.5065 20.6534 79.7714 20.6534H78.5826V26.0359H79.7714Z" fill="#0F172A"></path></g></g><defs><clipPath id="clip0_318_1061"><rect width="98" height="33" fill="white" transform="translate(0 0.5)"></rect></clipPath></defs>', 2)
  ]));
}
const yc = /* @__PURE__ */ tn(bc, [["render", Cc]]), kc = {
  id: "footer",
  "data-test-id": "footer",
  class: "flex justify-center px-10 py-12 md:px-16 xl:px-4 2xl:px-0 border-t border-t-neutral-200 border-solid"
}, xc = { class: "bg-white xl:w-[1200px]" }, Ec = { class: "flex justify-between md:items-center lg:mb-12 flex-col md:flex-row mb-8" }, Sc = {
  href: "https://www.anwalt.de/",
  class: "group flex h-[40px] w-[210px] mb-8 md:mb-0"
}, Tc = { class: "flex" }, Mc = ["href", "title", "data-ga-trackingtype", "data-ga-event-category", "data-ga-event-action"], Ic = { class: "sr-only" }, Lc = { class: "flex justify-between flex-col md:flex-row text-sm md:text-base md:flex-wrap" }, _c = ["aria-labelledby"], Oc = ["id"], Pc = { key: 0 }, Bc = {
  key: 0,
  class: "text-neutral-600"
}, Rc = { class: "xl:w-[405px] mt-10 md:mt-0 w-full" }, Nc = { class: "border-t border-t-neutral-200 border-solid py-6 mt-9 flex flex-col md:flex-row justify-between md:items-center" }, Dc = { class: "text-base text-neutral-900" }, Hc = { class: "flex flex-col md:flex-row md:items-center" }, Fc = /* @__PURE__ */ x({
  __name: "AnwFooterAccessible",
  props: {
    ratingAverage: { default: 4.6 },
    ratingCount: { default: 349 }
  },
  setup(t) {
    const e = () => `© 2004-${(/* @__PURE__ */ new Date()).getFullYear()}`;
    return (n, a) => (u(), m("footer", kc, [
      d("div", xc, [
        d("div", Ec, [
          d("a", Sc, [
            a[0] || (a[0] = d("span", { class: "sr-only" }, "Anwalt suchen und finden bei anwalt.de", -1)),
            M(uc)
          ]),
          d("ul", Tc, [
            (u(!0), m(U, null, ne(p(vc), (i) => (u(), m("li", {
              key: i.label,
              class: "md:ml-4 mr-4 md:mr-0"
            }, [
              d("a", {
                href: i.link,
                target: "_blank",
                title: i.label,
                "data-ga-trackingtype": p(Kt).TYPE,
                "data-ga-event-category": p(Kt).CATEGORY,
                "data-ga-event-action": i.eventAction
              }, [
                M(p(Q), {
                  icon: i.icon,
                  class: "text-[1.5rem] text-neutral-500 hover:text-info-500"
                }, null, 8, ["icon"]),
                d("span", Ic, k(i.label), 1),
                a[1] || (a[1] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
              ], 8, Mc)
            ]))), 128))
          ])
        ]),
        d("div", Lc, [
          (u(!0), m(U, null, ne(p(Tr), (i, r) => (u(), m("nav", {
            key: i.groupTitle,
            "aria-labelledby": i.id,
            class: L(r === p(Tr).length - 1 ? "mb-0" : "mb-6")
          }, [
            d("h6", {
              id: i.id,
              class: "text-neutral-600 mb-4 text-sm md:text-base font-semibold"
            }, k(i.groupTitle), 9, Oc),
            d("ul", null, [
              (u(!0), m(U, null, ne(i.links, (o, s) => {
                var l;
                return u(), m("li", {
                  key: o.label,
                  class: L(s === i.links.length - 1 ? "mb-0" : "mb-3")
                }, [
                  (l = o.sublinks) != null && l.length ? (u(), m("div", Pc, [
                    (u(!0), m(U, null, ne(o.sublinks, (c, f) => (u(), m(U, {
                      key: c.label
                    }, [
                      M(Mr, { link: c }, null, 8, ["link"]),
                      f < o.sublinks.length - 1 ? (u(), m("span", Bc, " & ")) : T("", !0)
                    ], 64))), 128))
                  ])) : (u(), D(Mr, {
                    key: 1,
                    link: o
                  }, null, 8, ["link"]))
                ], 2);
              }), 128))
            ])
          ], 10, _c))), 128)),
          d("div", Rc, [
            a[2] || (a[2] = d("div", { class: "mb-6 text-neutral-600 text-sm md:text-base md:mt-10 xl:mt-0" }, " Hier bekommen Sie Recht – aktuell und schnell: Bleiben Sie auf dem Laufenden und erhalten Sie hilfreiche Infos zu rechtlichen Fallen des Alltags. ", -1)),
            d("div", null, [
              M(p(_a), {
                href: "https://www.anwalt.de/rechtstipps/newsletter.php",
                "data-ga-trackingtype": p(Kt).TYPE,
                "data-ga-event-category": p(Kt).CATEGORY,
                "data-ga-event-action": "Klick auf 'Newsletter anmelden'",
                label: "Zum anwalt.de-Newsletter",
                class: "xl:w-full w-auto inline-block",
                appearance: "secondary-outline"
              }, null, 8, ["data-ga-trackingtype", "data-ga-event-category"])
            ])
          ])
        ]),
        d("div", Nc, [
          d("p", Dc, k(e()), 1),
          d("div", Hc, [
            M(yc),
            M(p(Ci), {
              class: "mt-6",
              "rating-average": n.ratingAverage,
              "rating-count": n.ratingCount
            }, null, 8, ["rating-average", "rating-count"])
          ])
        ])
      ])
    ]));
  }
}), Vc = ["aria-label"], zc = { class: "flex flex-wrap gap-2" }, Uc = ["href"], Qc = ["href"], jc = /* @__PURE__ */ x({
  __name: "AnwBreadcrumbs",
  props: {
    breadcrumbsLabel: {},
    args: {}
  },
  setup(t) {
    return (e, n) => (u(), m("nav", { "aria-label": e.breadcrumbsLabel }, [
      d("ol", zc, [
        (u(!0), m(U, null, ne(e.args, (a, i) => (u(), m("li", {
          key: i,
          class: "flex gap-2 text-xs text-neutral-600"
        }, [
          e.args.length > i + 1 ? (u(), m(U, { key: 0 }, [
            d("a", {
              href: a.url,
              class: "text-info-500 !no-underline"
            }, k(a.text), 9, Uc),
            n[0] || (n[0] = d("span", { "aria-hidden": "true" }, "/", -1))
          ], 64)) : (u(), m("a", {
            key: 1,
            href: a.url,
            "aria-current": "page",
            class: "cursor-text !text-inherit !no-underline"
          }, k(a.text), 9, Qc))
        ]))), 128))
      ])
    ], 8, Vc));
  }
}), Zc = (t, e) => {
  let n;
  return (...a) => {
    n && clearTimeout(n), n = setTimeout(() => {
      t(...a);
    }, e);
  };
};
var Gc = {
  prefix: "fad",
  iconName: "lock",
  icon: [448, 512, [128274], "f023", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
}, Yc = {
  prefix: "fad",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", ["M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z", "M212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"]]
};
const Kc = ["id", "type", "data-testid", "disabled"], $c = ["for", "data-testid"], Jc = ["data-testid"], Yo = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwInput",
  props: {
    errorMessage: { default: "" },
    id: { default: "" },
    label: { default: "" },
    modelValue: { default: "" },
    wrapperClass: { default: "" },
    type: { default: "text" },
    debounceTimeout: { default: 0 },
    loadingState: { type: Boolean, default: !1 },
    testid: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, { debounceTimeout: a } = st(n), i = e, r = (l) => i("update:modelValue", l), o = Zc((l) => {
      r(l);
    }, a.value), s = w({
      get() {
        return n.modelValue;
      },
      set(l) {
        n.debounceTimeout ? o(l) : r(l);
      }
    });
    return (l, c) => (u(), m("div", {
      class: L(["relative mb-3", l.wrapperClass])
    }, [
      We(d("input", ge(l.$attrs, {
        id: l.id,
        "onUpdate:modelValue": c[0] || (c[0] = (f) => s.value = f),
        type: l.type,
        class: ["anw-floating-input peer", { "anw-is-invalid": l.errorMessage }],
        placeholder: " ",
        "data-testid": l.testid ? `${l.testid}_input` : void 0,
        disabled: l.loadingState || l.disabled
      }), null, 16, Kc), [
        [lo, s.value]
      ]),
      l.loadingState ? (u(), D(p(Ni), {
        key: 0,
        "loader-size": "small",
        class: "absolute right-3 top-5"
      })) : T("", !0),
      l.disabled ? (u(), D(p(Q), {
        key: 1,
        icon: p(Gc),
        class: "text-neutral-400 text-sm absolute right-3 top-5"
      }, null, 8, ["icon"])) : T("", !0),
      d("label", {
        for: l.id,
        class: "anw-floating-label",
        "data-testid": l.testid ? `${l.testid}_label` : void 0
      }, k(l.label), 9, $c),
      l.errorMessage ? (u(), m("div", {
        key: 2,
        class: "anw-invalid-feedback",
        "data-testid": l.testid ? `${l.testid}_error` : void 0
      }, k(l.errorMessage), 9, Jc)) : T("", !0)
    ], 2));
  }
}), Wc = { class: "relative mb-3" }, qc = ["id", "rows", "data-testid"], Xc = ["for", "data-testid"], eu = ["data-testid"], tu = {
  key: 1,
  class: "awn-counter-textarea"
}, nu = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwTextarea",
  props: {
    errorMessage: { default: "" },
    id: { default: "" },
    label: { default: "" },
    modelValue: { default: "" },
    rows: { default: 4 },
    counter: { default: () => ({ enable: !1, min: null, max: null }) },
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = w({
      get() {
        return n.modelValue;
      },
      set(o) {
        a("update:modelValue", o);
      }
    }), r = function(o) {
      o.style.minHeight = "", o.style.minHeight = o.scrollHeight + "px";
    };
    return (o, s) => {
      var l;
      return u(), m("div", Wc, [
        We(d("textarea", ge(o.$attrs, {
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (c) => i.value = c),
          rows: o.rows,
          placeholder: " ",
          class: ["anw-floating-input peer overflow-hidden", { "anw-is-invalid": o.errorMessage }],
          "data-testid": o.testid ? `${o.testid}_input` : void 0,
          onInput: s[1] || (s[1] = (c) => r(c.target))
        }), null, 16, qc), [
          [Sn, i.value]
        ]),
        d("label", {
          for: o.id,
          class: "anw-floating-label",
          "data-testid": o.testid ? `${o.testid}_label` : void 0
        }, k(o.label), 9, Xc),
        o.errorMessage ? (u(), m("div", {
          key: 0,
          class: "anw-invalid-feedback",
          "data-testid": o.testid ? `${o.testid}_error` : void 0
        }, k(o.errorMessage), 9, eu)) : T("", !0),
        (l = o.counter) != null && l.enable ? (u(), m("span", tu, [
          d("span", {
            class: L({ "text-error-500": o.modelValue.length < o.counter.min || o.modelValue.length === o.counter.max })
          }, k(o.modelValue.length), 3),
          J(" /" + k(o.counter.max), 1)
        ])) : T("", !0)
      ]);
    };
  }
});
function Ko(t) {
  return Ss() ? (Ts(t), !0) : !1;
}
const za = /* @__PURE__ */ new WeakMap(), au = (...t) => {
  var e;
  const n = t[0], a = (e = Ca()) == null ? void 0 : e.proxy;
  if (a == null && !co())
    throw new Error("injectLocal must be called in setup");
  return a && za.has(a) && n in za.get(a) ? za.get(a)[n] : lt(...t);
}, $o = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const iu = (t) => t != null, ru = Object.prototype.toString, ou = (t) => ru.call(t) === "[object Object]", at = () => {
}, su = /* @__PURE__ */ lu();
function lu() {
  var t, e;
  return $o && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Ir(t) {
  return t.endsWith("rem") ? Number.parseFloat(t) * 16 : Number.parseFloat(t);
}
function ca(t) {
  return Array.isArray(t) ? t : [t];
}
function cu(t, e, n) {
  return be(
    t,
    e,
    {
      ...n,
      immediate: !0
    }
  );
}
const Ta = $o ? window : void 0;
function gt(t) {
  var e;
  const n = Je(t);
  return (e = n == null ? void 0 : n.$el) != null ? e : n;
}
function Zt(...t) {
  const e = [], n = () => {
    e.forEach((s) => s()), e.length = 0;
  }, a = (s, l, c, f) => (s.addEventListener(l, c, f), () => s.removeEventListener(l, c, f)), i = w(() => {
    const s = ca(Je(t[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), r = cu(
    () => {
      var s, l;
      return [
        (l = (s = i.value) == null ? void 0 : s.map((c) => gt(c))) != null ? l : [Ta].filter((c) => c != null),
        ca(Je(i.value ? t[1] : t[0])),
        ca(p(i.value ? t[2] : t[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Je(i.value ? t[3] : t[2])
      ];
    },
    ([s, l, c, f]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(c != null && c.length))
        return;
      const g = ou(f) ? { ...f } : f;
      e.push(
        ...s.flatMap(
          (v) => l.flatMap(
            (A) => c.map((y) => a(v, A, y, g))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    r(), n();
  };
  return Ko(n), o;
}
let Lr = !1;
function Dn(t, e, n = {}) {
  const { window: a = Ta, ignore: i = [], capture: r = !0, detectIframe: o = !1, controls: s = !1 } = n;
  if (!a)
    return s ? { stop: at, cancel: at, trigger: at } : at;
  if (su && !Lr) {
    Lr = !0;
    const C = { passive: !0 };
    Array.from(a.document.body.children).forEach((b) => Zt(b, "click", at, C)), Zt(a.document.documentElement, "click", at, C);
  }
  let l = !0;
  const c = (C) => Je(i).some((b) => {
    if (typeof b == "string")
      return Array.from(a.document.querySelectorAll(b)).some((S) => S === C.target || C.composedPath().includes(S));
    {
      const S = gt(b);
      return S && (C.target === S || C.composedPath().includes(S));
    }
  });
  function f(C) {
    const b = Je(C);
    return b && b.$.subTree.shapeFlag === 16;
  }
  function g(C, b) {
    const S = Je(C), F = S.$.subTree && S.$.subTree.children;
    return F == null || !Array.isArray(F) ? !1 : F.some((V) => V.el === b.target || b.composedPath().includes(V.el));
  }
  const v = (C) => {
    const b = gt(t);
    if (C.target != null && !(!(b instanceof Element) && f(t) && g(t, C)) && !(!b || b === C.target || C.composedPath().includes(b))) {
      if ("detail" in C && C.detail === 0 && (l = !c(C)), !l) {
        l = !0;
        return;
      }
      e(C);
    }
  };
  let A = !1;
  const y = [
    Zt(a, "click", (C) => {
      A || (A = !0, setTimeout(() => {
        A = !1;
      }, 0), v(C));
    }, { passive: !0, capture: r }),
    Zt(a, "pointerdown", (C) => {
      const b = gt(t);
      l = !c(C) && !!(b && !C.composedPath().includes(b));
    }, { passive: !0 }),
    o && Zt(a, "blur", (C) => {
      setTimeout(() => {
        var b;
        const S = gt(t);
        ((b = a.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !(S != null && S.contains(a.document.activeElement)) && e(C);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), _ = () => y.forEach((C) => C());
  return s ? {
    stop: _,
    cancel: () => {
      l = !1;
    },
    trigger: (C) => {
      l = !0, v(C), l = !1;
    }
  } : _;
}
function uu() {
  const t = Cn(!1), e = Ca();
  return e && Ct(() => {
    t.value = !0;
  }, e), t;
}
function Jo(t) {
  const e = uu();
  return w(() => (e.value, !!t()));
}
const du = Symbol("vueuse-ssr-width");
function fu() {
  const t = co() ? au(du, null) : null;
  return typeof t == "number" ? t : void 0;
}
function mu(t, e = {}) {
  const { window: n = Ta, ssrWidth: a = fu() } = e, i = Jo(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), r = Cn(typeof a == "number"), o = Cn(), s = Cn(!1), l = (c) => {
    s.value = c.matches;
  };
  return yn(() => {
    if (r.value) {
      r.value = !i.value;
      const c = Je(t).split(",");
      s.value = c.some((f) => {
        const g = f.includes("not all"), v = f.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), A = f.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let y = !!(v || A);
        return v && y && (y = a >= Ir(v[1])), A && y && (y = a <= Ir(A[1])), g ? !y : y;
      });
      return;
    }
    i.value && (o.value = n.matchMedia(Je(t)), s.value = o.value.matches);
  }), Zt(o, "change", l, { passive: !0 }), w(() => s.value);
}
function pu(t, e, n = {}) {
  const {
    root: a,
    rootMargin: i = "0px",
    threshold: r = 0,
    window: o = Ta,
    immediate: s = !0
  } = n, l = Jo(() => o && "IntersectionObserver" in o), c = w(() => {
    const y = Je(t);
    return ca(y).map(gt).filter(iu);
  });
  let f = at;
  const g = Cn(s), v = l.value ? be(
    () => [c.value, gt(a), g.value],
    ([y, _]) => {
      if (f(), !g.value || !y.length)
        return;
      const C = new IntersectionObserver(
        e,
        {
          root: gt(_),
          rootMargin: i,
          threshold: r
        }
      );
      y.forEach((b) => b && C.observe(b)), f = () => {
        C.disconnect(), f = at;
      };
    },
    { immediate: s, flush: "post" }
  ) : at, A = () => {
    f(), v(), g.value = !1;
  };
  return Ko(A), {
    isSupported: l,
    isActive: g,
    pause() {
      f(), g.value = !1;
    },
    resume() {
      g.value = !0;
    },
    stop: A
  };
}
const gu = { class: "anw-dropdown mb-3" }, hu = ["id", "data-testid"], vu = ["for", "data-testid"], Au = { class: "anw-dropdown-content" }, bu = { class: "max-h-52 w-full list-none overflow-y-auto rounded border border-neutral-400 bg-white p-0" }, wu = ["data-testid", "onClick"], Cu = ["data-testid"], yu = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwSelect",
  props: {
    modelValue: { default: "" },
    options: {},
    label: {},
    errorMessage: { default: "" },
    id: { default: "anw-dropdown-toggler" },
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = e, a = t, i = N(null), r = (s) => {
      n("update:modelValue", s), i.value && (i.value.checked = !1);
    };
    Dn(i, () => i.value.checked = !1);
    const o = w(() => {
      var s;
      return a.modelValue ? (s = a.options.find((l) => l.value === a.modelValue)) == null ? void 0 : s.label : a.label;
    });
    return (s, l) => (u(), m("div", gu, [
      d("input", ge({
        id: s.id,
        ref_key: "dropdownToggler",
        ref: i,
        class: "anw-dropdown-toggler peer",
        type: "checkbox",
        "data-testid": s.testid ? `${s.testid}_input` : void 0
      }, s.$attrs), null, 16, hu),
      d("label", {
        ref: "dropdownHandler",
        class: L([{ "anw-is-invalid": s.errorMessage }, "anw-form-select anw-peer-form-focus"]),
        for: s.id,
        "data-testid": s.testid ? `${s.testid}_label` : void 0
      }, k(o.value), 11, vu),
      d("div", Au, [
        d("ul", bu, [
          (u(!0), m(U, null, ne(s.options, (c, f) => (u(), m("li", { key: f }, [
            d("button", {
              class: "anw-menu-link w-full text-left",
              "data-testid": s.testid ? `${s.testid}_option_${f}` : void 0,
              onClick: Pn((g) => r(c.value), ["prevent"])
            }, k(c.label), 9, wu)
          ]))), 128))
        ])
      ]),
      s.errorMessage ? (u(), m("div", {
        key: 0,
        class: "anw-invalid-feedback",
        "data-testid": s.testid ? `${s.testid}_error` : void 0
      }, k(s.errorMessage), 9, Cu)) : T("", !0)
    ]));
  }
}), ku = ["data-testid"], Ni = /* @__PURE__ */ x({
  __name: "AnwLoader",
  props: {
    loaderSize: { default: "default" },
    testid: { default: "" }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "": !0,
      "anw-loader-default": e.loaderSize === "default",
      "anw-loader-small": e.loaderSize === "small"
    }));
    return (a, i) => (u(), m("div", {
      role: "alert",
      "aria-label": "Loading",
      "data-testid": a.testid ? a.testid : void 0
    }, [
      (u(), m("svg", {
        class: L(n.value),
        viewBox: "0 0 80 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, i[0] || (i[0] = [
        Ie('<circle cx="40" cy="40" r="35" stroke="#E8EDFB" stroke-width="10"></circle><path d="M70 40C70 42.7614 72.2386 45 75 45C77.7614 45 80 42.7614 80 40H70ZM53.3939 7.66423L51.4805 12.2836L53.3939 7.66423ZM33.1718 5.67253L34.1473 10.5765L33.1718 5.67253ZM15.2513 15.2513L11.7157 11.7157L11.7157 11.7157L15.2513 15.2513ZM5.67253 33.1718L0.768604 32.1964L5.67253 33.1718ZM7.66423 53.3939L3.04483 55.3073L7.66423 53.3939ZM20.5551 69.1014L17.7772 73.2588H17.7772L20.5551 69.1014ZM80 40C80 32.0888 77.654 24.3552 73.2588 17.7772L64.9441 23.3329C68.2405 28.2664 70 34.0666 70 40H80ZM73.2588 17.7772C68.8635 11.1992 62.6164 6.07234 55.3073 3.04483L51.4805 12.2836C56.9623 14.5543 61.6476 18.3994 64.9441 23.3329L73.2588 17.7772ZM55.3073 3.04483C47.9983 0.0173292 39.9556 -0.774804 32.1964 0.768604L34.1473 10.5765C39.9667 9.4189 45.9987 10.013 51.4805 12.2836L55.3073 3.04483ZM32.1964 0.768604C24.4372 2.31201 17.3098 6.12164 11.7157 11.7157L18.7868 18.7868C22.9824 14.5912 28.3279 11.734 34.1473 10.5765L32.1964 0.768604ZM11.7157 11.7157C6.12164 17.3098 2.31201 24.4372 0.768604 32.1964L10.5765 34.1473C11.734 28.3279 14.5912 22.9824 18.7868 18.7868L11.7157 11.7157ZM0.768604 32.1964C-0.774804 39.9556 0.0173292 47.9983 3.04483 55.3073L12.2836 51.4805C10.013 45.9987 9.4189 39.9667 10.5765 34.1473L0.768604 32.1964ZM3.04483 55.3073C6.07234 62.6164 11.1992 68.8635 17.7772 73.2588L23.3329 64.9441C18.3994 61.6476 14.5543 56.9623 12.2836 51.4805L3.04483 55.3073ZM17.7772 73.2588C24.3552 77.654 32.0888 80 40 80V70C34.0666 70 28.2664 68.2405 23.3329 64.9441L17.7772 73.2588Z" fill="url(#paint0_linear_360_778)"></path><defs><linearGradient id="paint0_linear_360_778" x1="75" y1="40" x2="40" y2="75" gradientUnits="userSpaceOnUse"><stop stop-color="#1D4ED8" offset="0"></stop><stop stop-color="#1D4ED8" offset="1" stop-opacity="0"></stop></linearGradient></defs>', 3)
      ]), 2))
    ], 8, ku));
  }
}), xu = ["id", "disabled"], Eu = ["for"], Su = { class: "anw-search-select" }, Tu = {
  key: 0,
  class: "flex items-center gap-3 px-4 py-2 text-neutral-700"
}, Mu = ["onClick"], Iu = {
  key: 2,
  class: "px-4 py-2 text-neutral-700"
}, Lu = {
  key: 0,
  class: "anw-invalid-feedback"
}, _u = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwSearchSelect",
  props: {
    modelValue: { default: "" },
    options: {},
    label: {},
    errorMessage: { default: "" },
    id: {},
    isDisabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "search"],
  setup(t, { emit: e }) {
    const n = e, a = t, i = N(""), r = N(!1), o = N(null), s = N(!1), l = N({
      value: "",
      label: ""
    }), c = (C) => {
      s.value = C;
    }, f = () => {
      r.value && n("search", i.value, c);
    }, g = w(() => {
      var b;
      const C = i.value.toLowerCase();
      return (b = a.options) == null ? void 0 : b.filter((S) => S.label.toLowerCase().includes(C));
    }), v = (C) => {
      l.value = C, i.value = C.label, r.value = !1, n("update:modelValue", C.value);
    }, A = () => {
      i.value = "", r.value = !0;
    }, y = () => {
      r.value = !1, s.value = !1, i.value = l.value.label ? l.value.label : "";
    };
    Dn(o, y);
    const _ = w(() => i.value ? i.value : a.label);
    return be(a, () => {
      var C;
      ((C = a.options) == null ? void 0 : C.length) === 0 && (i.value = "");
    }), (C, b) => (u(), m("div", {
      ref_key: "dropdownToggler",
      ref: o,
      class: "anw-dropdown mb-3"
    }, [
      d("div", null, [
        We(d("input", ge(C.$attrs, {
          id: C.id,
          "onUpdate:modelValue": b[0] || (b[0] = (S) => i.value = S),
          disabled: C.isDisabled,
          type: "text",
          class: "anw-dropdown-toggler peer",
          onFocus: A,
          onKeyup: f,
          onKeydown: fa(y, ["escape"])
        }), null, 16, xu), [
          [Sn, i.value]
        ]),
        d("label", {
          ref: "dropdownHandler",
          for: C.id,
          class: L(["anw-form-select anw-peer-form-focus mb-2 peer-focus:cursor-text", { "anw-is-invalid": C.errorMessage, "peer-focus:text-neutral-500": !i.value }])
        }, k(_.value), 11, Eu)
      ]),
      We(d("ul", Su, [
        s.value ? (u(), m("div", Tu, [
          M(Ni, { "loader-size": "small" }),
          b[1] || (b[1] = J(" Wird geladen ... "))
        ])) : (u(!0), m(U, { key: 1 }, ne(g.value, (S, F) => (u(), m("li", {
          key: F,
          class: "anw-menu-link cursor-pointer",
          onClick: (V) => v(S)
        }, k(S.label), 9, Mu))), 128)),
        g.value.length === 0 && !s.value ? (u(), m("li", Iu, [
          pe(C.$slots, "noOptions", {}, () => [
            b[2] || (b[2] = J("Sorry, Keine passenden Optionen gefunden"))
          ])
        ])) : T("", !0)
      ], 512), [
        [Ms, r.value]
      ]),
      C.errorMessage ? (u(), m("div", Lu, k(C.errorMessage), 1)) : T("", !0)
    ], 512));
  }
}), Ou = ["id", "name", "value", "data-testid"], Pu = ["for", "data-testid"], Bu = ["data-testid"], Ru = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwRadio",
  props: {
    id: { default: "" },
    label: { default: "" },
    modelValue: { default: "" },
    name: { default: "" },
    value: { default: "" },
    errorMessage: { default: "" },
    testid: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = w({
      get() {
        return n.modelValue;
      },
      set(r) {
        a("update:modelValue", r);
      }
    });
    return (r, o) => (u(), m(U, null, [
      d("div", {
        class: L([{ "anw-is-invalid": r.errorMessage }, "anw-form-check"])
      }, [
        We(d("input", ge({
          id: r.id,
          "onUpdate:modelValue": o[0] || (o[0] = (s) => i.value = s),
          name: r.name,
          value: r.value,
          class: "anw-form-input",
          type: "radio",
          "data-testid": r.testid ? `${r.testid}_input` : void 0
        }, r.$attrs), null, 16, Ou), [
          [Is, i.value]
        ]),
        d("label", {
          for: r.id,
          class: "text-neutral-900",
          "data-testid": r.testid ? `${r.testid}_label` : void 0
        }, [
          J(k(r.label) + " ", 1),
          pe(r.$slots, "default")
        ], 8, Pu)
      ], 2),
      r.errorMessage ? (u(), m("div", {
        key: 0,
        class: "anw-invalid-feedback",
        "data-testid": r.testid ? `${r.testid}_error` : void 0
      }, k(r.errorMessage), 9, Bu)) : T("", !0)
    ], 64));
  }
}), Nu = { class: "mb-4" }, Du = ["id", "value", "data-testid"], Hu = ["for", "data-testid"], Fu = ["data-testid"], Vu = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwCheckbox",
  props: {
    id: { default: "" },
    label: { default: "" },
    textSize: { default: "text-xs" },
    modelValue: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    testid: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = w({
      get() {
        return n.modelValue;
      },
      set(o) {
        a("update:modelValue", o);
      }
    }), r = w(() => ({
      "": !0,
      "text-xs": n.textSize === "text-xs",
      "text-sm": n.textSize === "text-sm",
      "text-base": n.textSize === "text-base",
      "text-lg": n.textSize === "text-lg"
    }));
    return (o, s) => (u(), m("div", Nu, [
      d("div", {
        class: L([[{ "anw-is-invalid": o.errorMessage }, r.value], "anw-form-check relative flex"])
      }, [
        We(d("input", ge({
          id: o.id,
          "onUpdate:modelValue": s[0] || (s[0] = (l) => i.value = l),
          value: o.id,
          class: "anw-form-input",
          name: "insurance",
          type: "checkbox",
          "data-testid": o.testid ? `${o.testid}_input` : void 0
        }, o.$attrs), null, 16, Du), [
          [Ls, i.value]
        ]),
        d("label", {
          for: o.id,
          "data-testid": o.testid ? `${o.testid}_label` : void 0
        }, [
          J(k(o.label) + " ", 1),
          pe(o.$slots, "default")
        ], 8, Hu)
      ], 2),
      o.errorMessage ? (u(), m("div", {
        key: 0,
        class: "anw-invalid-feedback mt-2 sm:mt-4",
        "data-testid": o.testid ? `${o.testid}_error` : void 0
      }, k(o.errorMessage), 9, Fu)) : T("", !0)
    ]));
  }
}), zu = ["data-testid"], Uu = { class: "relative inline-flex items-center self-start" }, Qu = ["disabled", "checked"], ju = { class: "ml-2 items-center" }, Zu = /* @__PURE__ */ x({
  __name: "AnwToggle",
  props: {
    label: { default: "" },
    extraText: { default: "" },
    size: { default: "sm" },
    modelValue: { type: Boolean },
    testid: { default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t) {
    const e = t, n = w(() => e.size === "sm"), a = w(() => e.size === "md"), i = w(() => ({
      container: {
        "w-9 h-5": n.value,
        "w-11 h-6": a.value
      },
      toggler: {
        "w-4 h-4 peer-checked:translate-x-4": n.value,
        "w-5 h-5 peer-checked:translate-x-5": a.value
      },
      labels: {
        "text-sm": n.value,
        "text-base": a.value
      }
    }));
    return (r, o) => (u(), m("div", null, [
      d("label", {
        class: "cursor-pointer flex",
        "data-testid": r.testid ? `${r.testid}_label` : void 0
      }, [
        d("span", Uu, [
          d("input", ge({
            disabled: r.disabled,
            type: "checkbox",
            class: "sr-only peer",
            checked: r.modelValue
          }, r.$attrs, {
            onChange: o[0] || (o[0] = (s) => r.$emit("update:modelValue", s.target.checked))
          }), null, 16, Qu),
          d("span", {
            class: L([i.value.container, "group-hover:peer-checked:bg-success-700 bg-neutral-100 peer-checked:bg-success-600 rounded-full peer-focus:ring-4 peer-focus:ring-neutral-200 peer-checked:peer-focus:ring-success-100 transition-colors duration-300"])
          }, null, 2),
          d("span", {
            class: L([i.value.toggler, "absolute left-0.5 top-0.5 bg-white peer-disabled:bg-neutral-50 rounded-full transition-transform duration-300 transform"])
          }, null, 2)
        ]),
        d("span", ju, [
          r.label ? (u(), m("span", {
            key: 0,
            class: L([i.value.labels, "flex text-neutral-700"])
          }, k(r.label), 3)) : T("", !0),
          r.extraText ? (u(), m("span", {
            key: 1,
            class: L([i.value.labels, "flex text-neutral-600"])
          }, k(r.extraText), 3)) : T("", !0)
        ])
      ], 8, zu)
    ]));
  }
}), Di = {
  name: "Germany (Deutschland)",
  iso: "de",
  dialCode: "+49"
}, Wo = [
  {
    name: "Germany (Deutschland)",
    iso: "de",
    dialCode: "+49"
  },
  {
    name: "Austria (Österreich)",
    iso: "at",
    dialCode: "+43"
  },
  {
    name: "Switzerland (Schweiz)",
    iso: "ch",
    dialCode: "+41"
  }
], Gu = Wo.length, Yu = [
  ...Wo,
  {
    name: "Afghanistan (‫افغانستان‬‎)",
    iso: "af",
    dialCode: "+93"
  },
  {
    name: "Albania (Shqipëri)",
    iso: "al",
    dialCode: "+355"
  },
  {
    name: "Algeria (‫الجزائر‬‎)",
    iso: "dz",
    dialCode: "+213"
  },
  {
    name: "American Samoa",
    iso: "as",
    dialCode: "+1684"
  },
  {
    name: "Andorra",
    iso: "ad",
    dialCode: "+376"
  },
  {
    name: "Angola",
    iso: "ao",
    dialCode: "+244"
  },
  {
    name: "Anguilla",
    iso: "ai",
    dialCode: "+1264"
  },
  {
    name: "Antigua and Barbuda",
    iso: "ag",
    dialCode: "+1268"
  },
  {
    name: "Argentina",
    iso: "ar",
    dialCode: "+54"
  },
  {
    name: "Armenia (Հայաստան)",
    iso: "am",
    dialCode: "+374"
  },
  {
    name: "Aruba",
    iso: "aw",
    dialCode: "+297"
  },
  {
    name: "Australia",
    iso: "au",
    dialCode: "+61"
  },
  {
    name: "Austria (Österreich)",
    iso: "at",
    dialCode: "+43"
  },
  {
    name: "Azerbaijan (Azərbaycan)",
    iso: "az",
    dialCode: "+994"
  },
  {
    name: "Bahamas",
    iso: "bs",
    dialCode: "+1242"
  },
  {
    name: "Bahrain (‫البحرين‬‎)",
    iso: "bh",
    dialCode: "+973"
  },
  {
    name: "Bangladesh (বাংলাদেশ)",
    iso: "bd",
    dialCode: "+880"
  },
  {
    name: "Barbados",
    iso: "bb",
    dialCode: "+1246"
  },
  {
    name: "Belarus (Беларусь)",
    iso: "by",
    dialCode: "+375"
  },
  {
    name: "Belgium (België)",
    iso: "be",
    dialCode: "+32"
  },
  {
    name: "Belize",
    iso: "bz",
    dialCode: "+501"
  },
  {
    name: "Benin (Bénin)",
    iso: "bj",
    dialCode: "+229"
  },
  {
    name: "Bermuda",
    iso: "bm",
    dialCode: "+1441"
  },
  {
    name: "Bhutan (འབྲུག)",
    iso: "bt",
    dialCode: "+975"
  },
  {
    name: "Bolivia",
    iso: "bo",
    dialCode: "+591"
  },
  {
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    iso: "ba",
    dialCode: "+387"
  },
  {
    name: "Botswana",
    iso: "bw",
    dialCode: "+267"
  },
  {
    name: "Brazil (Brasil)",
    iso: "br",
    dialCode: "+55"
  },
  {
    name: "British Indian Ocean Territory",
    iso: "io",
    dialCode: "+246"
  },
  {
    name: "British Virgin Islands",
    iso: "vg",
    dialCode: "+1284"
  },
  {
    name: "Brunei",
    iso: "bn",
    dialCode: "+673"
  },
  {
    name: "Bulgaria (България)",
    iso: "bg",
    dialCode: "+359"
  },
  {
    name: "Burkina Faso",
    iso: "bf",
    dialCode: "+226"
  },
  {
    name: "Burundi (Uburundi)",
    iso: "bi",
    dialCode: "+257"
  },
  {
    name: "Cambodia (កម្ពុជា)",
    iso: "kh",
    dialCode: "+855"
  },
  {
    name: "Cameroon (Cameroun)",
    iso: "cm",
    dialCode: "+237"
  },
  {
    name: "Canada",
    iso: "ca",
    dialCode: "+1"
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    iso: "cv",
    dialCode: "+238"
  },
  {
    name: "Caribbean Netherlands",
    iso: "bq",
    dialCode: "+599"
  },
  {
    name: "Cayman Islands",
    iso: "ky",
    dialCode: "+1345"
  },
  {
    name: "Central African Republic (République centrafricaine)",
    iso: "cf",
    dialCode: "+236"
  },
  {
    name: "Chad (Tchad)",
    iso: "td",
    dialCode: "+235"
  },
  {
    name: "Chile",
    iso: "cl",
    dialCode: "+56"
  },
  {
    name: "China (中国)",
    iso: "cn",
    dialCode: "+86"
  },
  {
    name: "Christmas Island",
    iso: "cx",
    dialCode: "+61"
  },
  {
    name: "Cocos (Keeling) Islands",
    iso: "cc",
    dialCode: "+61"
  },
  {
    name: "Colombia",
    iso: "co",
    dialCode: "+57"
  },
  {
    name: "Comoros (‫جزر القمر‬‎)",
    iso: "km",
    dialCode: "+269"
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    iso: "cd",
    dialCode: "+243"
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    iso: "cg",
    dialCode: "+242"
  },
  {
    name: "Cook Islands",
    iso: "ck",
    dialCode: "+682"
  },
  {
    name: "Costa Rica",
    iso: "cr",
    dialCode: "+506"
  },
  {
    name: "Côte d’Ivoire",
    iso: "ci",
    dialCode: "+225"
  },
  {
    name: "Croatia (Hrvatska)",
    iso: "hr",
    dialCode: "+385"
  },
  {
    name: "Cuba",
    iso: "cu",
    dialCode: "+53"
  },
  {
    name: "Curaçao",
    iso: "cw",
    dialCode: "+599"
  },
  {
    name: "Cyprus (Κύπρος)",
    iso: "cy",
    dialCode: "+357"
  },
  {
    name: "Czech Republic (Česká republika)",
    iso: "cz",
    dialCode: "+420"
  },
  {
    name: "Denmark (Danmark)",
    iso: "dk",
    dialCode: "+45"
  },
  {
    name: "Djibouti",
    iso: "dj",
    dialCode: "+253"
  },
  {
    name: "Dominica",
    iso: "dm",
    dialCode: "+1767"
  },
  {
    name: "Dominican Republic (República Dominicana)",
    iso: "do",
    dialCode: "+1"
  },
  {
    name: "Ecuador",
    iso: "ec",
    dialCode: "+593"
  },
  {
    name: "Egypt (‫مصر‬‎)",
    iso: "eg",
    dialCode: "+20"
  },
  {
    name: "El Salvador",
    iso: "sv",
    dialCode: "+503"
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    iso: "gq",
    dialCode: "+240"
  },
  {
    name: "Eritrea",
    iso: "er",
    dialCode: "+291"
  },
  {
    name: "Estonia (Eesti)",
    iso: "ee",
    dialCode: "+372"
  },
  {
    name: "Ethiopia",
    iso: "et",
    dialCode: "+251"
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    iso: "fk",
    dialCode: "+500"
  },
  {
    name: "Faroe Islands (Føroyar)",
    iso: "fo",
    dialCode: "+298"
  },
  {
    name: "Fiji",
    iso: "fj",
    dialCode: "+679"
  },
  {
    name: "Finland (Suomi)",
    iso: "fi",
    dialCode: "+358"
  },
  {
    name: "France",
    iso: "fr",
    dialCode: "+33"
  },
  {
    name: "French Guiana (Guyane française)",
    iso: "gf",
    dialCode: "+594"
  },
  {
    name: "French Polynesia (Polynésie française)",
    iso: "pf",
    dialCode: "+689"
  },
  {
    name: "Gabon",
    iso: "ga",
    dialCode: "+241"
  },
  {
    name: "Gambia",
    iso: "gm",
    dialCode: "+220"
  },
  {
    name: "Georgia (საქართველო)",
    iso: "ge",
    dialCode: "+995"
  },
  Di,
  {
    name: "Ghana (Gaana)",
    iso: "gh",
    dialCode: "+233"
  },
  {
    name: "Gibraltar",
    iso: "gi",
    dialCode: "+350"
  },
  {
    name: "Greece (Ελλάδα)",
    iso: "gr",
    dialCode: "+30"
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    iso: "gl",
    dialCode: "+299"
  },
  {
    name: "Grenada",
    iso: "gd",
    dialCode: "+1473"
  },
  {
    name: "Guadeloupe",
    iso: "gp",
    dialCode: "+590"
  },
  {
    name: "Guam",
    iso: "gu",
    dialCode: "+1671"
  },
  {
    name: "Guatemala",
    iso: "gt",
    dialCode: "+502"
  },
  {
    name: "Guernsey",
    iso: "gg",
    dialCode: "+44"
  },
  {
    name: "Guinea (Guinée)",
    iso: "gn",
    dialCode: "+224"
  },
  {
    name: "Guinea-Bissau (Guiné Bissau)",
    iso: "gw",
    dialCode: "+245"
  },
  {
    name: "Guyana",
    iso: "gy",
    dialCode: "+592"
  },
  {
    name: "Haiti",
    iso: "ht",
    dialCode: "+509"
  },
  {
    name: "Honduras",
    iso: "hn",
    dialCode: "+504"
  },
  {
    name: "Hong Kong (香港)",
    iso: "hk",
    dialCode: "+852"
  },
  {
    name: "Hungary (Magyarország)",
    iso: "hu",
    dialCode: "+36"
  },
  {
    name: "Iceland (Ísland)",
    iso: "is",
    dialCode: "+354"
  },
  {
    name: "India (भारत)",
    iso: "in",
    dialCode: "+91"
  },
  {
    name: "Indonesia",
    iso: "id",
    dialCode: "+62"
  },
  {
    name: "Iran (‫ایران‬‎)",
    iso: "ir",
    dialCode: "+98"
  },
  {
    name: "Iraq (‫العراق‬‎)",
    iso: "iq",
    dialCode: "+964"
  },
  {
    name: "Ireland",
    iso: "ie",
    dialCode: "+353"
  },
  {
    name: "Isle of Man",
    iso: "im",
    dialCode: "+44"
  },
  {
    name: "Israel (‫ישראל‬‎)",
    iso: "il",
    dialCode: "+972"
  },
  {
    name: "Italy (Italia)",
    iso: "it",
    dialCode: "+39"
  },
  {
    name: "Jamaica",
    iso: "jm",
    dialCode: "+1876"
  },
  {
    name: "Japan (日本)",
    iso: "jp",
    dialCode: "+81"
  },
  {
    name: "Jersey",
    iso: "je",
    dialCode: "+44"
  },
  {
    name: "Jordan (‫الأردن‬‎)",
    iso: "jo",
    dialCode: "+962"
  },
  {
    name: "Kazakhstan (Казахстан)",
    iso: "kz",
    dialCode: "+7"
  },
  {
    name: "Kenya",
    iso: "ke",
    dialCode: "+254"
  },
  {
    name: "Kiribati",
    iso: "ki",
    dialCode: "+686"
  },
  {
    name: "Kosovo",
    iso: "xk",
    dialCode: "+383"
  },
  {
    name: "Kuwait (‫الكويت‬‎)",
    iso: "kw",
    dialCode: "+965"
  },
  {
    name: "Kyrgyzstan (Кыргызстан)",
    iso: "kg",
    dialCode: "+996"
  },
  {
    name: "Laos (ລາວ)",
    iso: "la",
    dialCode: "+856"
  },
  {
    name: "Latvia (Latvija)",
    iso: "lv",
    dialCode: "+371"
  },
  {
    name: "Lebanon (‫لبنان‬‎)",
    iso: "lb",
    dialCode: "+961"
  },
  {
    name: "Lesotho",
    iso: "ls",
    dialCode: "+266"
  },
  {
    name: "Liberia",
    iso: "lr",
    dialCode: "+231"
  },
  {
    name: "Libya (‫ليبيا‬‎)",
    iso: "ly",
    dialCode: "+218"
  },
  {
    name: "Liechtenstein",
    iso: "li",
    dialCode: "+423"
  },
  {
    name: "Lithuania (Lietuva)",
    iso: "lt",
    dialCode: "+370"
  },
  {
    name: "Luxembourg",
    iso: "lu",
    dialCode: "+352"
  },
  {
    name: "Macau (澳門)",
    iso: "mo",
    dialCode: "+853"
  },
  {
    name: "Macedonia (FYROM) (Македонија)",
    iso: "mk",
    dialCode: "+389"
  },
  {
    name: "Madagascar (Madagasikara)",
    iso: "mg",
    dialCode: "+261"
  },
  {
    name: "Malawi",
    iso: "mw",
    dialCode: "+265"
  },
  {
    name: "Malaysia",
    iso: "my",
    dialCode: "+60"
  },
  {
    name: "Maldives",
    iso: "mv",
    dialCode: "+960"
  },
  {
    name: "Mali",
    iso: "ml",
    dialCode: "+223"
  },
  {
    name: "Malta",
    iso: "mt",
    dialCode: "+356"
  },
  {
    name: "Marshall Islands",
    iso: "mh",
    dialCode: "+692"
  },
  {
    name: "Martinique",
    iso: "mq",
    dialCode: "+596"
  },
  {
    name: "Mauritania (‫موريتانيا‬‎)",
    iso: "mr",
    dialCode: "+222"
  },
  {
    name: "Mauritius (Moris)",
    iso: "mu",
    dialCode: "+230"
  },
  {
    name: "Mayotte",
    iso: "yt",
    dialCode: "+262"
  },
  {
    name: "Mexico (México)",
    iso: "mx",
    dialCode: "+52"
  },
  {
    name: "Micronesia",
    iso: "fm",
    dialCode: "+691"
  },
  {
    name: "Moldova (Republica Moldova)",
    iso: "md",
    dialCode: "+373"
  },
  {
    name: "Monaco",
    iso: "mc",
    dialCode: "+377"
  },
  {
    name: "Mongolia (Монгол)",
    iso: "mn",
    dialCode: "+976"
  },
  {
    name: "Montenegro (Crna Gora)",
    iso: "me",
    dialCode: "+382"
  },
  {
    name: "Montserrat",
    iso: "ms",
    dialCode: "+1664"
  },
  {
    name: "Morocco (‫المغرب‬‎)",
    iso: "ma",
    dialCode: "+212"
  },
  {
    name: "Mozambique (Moçambique)",
    iso: "mz",
    dialCode: "+258"
  },
  {
    name: "Myanmar (Burma) (မြန်မာ)",
    iso: "mm",
    dialCode: "+95"
  },
  {
    name: "Namibia (Namibië)",
    iso: "na",
    dialCode: "+264"
  },
  {
    name: "Nauru",
    iso: "nr",
    dialCode: "+674"
  },
  {
    name: "Nepal (नेपाल)",
    iso: "np",
    dialCode: "+977"
  },
  {
    name: "Netherlands (Nederland)",
    iso: "nl",
    dialCode: "+31"
  },
  {
    name: "New Caledonia (Nouvelle-Calédonie)",
    iso: "nc",
    dialCode: "+687"
  },
  {
    name: "New Zealand",
    iso: "nz",
    dialCode: "+64"
  },
  {
    name: "Nicaragua",
    iso: "ni",
    dialCode: "+505"
  },
  {
    name: "Niger (Nijar)",
    iso: "ne",
    dialCode: "+227"
  },
  {
    name: "Nigeria",
    iso: "ng",
    dialCode: "+234"
  },
  {
    name: "Niue",
    iso: "nu",
    dialCode: "+683"
  },
  {
    name: "Norfolk Island",
    iso: "nf",
    dialCode: "+672"
  },
  {
    name: "North Korea (조선 민주주의 인민 공화국)",
    iso: "kp",
    dialCode: "+850"
  },
  {
    name: "Northern Mariana Islands",
    iso: "mp",
    dialCode: "+1670"
  },
  {
    name: "Norway (Norge)",
    iso: "no",
    dialCode: "+47"
  },
  {
    name: "Oman (‫عُمان‬‎)",
    iso: "om",
    dialCode: "+968"
  },
  {
    name: "Pakistan (‫پاکستان‬‎)",
    iso: "pk",
    dialCode: "+92"
  },
  {
    name: "Palau",
    iso: "pw",
    dialCode: "+680"
  },
  {
    name: "Palestine (‫فلسطين‬‎)",
    iso: "ps",
    dialCode: "+970"
  },
  {
    name: "Panama (Panamá)",
    iso: "pa",
    dialCode: "+507"
  },
  {
    name: "Papua New Guinea",
    iso: "pg",
    dialCode: "+675"
  },
  {
    name: "Paraguay",
    iso: "py",
    dialCode: "+595"
  },
  {
    name: "Peru (Perú)",
    iso: "pe",
    dialCode: "+51"
  },
  {
    name: "Philippines",
    iso: "ph",
    dialCode: "+63"
  },
  {
    name: "Poland (Polska)",
    iso: "pl",
    dialCode: "+48"
  },
  {
    name: "Portugal",
    iso: "pt",
    dialCode: "+351"
  },
  {
    name: "Puerto Rico",
    iso: "pr",
    dialCode: "+1"
  },
  {
    name: "Qatar (‫قطر‬‎)",
    iso: "qa",
    dialCode: "+974"
  },
  {
    name: "Réunion (La Réunion)",
    iso: "re",
    dialCode: "+262"
  },
  {
    name: "Romania (România)",
    iso: "ro",
    dialCode: "+40"
  },
  {
    name: "Russia (Россия)",
    iso: "ru",
    dialCode: "+7"
  },
  {
    name: "Rwanda",
    iso: "rw",
    dialCode: "+250"
  },
  {
    name: "Saint Barthélemy",
    iso: "bl",
    dialCode: "+590"
  },
  {
    name: "Saint Helena",
    iso: "sh",
    dialCode: "+290"
  },
  {
    name: "Saint Kitts and Nevis",
    iso: "kn",
    dialCode: "+1869"
  },
  {
    name: "Saint Lucia",
    iso: "lc",
    dialCode: "+1758"
  },
  {
    name: "Saint Martin (Saint-Martin (partie française))",
    iso: "mf",
    dialCode: "+590"
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    iso: "pm",
    dialCode: "+508"
  },
  {
    name: "Saint Vincent and the Grenadines",
    iso: "vc",
    dialCode: "+1784"
  },
  {
    name: "Samoa",
    iso: "ws",
    dialCode: "+685"
  },
  {
    name: "San Marino",
    iso: "sm",
    dialCode: "+378"
  },
  {
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    iso: "st",
    dialCode: "+239"
  },
  {
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    iso: "sa",
    dialCode: "+966"
  },
  {
    name: "Senegal (Sénégal)",
    iso: "sn",
    dialCode: "+221"
  },
  {
    name: "Serbia (Србија)",
    iso: "rs",
    dialCode: "+381"
  },
  {
    name: "Seychelles",
    iso: "sc",
    dialCode: "+248"
  },
  {
    name: "Sierra Leone",
    iso: "sl",
    dialCode: "+232"
  },
  {
    name: "Singapore",
    iso: "sg",
    dialCode: "+65"
  },
  {
    name: "Sint Maarten",
    iso: "sx",
    dialCode: "+1721"
  },
  {
    name: "Slovakia (Slovensko)",
    iso: "sk",
    dialCode: "+421"
  },
  {
    name: "Slovenia (Slovenija)",
    iso: "si",
    dialCode: "+386"
  },
  {
    name: "Solomon Islands",
    iso: "sb",
    dialCode: "+677"
  },
  {
    name: "Somalia (Soomaaliya)",
    iso: "so",
    dialCode: "+252"
  },
  {
    name: "South Africa",
    iso: "za",
    dialCode: "+27"
  },
  {
    name: "South Korea (대한민국)",
    iso: "kr",
    dialCode: "+82"
  },
  {
    name: "South Sudan (‫جنوب السودان‬‎)",
    iso: "ss",
    dialCode: "+211"
  },
  {
    name: "Spain (España)",
    iso: "es",
    dialCode: "+34"
  },
  {
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    iso: "lk",
    dialCode: "+94"
  },
  {
    name: "Sudan (‫السودان‬‎)",
    iso: "sd",
    dialCode: "+249"
  },
  {
    name: "Suriname",
    iso: "sr",
    dialCode: "+597"
  },
  {
    name: "Svalbard and Jan Mayen",
    iso: "sj",
    dialCode: "+47"
  },
  {
    name: "Swaziland",
    iso: "sz",
    dialCode: "+268"
  },
  {
    name: "Sweden (Sverige)",
    iso: "se",
    dialCode: "+46"
  },
  {
    name: "Switzerland (Schweiz)",
    iso: "ch",
    dialCode: "+41"
  },
  {
    name: "Syria (‫سوريا‬‎)",
    iso: "sy",
    dialCode: "+963"
  },
  {
    name: "Taiwan (台灣)",
    iso: "tw",
    dialCode: "+886"
  },
  {
    name: "Tajikistan",
    iso: "tj",
    dialCode: "+992"
  },
  {
    name: "Tanzania",
    iso: "tz",
    dialCode: "+255"
  },
  {
    name: "Thailand (ไทย)",
    iso: "th",
    dialCode: "+66"
  },
  {
    name: "Timor-Leste",
    iso: "tl",
    dialCode: "+670"
  },
  {
    name: "Togo",
    iso: "tg",
    dialCode: "+228"
  },
  {
    name: "Tokelau",
    iso: "tk",
    dialCode: "+690"
  },
  {
    name: "Tonga",
    iso: "to",
    dialCode: "+676"
  },
  {
    name: "Trinidad and Tobago",
    iso: "tt",
    dialCode: "+1868"
  },
  {
    name: "Tunisia (‫تونس‬‎)",
    iso: "tn",
    dialCode: "+216"
  },
  {
    name: "Turkey (Türkiye)",
    iso: "tr",
    dialCode: "+90"
  },
  {
    name: "Turkmenistan",
    iso: "tm",
    dialCode: "+993"
  },
  {
    name: "Turks and Caicos Islands",
    iso: "tc",
    dialCode: "+1649"
  },
  {
    name: "Tuvalu",
    iso: "tv",
    dialCode: "+688"
  },
  {
    name: "U.S. Virgin Islands",
    iso: "vi",
    dialCode: "+1340"
  },
  {
    name: "Uganda",
    iso: "ug",
    dialCode: "+256"
  },
  {
    name: "Ukraine (Україна)",
    iso: "ua",
    dialCode: "+380"
  },
  {
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    iso: "ae",
    dialCode: "+971"
  },
  {
    name: "United Kingdom",
    iso: "gb",
    dialCode: "+44"
  },
  {
    name: "United States",
    iso: "us",
    dialCode: "+1"
  },
  {
    name: "Uruguay",
    iso: "uy",
    dialCode: "+598"
  },
  {
    name: "Uzbekistan (Oʻzbekiston)",
    iso: "uz",
    dialCode: "+998"
  },
  {
    name: "Vanuatu",
    iso: "vu",
    dialCode: "+678"
  },
  {
    name: "Vatican City (Città del Vaticano)",
    iso: "va",
    dialCode: "+39"
  },
  {
    name: "Venezuela",
    iso: "ve",
    dialCode: "+58"
  },
  {
    name: "Vietnam (Việt Nam)",
    iso: "vn",
    dialCode: "+84"
  },
  {
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    iso: "wf",
    dialCode: "+681"
  },
  {
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    iso: "eh",
    dialCode: "+212"
  },
  {
    name: "Yemen (‫اليمن‬‎)",
    iso: "ye",
    dialCode: "+967"
  },
  {
    name: "Zambia",
    iso: "zm",
    dialCode: "+260"
  },
  {
    name: "Zimbabwe",
    iso: "zw",
    dialCode: "+263"
  },
  {
    name: "Åland Islands",
    iso: "ax",
    dialCode: "+358"
  }
], qo = {
  items: Yu
};
function Ku(t, e) {
  return qo.items.find((a) => a[t] === e) ?? Di;
}
function $u(t) {
  return Ku("iso", t);
}
const Ju = ["title"], Aa = /* @__PURE__ */ x({
  __name: "AnwFlag",
  props: {
    country: {},
    title: {}
  },
  setup(t) {
    return (e, n) => (u(), m("span", {
      class: L("fi fi-" + e.country),
      title: e.title
    }, null, 10, Ju));
  }
}), Wu = {
  key: 0,
  class: "absolute bottom-0 left-0 z-20 mb-3 h-40 overflow-scroll border bg-white"
}, qu = ["onClick"], Xu = { class: "ms-2" }, e2 = { class: "relative w-full" }, t2 = ["id"], n2 = ["for"], a2 = {
  key: 0,
  class: "anw-invalid-feedback"
}, i2 = /* @__PURE__ */ x({
  __name: "AnwPhoneInput",
  props: {
    modelValue: { default: "" },
    errorMessage: { default: "" },
    id: {},
    label: { default: "Telefon" }
  },
  emits: ["isoCode", "update:modelValue"],
  setup(t, { emit: e }) {
    const n = e, a = t, i = N(!1), r = N(null), o = w({
      get() {
        return a.modelValue;
      },
      set(g) {
        s(g);
      }
    }), s = (g) => {
      n("update:modelValue", g);
    };
    Dn(r, () => i.value = !1);
    const l = N(Di);
    function c(g) {
      l.value = g, n("isoCode", l.value.iso), i.value = !1;
    }
    function f() {
      return $u(l.value.iso);
    }
    return (g, v) => (u(), m(U, null, [
      d("div", {
        ref_key: "target",
        ref: r,
        class: "anw-input-group"
      }, [
        d("button", {
          class: "anw-btn-phone-input after:anw-dropdown-arrow",
          type: "button",
          onClickPassive: v[0] || (v[0] = (A) => i.value = !i.value)
        }, [
          f().iso ? (u(), D(Aa, {
            key: 0,
            class: "mr-2 !w-[1.2rem]",
            country: f().iso,
            title: f().name + "Flagge"
          }, null, 8, ["country", "title"])) : T("", !0),
          J(" " + k(l.value.dialCode), 1)
        ], 32),
        i.value ? (u(), m("ul", Wu, [
          (u(!0), m(U, null, ne(p(qo).items, (A, y) => (u(), m("li", {
            key: A.iso,
            class: L([{ "border-b border-neutral-300": y === p(Gu) - 1 }, "flex cursor-pointer px-3 py-2 hover:bg-neutral-100"]),
            onClick: (_) => c(A)
          }, [
            A.iso ? (u(), D(Aa, {
              key: 0,
              class: "dropdown-item",
              country: A.iso,
              title: A.name + "Flagge"
            }, null, 8, ["country", "title"])) : T("", !0),
            d("div", Xu, k(A.name), 1)
          ], 10, qu))), 128))
        ])) : T("", !0),
        d("div", e2, [
          We(d("input", {
            id: g.id,
            "onUpdate:modelValue": v[1] || (v[1] = (A) => o.value = A),
            type: "tel",
            class: L(["anw-floating-input peer", { "anw-is-invalid": g.errorMessage }]),
            placeholder: " "
          }, null, 10, t2), [
            [Sn, o.value]
          ]),
          d("label", {
            for: g.id,
            class: "anw-floating-label"
          }, k(g.label), 9, n2)
        ])
      ], 512),
      g.errorMessage ? (u(), m("div", a2, k(g.errorMessage), 1)) : T("", !0)
    ], 64));
  }
});
var r2 = {
  prefix: "far",
  iconName: "arrow-up-long",
  icon: [384, 512, ["long-arrow-up"], "f176", "M209 7c-9.4-9.4-24.6-9.4-33.9 0L39 143c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l95-95V488c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9l95 95c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7z"]
}, o2 = {
  prefix: "far",
  iconName: "eye-slash",
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"]
}, s2 = {
  prefix: "far",
  iconName: "arrow-down-long",
  icon: [384, 512, ["long-arrow-down"], "f175", "M175 505c9.4 9.4 24.6 9.4 33.9 0L345 369c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 406.1L73 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505z"]
}, l2 = {
  prefix: "far",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24H430.1L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223V184c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
}, c2 = {
  prefix: "far",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
}, u2 = {
  prefix: "far",
  iconName: "arrow-up-arrow-down",
  icon: [576, 512, ["sort-up-down"], "e099", "M529 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55V56c0-13.3-10.7-24-24-24s-24 10.7-24 24V398.1l-55-55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55V456c0 13.3 10.7 24 24 24s24-10.7 24-24V113.9l55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39z"]
}, Xo = {
  prefix: "far",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"]
}, _r = {
  prefix: "far",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
}, Ma = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, es = {
  prefix: "far",
  iconName: "angle-up",
  icon: [448, 512, [8963], "f106", "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"]
};
const d2 = ["id", "type"], f2 = ["for"], m2 = {
  key: 0,
  class: "anw-invalid-feedback"
}, p2 = /* @__PURE__ */ x({
  inheritAttrs: !1,
  __name: "AnwInputPassword",
  props: {
    hasError: { type: Boolean, default: !1 },
    errorMessage: { default: "" },
    id: { default: "" },
    label: { default: "" },
    modelValue: { default: "" },
    wrapperClass: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = w({
      get() {
        return n.modelValue;
      },
      set(l) {
        a("update:modelValue", l);
      }
    }), r = w(() => o.value ? o2 : c2), o = N(!1), s = () => {
      o.value = !o.value;
    };
    return (l, c) => (u(), m("div", {
      class: L(["relative mb-3", l.wrapperClass])
    }, [
      We(d("input", ge(l.$attrs, {
        id: l.id,
        "onUpdate:modelValue": c[0] || (c[0] = (f) => i.value = f),
        type: o.value ? "text" : "password",
        placeholder: " ",
        class: ["anw-floating-input peer pe-9", { "anw-is-invalid": l.hasError }]
      }), null, 16, d2), [
        [lo, i.value]
      ]),
      d("label", {
        for: l.id,
        class: "anw-floating-label"
      }, k(l.label), 9, f2),
      l.hasError ? (u(), m("div", m2, k(l.errorMessage), 1)) : T("", !0),
      d("span", {
        class: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500",
        onClick: s
      }, [
        M(p(Q), {
          icon: r.value,
          "fixed-width": ""
        }, null, 8, ["icon"])
      ])
    ], 2));
  }
});
var an = {
  prefix: "fal",
  iconName: "angle-right",
  icon: [320, 512, [8250], "f105", "M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"]
}, g2 = {
  prefix: "fal",
  iconName: "link-simple",
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C89.3 128 32 185.3 32 256s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zM152 240H424c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, h2 = {
  prefix: "fal",
  iconName: "globe",
  icon: [512, 512, [127760], "f0ac", "M256 480c16.7 0 40.4-14.4 61.9-57.3c9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7C215.6 465.6 239.3 480 256 480zM164.3 320H347.7c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zM170 160H342c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3C184.2 109.1 175.9 133 170 160zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3c21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3C126.7 63.1 79.4 105.5 53.6 160h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zM327.5 468.3c57.8-19.5 105-61.8 130.9-116.3H374.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
}, v2 = {
  prefix: "fal",
  iconName: "image",
  icon: [512, 512, [], "f03e", "M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
}, A2 = {
  prefix: "fal",
  iconName: "angles-right",
  icon: [512, 512, [187, "angle-double-right"], "f101", "M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160l160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"]
}, b2 = {
  prefix: "fal",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
}, w2 = {
  prefix: "fal",
  iconName: "envelope",
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
}, C2 = {
  prefix: "fal",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
}, y2 = {
  prefix: "fal",
  iconName: "angle-down",
  icon: [448, 512, [8964], "f107", "M212.7 363.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 329.4 75.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z"]
}, k2 = {
  prefix: "fal",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
}, x2 = {
  prefix: "fal",
  iconName: "award-simple",
  icon: [384, 512, [], "e0ab", "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3 .8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5 .8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2 .5c-18.3 .4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2 .5c3.3 .1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9L96.4 76.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2 .5c6.4 .2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2 .5c-9.4 .2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM88 390c9.7 4.3 20.3 6.6 31.3 6.8l-16.6 72 83-35.6c4-1.7 8.6-1.7 12.6 0l83 35.6-16.6-72c10.9-.2 21.5-2.5 31.3-6.8l23.6 102.4c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9L88 390z"]
}, E2 = {
  prefix: "fal",
  iconName: "angles-left",
  icon: [512, 512, [171, "angle-double-left"], "f100", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 235.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160l-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 427.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
}, S2 = {
  prefix: "fal",
  iconName: "clone",
  icon: [512, 512, [], "f24d", "M64 480H288c17.7 0 32-14.3 32-32V384h32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v32H64c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32zM224 320H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32zm-64-32V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"]
}, ts = {
  prefix: "fal",
  iconName: "scale-balanced",
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M384 64c0 29.8-20.4 54.9-48 62V480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H320 112c-8.8 0-16-7.2-16-16s7.2-16 16-16H304V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16H264.6C275.6 12.9 296.3 0 320 0s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3C457.8 375.1 482.9 384 512 384s54.2-8.9 71.3-21.7C600.4 349.5 608 334.2 608 320H416v-1.6l0 .1V320c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288H597.7L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96s-128-43-128-96zM32 320c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7C216.4 349.5 224 334.2 224 320H32v-1.6l0 .1V320zm10.3-32H213.7L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6V320c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, Ia = {
  prefix: "fal",
  iconName: "angle-left",
  icon: [320, 512, [8249], "f104", "M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z"]
}, T2 = {
  prefix: "fal",
  iconName: "clapperboard-play",
  icon: [512, 512, [], "e132", "M480 192V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192H480zm0-32H382.6l87.3-87.3C476.1 78.5 480 86.8 480 96v64zm-249.4 0l96-96H433.4l-96 96H230.6zm-45.3 0H78.6l96-96H281.4l-96 96zM64 64h65.4l-96 96H32V96c0-17.7 14.3-32 32-32zm448 96V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64 16 16V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192 176 160zM216.1 226.2c-4.9-2.9-11.1-2.9-16.1-.1s-8.1 8.1-8.1 13.9V400c0 5.7 3.1 11 8.1 13.9s11.1 2.8 16.1-.1l136-80c4.9-2.9 7.9-8.1 7.9-13.8s-3-10.9-7.9-13.8l-136-80zM312.4 320L224 372V268l88.4 52z"]
}, ns = {
  prefix: "fal",
  iconName: "video",
  icon: [576, 512, ["video-camera"], "f03d", "M64 96c-17.7 0-32 14.3-32 32V384c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64v47.2V336.8 384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM519.4 411.3L416 354.4V317.9l118.8 65.4c.9 .5 1.9 .8 3 .8c3.4 0 6.2-2.8 6.2-6.2V134.2c0-3.4-2.8-6.2-6.2-6.2c-1 0-2.1 .3-3 .8L416 194.1V157.6l103.4-56.9c5.6-3.1 12-4.7 18.4-4.7c21.1 0 38.2 17.1 38.2 38.2V377.8c0 21.1-17.1 38.2-38.2 38.2c-6.4 0-12.8-1.6-18.4-4.7z"]
}, as = {
  prefix: "fal",
  iconName: "graduation-cap",
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M307.2 66.2L47.6 160l74 26.7c10.3-6.9 21.5-12.6 33.4-17.1l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6L166.2 199.6c-1.5 .5-2.9 1.1-4.3 1.7l145.3 52.5c4.1 1.5 8.4 2.2 12.8 2.2s8.7-.8 12.8-2.2L592.4 160 332.8 66.2c-4.1-1.5-8.4-2.2-12.8-2.2s-8.7 .8-12.8 2.2zM296.3 283.9L126.9 222.7C99.4 246 82.1 279.9 80.2 316.9c5.9 13.2 10.2 27.5 13.4 41.5c6.4 27.6 10.7 65.9 2.1 108.7c-.9 4.3-3.4 8-7.1 10.4s-8.2 3.1-12.4 2l-64-16c-5.2-1.3-9.4-5.1-11.2-10.2s-.9-10.7 2.3-14.9c8.6-11.7 16-24.6 22.5-37.6C37.2 377.8 48 348.4 48 320c0-.6 0-1.2 .1-1.8c1.4-41 18-79.1 45.1-107.7L15.8 182.6C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1L624.2 137.4c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zm-122-10L160.4 406.3c.7 .8 1.8 2.1 3.7 3.7c6 5.2 16.5 11.5 31.9 17.5C226.4 439.4 270.3 448 320 448s93.6-8.6 124.1-20.6c15.4-6 25.8-12.3 31.9-17.5c1.9-1.6 3-2.8 3.7-3.7L465.7 273.8l31-11.2L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 31 11.2zM480.5 405a.2 .2 0 1 0 -.3-.1 .2 .2 0 1 0 .3 .1zm-321 0a.1 .1 0 1 0 .2 0 .1 .1 0 1 0 -.2 0zM67 444.2c2.5-20.7 1.7-40-.5-56.7c-3.8 10-8 19.3-12.1 27.6c-3.8 7.6-7.9 15.2-12.5 22.8L67 444.2z"]
};
const $ = {
  TOPIC: "topic",
  LOCATION: "location"
};
function M2(t, e) {
  const n = (y) => {
    const _ = document.createElement("DIV");
    return _.innerHTML = y, _.textContent || _.innerText || "";
  }, a = w({
    get: () => t.modelValue[$.TOPIC],
    set: (y) => e("update:modelValue", { ...t.modelValue, [$.TOPIC]: n(y) })
  }), i = w({
    get: () => t.modelValue[$.LOCATION],
    set: (y) => e("update:modelValue", { ...t.modelValue, [$.LOCATION]: n(y) })
  }), r = N({
    [$.TOPIC]: !1,
    [$.LOCATION]: !1
  }), o = {
    [$.TOPIC]: t.topicMaxSuggestions ?? 1 / 0,
    [$.LOCATION]: t.locationMaxSuggestions ?? 1 / 0
  }, s = {
    [$.TOPIC]: t.topicVisibleOverflow,
    [$.LOCATION]: t.locationVisibleOverflow
  };
  return {
    topic: a,
    location: i,
    isDropdownOpen: r,
    maxSuggestions: o,
    visibleOverflow: s,
    closeDropdown: (y) => {
      window.setTimeout(() => {
        r.value[y] = !1;
      }, 100);
    },
    openDropdown: (y) => {
      r.value[y] = !0;
    },
    handleInput: (y, _) => {
      e("input", { field: y, value: _ });
    },
    handleSuggestionSelect: (y, _) => {
      r.value[y] = !1, e("update:modelValue", { ...t.modelValue, [y]: n(_) });
    },
    handleLocationIconClick: () => {
      e("location-icon-clicked");
    },
    handleSearch: () => {
      e("search", { [$.TOPIC]: a.value, [$.LOCATION]: i.value });
    }
  };
}
const I2 = ["onMousedown", "innerHTML"], Or = /* @__PURE__ */ x({
  __name: "SearchDropdown",
  props: {
    suggestions: {},
    isOpen: { type: Boolean },
    maxSuggestions: {},
    visibleOverflow: { type: Boolean }
  },
  emits: ["select"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = N(null), r = w(
      () => n.maxSuggestions === null || n.visibleOverflow ? n.suggestions : n.suggestions.slice(0, n.maxSuggestions)
    ), o = w(() => ["anw-search-bar__dropdown", { "overflow-y-auto": n.visibleOverflow }]);
    yn(() => {
      if (!i.value) return;
      const c = n.maxSuggestions ?? 1 / 0, f = i.value.querySelectorAll("li"), g = f.length > c ? f[c - 1].offsetTop + f[c - 1].offsetHeight : null;
      i.value.style.maxHeight = g ? `${g}px` : n.visibleOverflow ? "300px" : "none";
    });
    const l = (c) => {
      a("select", c);
    };
    return (c, f) => c.isOpen && c.suggestions.length ? (u(), m("ul", {
      key: 0,
      ref_key: "dropdownRef",
      ref: i,
      class: L(o.value)
    }, [
      d("div", null, [
        (u(!0), m(U, null, ne(r.value, (g) => (u(), m("li", {
          key: g,
          onMousedown: (v) => l(g),
          innerHTML: g
        }, null, 40, I2))), 128))
      ])
    ], 2)) : T("", !0);
  }
}), L2 = ["title"], _2 = {
  class: "top-50 start-50 absolute h-4 -translate-x-1/2 -translate-y-1/2",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, O2 = {
  key: 0,
  d: "M0 256H224V480h48L432 48 0 208v48z",
  fill: "url(#locationGradient)"
}, P2 = {
  key: 1,
  d: `M272 208l0 48 0 85.8 78.7-212.5L138.2 208l85.8 0 48 0zM0 208L372.7 70 432 48l-22 59.3L272 480l-48 0 0-48
        0-128 0-48-48 0L48 256 0 256l0-48z`,
  fill: "url(#locationGradient)"
}, B2 = /* @__PURE__ */ x({
  __name: "LocationButton",
  props: {
    allowLocation: { type: Boolean }
  },
  emits: ["location-icon-clicked"],
  setup(t, { emit: e }) {
    const n = e;
    return (a, i) => (u(), m("button", {
      class: "anw-location rounded-0 absolute bottom-0 end-0 top-0 z-20 border-0 bg-transparent px-5",
      type: "button",
      title: a.allowLocation ? "Sie haben Ihren Standort bereits freigegeben" : "Ihren Standort freigeben",
      onClick: i[0] || (i[0] = (r) => n("location-icon-clicked"))
    }, [
      (u(), m("svg", _2, [
        i[1] || (i[1] = d("defs", null, [
          d("linearGradient", { id: "locationGradient" }, [
            d("stop", { offset: "57%" }),
            d("stop", { offset: "100%" })
          ])
        ], -1)),
        a.allowLocation ? (u(), m("path", O2)) : (u(), m("path", P2))
      ]))
    ], 8, L2));
  }
}), R2 = { class: "anw-search-bar md:flex" }, N2 = { class: "relative mb-3 grow md:mb-0" }, D2 = ["id"], H2 = ["for"], F2 = { class: "relative mb-3 grow md:mb-0" }, V2 = ["id"], z2 = ["for"], U2 = { class: "relative mb-3 md:mb-0" }, Q2 = /* @__PURE__ */ x({
  __name: "AnwSearchBar",
  props: {
    allowLocation: { type: Boolean, default: !1 },
    modelValue: { default: () => ({ [$.TOPIC]: "", [$.LOCATION]: "" }) },
    topicSuggestions: { default: () => [] },
    locationSuggestions: { default: () => [] },
    topicMaxSuggestions: { default: null },
    locationMaxSuggestions: { default: null },
    topicVisibleOverflow: { type: Boolean, default: !0 },
    locationVisibleOverflow: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "search", "input", "location-icon-clicked"],
  setup(t, { emit: e }) {
    const n = t, a = e, {
      isDropdownOpen: i,
      maxSuggestions: r,
      visibleOverflow: o,
      location: s,
      topic: l,
      closeDropdown: c,
      openDropdown: f,
      handleInput: g,
      handleSuggestionSelect: v,
      handleLocationIconClick: A,
      handleSearch: y
    } = M2(n, a);
    return (_, C) => (u(), m("div", R2, [
      d("div", N2, [
        We(d("input", {
          id: p($).TOPIC,
          "onUpdate:modelValue": C[0] || (C[0] = (b) => Xi(l) ? l.value = b : null),
          class: "anw-floating-input peer rounded-xl border-neutral-400 bg-white md:rounded-e-none md:border-e-0",
          placeholder: " ",
          onInput: C[1] || (C[1] = (b) => p(g)(p($).TOPIC, b.target.value)),
          onFocus: C[2] || (C[2] = (b) => p(f)(p($).TOPIC)),
          onBlur: C[3] || (C[3] = (b) => p(c)(p($).TOPIC))
        }, null, 40, D2), [
          [Sn, p(l)]
        ]),
        d("label", {
          class: "anw-floating-label text-neutral-400",
          for: p($).TOPIC
        }, [
          M(p(Q), {
            icon: p(_r),
            class: "mr-1.5 inline-block"
          }, null, 8, ["icon"]),
          C[11] || (C[11] = J(" Rechtsthema / Name "))
        ], 8, H2),
        M(Or, {
          suggestions: _.topicSuggestions,
          "is-open": p(i)[p($).TOPIC],
          "max-suggestions": p(r)[p($).TOPIC],
          "visible-overflow": p(o)[p($).TOPIC],
          onSelect: C[4] || (C[4] = (b) => p(v)(p($).TOPIC, b))
        }, null, 8, ["suggestions", "is-open", "max-suggestions", "visible-overflow"])
      ]),
      d("div", F2, [
        We(d("input", {
          id: p($).LOCATION,
          "onUpdate:modelValue": C[5] || (C[5] = (b) => Xi(s) ? s.value = b : null),
          class: "anw-floating-input peer rounded-xl border-neutral-400 bg-white pe-10 md:rounded-none",
          placeholder: " ",
          onInput: C[6] || (C[6] = (b) => p(g)(p($).LOCATION, b.target.value)),
          onFocus: C[7] || (C[7] = (b) => p(f)(p($).LOCATION)),
          onBlur: C[8] || (C[8] = (b) => p(c)(p($).LOCATION))
        }, null, 40, V2), [
          [Sn, p(s)]
        ]),
        d("label", {
          class: "anw-floating-label text-neutral-400",
          for: p($).LOCATION
        }, [
          M(p(Q), {
            icon: p(k2),
            class: "mr-1.5 inline-block"
          }, null, 8, ["icon"]),
          C[12] || (C[12] = J(" PLZ / Ort "))
        ], 8, z2),
        M(Or, {
          suggestions: _.locationSuggestions,
          "is-open": p(i)[p($).LOCATION],
          "max-suggestions": p(r)[p($).LOCATION],
          "visible-overflow": p(o)[p($).LOCATION],
          onSelect: C[9] || (C[9] = (b) => p(v)(p($).LOCATION, b))
        }, null, 8, ["suggestions", "is-open", "max-suggestions", "visible-overflow"]),
        M(B2, {
          "allow-location": _.allowLocation,
          onLocationIconClicked: p(A)
        }, null, 8, ["allow-location", "onLocationIconClicked"])
      ]),
      d("div", U2, [
        d("button", {
          "aria-label": "Search",
          class: "anw-gradient-primary anw-btn h-full w-full rounded-xl !px-16 font-bold text-white focus:ring-4 focus:ring-pink/20 focus:ring-offset-0 focus-visible:ring-primary/60 md:rounded-e-xl md:rounded-s-none",
          type: "button",
          onClick: C[10] || (C[10] = //@ts-ignore
          (...b) => p(y) && p(y)(...b))
        }, [
          M(p(Q), {
            class: L(["text-[16px]", "mr-3 inline-block"]),
            icon: p(_r)
          }, null, 8, ["icon"]),
          C[13] || (C[13] = J(" Suchen "))
        ])
      ])
    ]));
  }
}), j2 = ["data-testid"], Hi = /* @__PURE__ */ x({
  __name: "AnwButton",
  props: {
    label: {},
    appearance: { default: "primary" },
    size: { default: "xl" },
    icon: { default: null },
    iconPosition: { default: "left" },
    iconClass: { default: "" },
    iconSize: { default: "16" },
    testid: {}
  },
  setup(t) {
    const e = t, n = w(() => ({
      "": !0,
      "anw-btn-primary": e.appearance === "primary",
      "anw-btn-secondary": e.appearance === "secondary",
      "anw-btn-primary-outline": e.appearance === "primaryOutline",
      "anw-btn-secondary-outline": e.appearance === "secondaryOutline",
      "anw-btn-neutral-outline": e.appearance === "neutralOutline",
      "anw-btn-link-color": e.appearance === "linkColor",
      "anw-btn-clean": e.appearance === "clean",
      "anw-btn-link": e.appearance === "link",
      "anw-btn-sm": e.size === "sm",
      "anw-btn-md": e.size === "md",
      "anw-btn-lg": e.size === "lg",
      "anw-btn-xl": e.size === "xl",
      "anw-btn-2xl": e.size === "2xl"
    }));
    return (a, i) => (u(), m("button", {
      type: "button",
      class: L(["anw-btn", n.value]),
      "data-testid": a.testid ? a.testid : void 0
    }, [
      a.iconPosition === "left" && a.icon ? (u(), D(p(Q), {
        key: 0,
        icon: a.icon,
        class: L([`${a.iconClass} text-[${a.iconSize}px]`, "mr-1.5 inline-block"]),
        "aria-hidden": "true"
      }, null, 8, ["icon", "class"])) : T("", !0),
      J(" " + k(a.label) + " ", 1),
      a.iconPosition === "right" && a.icon ? (u(), D(p(Q), {
        key: 1,
        icon: a.icon,
        class: L([`${a.iconClass} text-[${a.iconSize}px]`, "ml-1.5 inline-block"]),
        "aria-hidden": "true"
      }, null, 8, ["icon", "class"])) : T("", !0)
    ], 10, j2));
  }
}), Z2 = { class: "sr-only" }, G2 = /* @__PURE__ */ x({
  __name: "AnwRoundButton",
  props: {
    appearance: { default: "default" },
    size: { default: "xl" },
    backgroundColor: { default: "default" },
    border: { default: "default" },
    srLabel: {},
    icon: { default: null },
    iconSize: { default: "26" }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "anw-btn-round-default": e.appearance === "default",
      "anw-btn-round-full": e.appearance === "rounded-full",
      border: e.border === "default",
      "anw-btn-bg-default": e.backgroundColor === "default",
      "anw-btn-bg-info-200": e.backgroundColor === "bg-info-200",
      "anw-btn-sm": e.size === "sm",
      "anw-btn-md": e.size === "md",
      "anw-btn-lg": e.size === "lg",
      "anw-btn-xl": e.size === "xl",
      "anw-btn-2xl": e.size === "2xl"
    }));
    return (a, i) => (u(), m("button", {
      type: "button",
      class: L(["anw-btn-round", n.value])
    }, [
      d("span", Z2, k(a.srLabel), 1),
      M(p(Q), {
        icon: a.icon,
        class: L([`text-[${a.iconSize}px]`, "!align-middle"]),
        height: a.iconSize,
        width: a.iconSize,
        "aria-hidden": "true"
      }, null, 8, ["icon", "class", "height", "width"])
    ], 2));
  }
}), Y2 = {
  type: "button",
  class: "anw-btn-gradient"
}, K2 = { class: "w-12" }, is = /* @__PURE__ */ x({
  __name: "AnwGradientButton",
  setup(t) {
    return (e, n) => (u(), m("button", Y2, [
      d("span", K2, [
        M(p(Q), {
          icon: p(Yc),
          class: "anw-btn-gradient-icon"
        }, null, 8, ["icon"])
      ]),
      n[0] || (n[0] = d("span", null, [
        J("Video"),
        d("span", { class: "anw-btn-gradient-text" }, " ansehen")
      ], -1))
    ]));
  }
}), $2 = {
  "aria-label": "Breadcrumbs",
  class: "anw-steps-wrapper"
}, J2 = { class: "anw-steps" }, W2 = {
  key: 0,
  class: "anw-step-return",
  "aria-hidden": "true"
}, q2 = { class: "anw-step-label" }, X2 = {
  key: 1,
  class: "anw-step-current-label"
}, ed = { class: "anw-step-label" }, td = /* @__PURE__ */ x({
  __name: "AnwProgressNavigation",
  props: {
    currentStepName: {},
    steps: {},
    clickableSteps: { type: Boolean, default: !0 },
    isBackButtonShown: { type: Boolean, default: !0 }
  },
  setup(t) {
    const e = t, n = (o) => ({
      "anw-step-done": a(o),
      "anw-step-current": i(o)
    }), a = (o) => {
      const s = Object.keys(e.steps);
      return s.indexOf(o) < s.indexOf(e.currentStepName);
    }, i = (o) => {
      const s = Object.keys(e.steps);
      return s.indexOf(o) === s.indexOf(e.currentStepName);
    }, r = (o) => Object.keys(e.steps).indexOf(e.currentStepName) - 1 === o;
    return (o, s) => {
      const l = _s("RouterLink");
      return u(), m("nav", $2, [
        d("ol", J2, [
          (u(!0), m(U, null, ne(o.steps, (c, f, g) => (u(), m("li", {
            key: f,
            class: "anw-step"
          }, [
            o.clickableSteps && (r(Number(g)) || f === o.currentStepName) ? (u(), D(l, {
              key: 0,
              to: { name: c.name },
              class: L(["anw-step-link", n(String(f))])
            }, {
              default: le(() => [
                o.clickableSteps && r(Number(g)) ? (u(), m(U, { key: 0 }, [
                  o.isBackButtonShown ? (u(), m("span", W2, [
                    M(p(Q), {
                      icon: p(Ia),
                      class: "text-base",
                      "aria-hidden": "true"
                    }, null, 8, ["icon"])
                  ])) : T("", !0),
                  d("span", q2, [
                    s[0] || (s[0] = d("span", { class: "sr-only" }, "Return to", -1)),
                    J(" " + k(c.title), 1)
                  ])
                ], 64)) : (u(), m("span", X2, k(c.title), 1))
              ]),
              _: 2
            }, 1032, ["to", "class"])) : (u(), m("span", {
              key: 1,
              class: L(["anw-step-link", n(String(f))])
            }, [
              d("span", ed, k(c.title), 1)
            ], 2)),
            g != Object.keys(o.steps).length - 1 ? (u(), D(p(Q), {
              key: 2,
              icon: p(an),
              class: "hidden text-base text-neutral-500 xl:block",
              "aria-hidden": "true"
            }, null, 8, ["icon"])) : T("", !0)
          ]))), 128))
        ])
      ]);
    };
  }
});
var rs = /* @__PURE__ */ ((t) => (t.COMPANY = "company", t.USER = "user", t))(rs || {}), Wt = /* @__PURE__ */ ((t) => (t[t.FEMALE = 2] = "FEMALE", t[t.MALE = 1] = "MALE", t))(Wt || {});
const nd = {
  firstName: "",
  lastName: "",
  name: "",
  formattedName: "",
  image: "",
  ratingAverage: 0,
  numberOfRatings: 0,
  offersOnlineAdvice: !0,
  links: [],
  isRateable: !0,
  companyName: "",
  profileShortUrl: "",
  title: "",
  suffix: ""
}, wa = class wa {
  static set profileInformation(e) {
    this._uuid = e.uuid, this._actorType = e.actorType;
  }
  static get uuid() {
    return this._uuid;
  }
  static get actorType() {
    return this._actorType;
  }
};
wa._uuid = "", wa._actorType = "";
let Ue = wa;
const Qe = {
  ACTOR_TYPE: rs,
  IMAGE_CDN_HOST: {
    development: "https://dev-images.anwalt.de",
    staging: "https://stage.www.anwalt.de",
    production: "https://www.anwalt.de"
  }
}, ea = {
  [Wt.FEMALE]: "Rechtsanwältin",
  [Wt.MALE]: "Rechtsanwalt",
  [Qe.ACTOR_TYPE.COMPANY]: "Kanzlei"
}, ke = zs("Profile", {
  state: () => ({
    profile: { ...nd },
    practiceAreas: [],
    isPracticeAreasLoaded: !1,
    isPracticeAreasError: !1,
    isProfileLoaded: !1,
    isProfileError: !1
  }),
  getters: {
    getDisplayedName: (t) => Ue.actorType === Qe.ACTOR_TYPE.COMPANY ? t.profile.companyName : t.profile.title + " " + t.profile.formattedName + " " + t.profile.suffix,
    getProfileImage: (t) => {
      var e, n;
      return ((n = (e = t.profile.links) == null ? void 0 : e.find((a) => a.rel === "profileImage")) == null ? void 0 : n.href) || "";
    },
    getProfileUrl: (t) => {
      var e, n;
      return ((n = (e = t.profile.links) == null ? void 0 : e.find((a) => a.rel === "profileUrl")) == null ? void 0 : n.href) || "";
    },
    getProfileTitle: (t) => Ue.actorType === Qe.ACTOR_TYPE.COMPANY ? `Ihre ${ea[Qe.ACTOR_TYPE.COMPANY]}` : t.profile.sexId === Wt.MALE ? `Ihr ${ea[Wt.MALE]}` : `Ihre ${ea[Wt.FEMALE]}`,
    getTitleAttribute: (t) => Ue.actorType === Qe.ACTOR_TYPE.COMPANY ? t.profile.companyName : `${ea[t.profile.sexId]} ${t.profile.formattedName}`,
    showErrorComponent: (t) => t.isPracticeAreasError || t.isProfileError
  }
}), ad = { class: "flex justify-between" }, id = { class: "mt-0.5" }, rd = { class: "text-sm text-neutral-700" }, od = /* @__PURE__ */ x({
  __name: "BasicVariant",
  props: {
    ratingAverage: {},
    numberOfRatings: {},
    ratingText: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", ad, [
      M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"]),
      d("div", id, [
        d("span", rd, k(Intl.NumberFormat("de-DE").format(e.numberOfRatings)) + " " + k(e.ratingText), 1)
      ])
    ]));
  }
}), sd = { class: "mt-1" }, ld = {
  key: 0,
  class: "font-semibold"
}, cd = { class: "text-neutral-700" }, ud = /* @__PURE__ */ x({
  __name: "WithMaxRatingVariant",
  props: {
    ratingAverage: {},
    numberOfRatings: {},
    ratingText: {}
  },
  setup(t) {
    return (e, n) => (u(), m(U, null, [
      M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"]),
      d("div", sd, [
        e.ratingAverage > 0 ? (u(), m("span", ld, k(Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(e.ratingAverage)) + "/" + k(p(po)), 1)) : T("", !0),
        d("span", cd, " (" + k(Intl.NumberFormat("de-DE").format(e.numberOfRatings)) + " " + k(e.ratingText) + ") ", 1)
      ])
    ], 64));
  }
}), dd = {
  key: 0,
  class: "font-semibold"
}, fd = /* @__PURE__ */ x({
  __name: "WithoutMaxRatingVariant",
  props: {
    ratingAverage: {},
    numberOfRatings: {},
    ratingText: {},
    ratingUrl: {},
    layoutClass: {},
    hasInlineRating: { type: Boolean },
    hasMobileFontSize: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (u(), D(ht(e.ratingUrl ? "a" : "div"), {
      href: e.ratingUrl,
      class: L([{ "anw-text-link": e.ratingUrl }, e.hasInlineRating ? e.layoutClass || "flex flex-wrap gap-x-2 xl:block" : ""])
    }, {
      default: le(() => {
        var a;
        return [
          M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"]),
          d("div", {
            class: L(["text-neutral-700", [
              e.hasInlineRating ? (a = e.layoutClass) != null && a.includes("xl:flex") ? "mt-0.5 flex-shrink-0" : "mt-0.5 flex-shrink-0 xl:mt-1" : "mt-1",
              { "mt-1 text-sm xl:mt-1 xl:text-base": e.hasMobileFontSize }
            ]])
          }, [
            e.ratingAverage > 0 ? (u(), m("span", dd, k(Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(e.ratingAverage)), 1)) : T("", !0),
            n[0] || (n[0] = J(" • ")),
            d("span", null, k(Intl.NumberFormat("de-DE").format(e.numberOfRatings)) + " " + k(e.ratingText), 1)
          ], 2)
        ];
      }),
      _: 1
    }, 8, ["href", "class"]));
  }
}), Pr = {
  BASIC: "basic",
  WITHOUT_MAX_RATING: "withoutMaxRating"
}, Hn = /* @__PURE__ */ x({
  __name: "AnwRatingCount",
  props: {
    ratingAverage: {},
    numberOfRatings: {},
    ratingVariant: { default: "withMaxRating" },
    hasInlineRating: { type: Boolean },
    layoutClass: { default: "" },
    ratingUrl: { default: "" },
    hasMobileFontSize: { type: Boolean }
  },
  setup(t) {
    const e = t, n = w(() => {
      switch (e.ratingVariant) {
        case Pr.BASIC:
          return od;
        case Pr.WITHOUT_MAX_RATING:
          return fd;
        default:
          return ud;
      }
    }), a = w(() => e.numberOfRatings === 1 ? "Bewertung" : "Bewertungen");
    return (i, r) => (u(), D(ht(n.value), {
      "has-inline-rating": i.hasInlineRating,
      "rating-average": i.ratingAverage,
      "rating-text": a.value,
      "number-of-ratings": i.numberOfRatings,
      "rating-url": i.ratingUrl,
      "layout-class": i.layoutClass,
      "has-mobile-font-size": i.hasMobileFontSize
    }, null, 8, ["has-inline-rating", "rating-average", "rating-text", "number-of-ratings", "rating-url", "layout-class", "has-mobile-font-size"]));
  }
}), md = { class: "mb-6 text-sm text-neutral-700" }, pd = { class: "mb-3 flex justify-items-start" }, gd = { class: "relative flex gap-4 xl:items-center" }, hd = ["alt", "src"], vd = ["href", "title"], os = /* @__PURE__ */ x({
  __name: "ProfileInformation",
  setup(t) {
    const { getProfileImage: e, getProfileTitle: n, getTitleAttribute: a, profile: i, getDisplayedName: r, getProfileUrl: o } = ke(), s = w(() => !!e), l = lt("mode"), c = w(() => {
      const f = Ue.actorType === Qe.ACTOR_TYPE.USER ? "cover" : "scale-down";
      return `${Qe.IMAGE_CDN_HOST[l] ?? ""}/cdn-cgi/image/format=auto,fit=${f},width=80,height=80${e}`;
    });
    return (f, g) => (u(), m(U, null, [
      d("div", md, k(p(n)), 1),
      d("div", pd, [
        d("div", gd, [
          d("figure", null, [
            s.value ? (u(), m("img", {
              key: 0,
              alt: "Bild von " + p(r),
              src: c.value,
              class: "rounded-xl",
              height: "80",
              width: "80"
            }, null, 8, hd)) : T("", !0)
          ]),
          d("div", null, [
            d("a", {
              href: p(o),
              title: p(a),
              class: "anw-stretch-link anw-text-link text-lg font-semibold",
              target: "_blank"
            }, k(p(r)), 9, vd),
            p(i).isRateable && p(i).numberOfRatings > 0 ? (u(), D(Hn, {
              key: 0,
              "rating-average": p(i).ratingAverage,
              "number-of-ratings": p(i).numberOfRatings
            }, null, 8, ["rating-average", "number-of-ratings"])) : T("", !0)
          ])
        ])
      ])
    ], 64));
  }
}), wt = /* @__PURE__ */ x({
  __name: "AnwHeading",
  props: {
    heading: {},
    icon: { default: null },
    tag: { default: "p" },
    headingClasses: { default: "" },
    counter: { default: 0 }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "mb-2 flex items-center gap-2 line break-normal text-sm/[22px] font-semibold": !0,
      [e.headingClasses]: !!e.headingClasses
    })), a = w(() => ({
      "rounded-full border border-neutral-200 bg-neutral-50 text-neutral-700 text-sm/[20px] py-0.5 px-2.5 -ml-0.5 font-normal": !0
    }));
    return (i, r) => (u(), D(ht(i.tag), {
      class: L(n.value)
    }, {
      default: le(() => [
        i.icon ? (u(), D(p(Q), {
          key: 0,
          icon: i.icon,
          class: "shrink-0",
          "aria-hidden": "true"
        }, null, 8, ["icon"])) : T("", !0),
        J(" " + k(i.heading) + " ", 1),
        i.counter ? (u(), m("span", {
          key: 1,
          class: L(a.value)
        }, k(Intl.NumberFormat("de-DE").format(i.counter)), 3)) : T("", !0)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Ad = {
  key: 1,
  width: "4",
  height: "4",
  viewBox: "0 0 4 4",
  class: "fill-neutral-300",
  xmlns: "http://www.w3.org/2000/svg"
}, On = /* @__PURE__ */ x({
  __name: "AnwLists",
  props: {
    args: {},
    appearance: { default: "pills" },
    background: { default: "info" },
    flags: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "gap-1.5": e.appearance === "pills",
      "gap-x-2 gap-y-1": e.appearance === "dots"
    })), a = w(() => ({
      "anw-badge": e.appearance === "pills",
      "anw-item-dot": e.appearance === "dots",
      "bg-info-50": e.background === "info" && e.appearance === "pills",
      "bg-neutral-50": e.background === "neutral" && e.appearance === "pills"
    }));
    return (i, r) => (u(), m("ul", {
      class: L(["flex flex-wrap", n.value])
    }, [
      (u(!0), m(U, null, ne(i.args, (o, s) => (u(), m("li", {
        key: s,
        class: L(a.value)
      }, [
        e.flags && o.iso ? (u(), D(Aa, {
          key: 0,
          country: o.iso,
          class: "h-[12px]",
          "aria-hidden": "true"
        }, null, 8, ["country"])) : T("", !0),
        J(" " + k(o.content) + " ", 1),
        e.appearance === "dots" && s !== i.args.length - 1 ? (u(), m("svg", Ad, r[0] || (r[0] = [
          d("circle", {
            cx: "2",
            cy: "2",
            r: "1.5"
          }, null, -1)
        ]))) : T("", !0)
      ], 2))), 128))
    ], 2));
  }
}), bd = {
  key: 0,
  class: "mt-12"
}, wd = /* @__PURE__ */ x({
  __name: "ProfilePracticeAreas",
  props: {
    practiceAreas: {},
    offersOnlineAdvice: { type: Boolean }
  },
  setup(t) {
    const e = t, n = w(() => e.practiceAreas.filter((r) => !!r.isSpecialPracticeArea).map((r) => ({
      content: r.name
    }))), a = w(
      () => e.practiceAreas.map((i) => ({
        content: i.name
      }))
    );
    return (i, r) => (u(), m(U, null, [
      n.value.length > 0 ? (u(), m("div", bd, [
        M(wt, {
          heading: "Fachanwalt:",
          icon: p(as)
        }, null, 8, ["icon"]),
        M(On, {
          appearance: "dots",
          args: n.value
        }, null, 8, ["args"])
      ])) : T("", !0),
      i.practiceAreas.length > 0 ? (u(), m("div", {
        key: 1,
        class: L(n.value.length === 0 ? "mt-12" : "mt-6")
      }, [
        M(wt, {
          heading: "Rechtsgebiete:",
          icon: p(ts)
        }, null, 8, ["icon"]),
        M(On, {
          appearance: "dots",
          args: a.value
        }, null, 8, ["args"])
      ], 2)) : T("", !0)
    ], 64));
  }
}), Br = js.create({
  withCredentials: !1,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
}), Cd = "/practice-areas", yd = "/api/practice_areas.json", kd = {
  [Qe.ACTOR_TYPE.COMPANY]: "/api/companies/",
  [Qe.ACTOR_TYPE.USER]: "/api/users/"
}, xd = {
  [Qe.ACTOR_TYPE.COMPANY]: "/api/company_profile.json",
  [Qe.ACTOR_TYPE.USER]: "/api/user_profile.json"
}, Ua = (t) => t === "development" ? { PROFILE: xd, PRACTICE_AREA: yd } : { PROFILE: kd, PRACTICE_AREA: Cd };
class di {
  static async getPracticeAreas(e) {
    const n = (e !== "development" ? "" : Ua(e).PROFILE[Ue.actorType] + Ue.uuid) + Ua(e).PRACTICE_AREA;
    try {
      ke().isPracticeAreasError = !1, ke().practiceAreas = (await Br.get(n)).data;
    } catch {
      ke().isPracticeAreasError = !0;
    } finally {
      ke().isPracticeAreasLoaded = !0;
    }
  }
  static async getProfile(e) {
    const n = Ua(e).PROFILE[Ue.actorType] + (e === "development" ? "" : Ue.uuid);
    try {
      ke().isProfileError = !1, ke().profile = (await Br.get(n)).data;
    } catch {
      ke().isProfileError = !0;
    } finally {
      ke().isProfileLoaded = !0;
    }
  }
}
const Ed = {
  key: 0,
  class: "mt-6 flex gap-2"
}, Sd = /* @__PURE__ */ x({
  __name: "ProfileOnlineAdvice",
  props: {
    offersOnlineAdvice: { type: Boolean }
  },
  setup(t) {
    return (e, n) => e.offersOnlineAdvice ? (u(), m("div", Ed, [
      M(wt, {
        heading: "Online-Rechtsberatung",
        icon: p(ns),
        class: "mb-0"
      }, null, 8, ["icon"])
    ])) : T("", !0);
  }
}), Td = { key: 0 }, Md = { key: 1 }, Id = /* @__PURE__ */ x({
  __name: "FullProfileView",
  setup(t) {
    const e = ke(), { profile: n, practiceAreas: a, isProfileLoaded: i, isPracticeAreasLoaded: r, showErrorComponent: o } = mo(e), s = lt("mode");
    return (async () => (i.value || await di.getProfile(s), r.value || await di.getPracticeAreas(s)))(), (l, c) => p(o) ? (u(), m("div", Td, "Die Profilinformationen konnten nicht geladen werden.")) : (u(), m("div", Md, [
      p(i) ? (u(), D(os, { key: 0 })) : T("", !0),
      p(r) ? (u(), D(wd, {
        key: 1,
        "practice-areas": p(a),
        "offers-online-advice": p(n).offersOnlineAdvice
      }, null, 8, ["practice-areas", "offers-online-advice"])) : T("", !0),
      p(i) ? (u(), D(Sd, {
        key: 2,
        "offers-online-advice": p(n).offersOnlineAdvice
      }, null, 8, ["offers-online-advice"])) : T("", !0)
    ]));
  }
}), Ld = { key: 0 }, _d = { key: 1 }, Od = /* @__PURE__ */ x({
  __name: "ShortProfileView",
  setup(t) {
    const e = ke(), { isProfileLoaded: n, showErrorComponent: a } = mo(e), i = lt("mode");
    return (async () => n.value || await di.getProfile(i))(), (r, o) => p(a) ? (u(), m("div", Ld, "Die Profilinformationen konnten nicht geladen werden.")) : (u(), m("div", _d, [
      p(n) ? (u(), D(os, { key: 0 })) : T("", !0),
      pe(r.$slots, "default")
    ]));
  }
}), Pd = {
  class: "anw-placeholder",
  role: "status"
}, Bd = { key: 0 }, Rd = {
  key: 1,
  class: "space-y-2.5"
}, Nd = {
  key: 2,
  class: "space-y-4 divide-y divide-neutral-200"
}, Dd = { key: 3 }, Hd = { key: 4 }, Fd = { key: 5 }, qt = /* @__PURE__ */ x({
  __name: "AnwPlaceholder",
  props: {
    appearance: { default: "generic" }
  },
  setup(t) {
    const e = t;
    return (n, a) => (u(), m("div", Pd, [
      e.appearance === "generic" ? (u(), m("div", Bd, a[0] || (a[0] = [
        Ie('<div class="mb-4 h-2 w-3/5 w-48 rounded-full bg-neutral-200"></div><div class="mb-2.5 h-2 w-4/5 rounded-full bg-neutral-200"></div><div class="mb-2.5 h-2 w-3/4 rounded-full bg-neutral-200"></div><div class="mb-2.5 h-2 w-3/5 rounded-full bg-neutral-200"></div><div class="mb-2.5 h-2 w-4/5 rounded-full bg-neutral-200"></div><div class="h-2 w-3/5 rounded-full bg-neutral-200"></div>', 6)
      ]))) : T("", !0),
      e.appearance === "text" ? (u(), m("div", Rd, a[1] || (a[1] = [
        Ie('<div class="flex w-4/5 items-center space-x-2"><div class="h-2.5 w-32 rounded-full bg-neutral-200"></div><div class="h-2.5 w-24 rounded-full bg-neutral-300"></div><div class="h-2.5 w-full rounded-full bg-neutral-300"></div></div><div class="flex w-3/4 items-center space-x-2"><div class="h-2.5 w-full rounded-full bg-neutral-200"></div><div class="h-2.5 w-full rounded-full bg-neutral-300"></div><div class="h-2.5 w-24 rounded-full bg-neutral-300"></div></div><div class="flex w-4/5 items-center space-x-2"><div class="h-2.5 w-full rounded-full bg-neutral-300"></div><div class="h-2.5 w-80 rounded-full bg-neutral-200"></div><div class="h-2.5 w-full rounded-full bg-neutral-300"></div></div><div class="flex w-3/4 items-center space-x-2"><div class="h-2.5 w-full rounded-full bg-neutral-200"></div><div class="h-2.5 w-full rounded-full bg-neutral-300"></div><div class="h-2.5 w-24 rounded-full bg-neutral-300"></div></div><div class="flex w-3/5 items-center space-x-2"><div class="h-2.5 w-32 rounded-full bg-neutral-300"></div><div class="h-2.5 w-24 rounded-full bg-neutral-300"></div><div class="h-2.5 w-full rounded-full bg-neutral-200"></div></div><div class="flex w-2/4 items-center space-x-2"><div class="h-2.5 w-full rounded-full bg-neutral-300"></div><div class="h-2.5 w-80 rounded-full bg-neutral-200"></div><div class="h-2.5 w-full rounded-full bg-neutral-300"></div></div>', 6)
      ]))) : T("", !0),
      e.appearance === "list" ? (u(), m("div", Nd, a[2] || (a[2] = [
        Ie('<div class="flex items-center justify-between"><div><div class="mb-2.5 h-2.5 w-24 rounded-full bg-neutral-300"></div><div class="h-2 w-32 rounded-full bg-neutral-200"></div></div><div class="h-2.5 w-12 rounded-full bg-neutral-300"></div></div><div class="flex items-center justify-between pt-4"><div><div class="mb-2.5 h-2.5 w-24 rounded-full bg-neutral-300"></div><div class="h-2 w-32 rounded-full bg-neutral-200"></div></div><div class="h-2.5 w-12 rounded-full bg-neutral-300"></div></div>', 2)
      ]))) : T("", !0),
      e.appearance === "image" ? (u(), m("div", Dd, a[3] || (a[3] = [
        d("div", { class: "flex h-48 w-full items-center justify-center rounded bg-neutral-300" }, [
          d("svg", {
            class: "h-12 w-12 text-neutral-200",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            fill: "currentColor",
            viewBox: "0 0 640 512"
          }, [
            d("path", { d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" })
          ])
        ], -1)
      ]))) : T("", !0),
      e.appearance === "avatar" ? (u(), m("div", Hd, a[4] || (a[4] = [
        Ie('<div class="flex items-center space-x-3"><svg class="h-14 w-14 text-neutral-200" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z" clip-rule="evenodd"></path></svg><div class="w-full"><div class="mb-2 h-2.5 rounded-full bg-neutral-200"></div><div class="h-2 w-48 rounded-full bg-neutral-200"></div></div></div>', 1)
      ]))) : T("", !0),
      e.appearance === "video" ? (u(), m("div", Fd, a[5] || (a[5] = [
        d("div", { class: "flex h-56 items-center justify-center rounded-xl bg-neutral-300" }, [
          d("svg", {
            class: "h-12 w-12 text-neutral-200",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true",
            fill: "currentColor",
            viewBox: "0 0 384 512"
          }, [
            d("path", { d: "M361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215z" })
          ])
        ], -1)
      ]))) : T("", !0),
      a[6] || (a[6] = d("span", { class: "sr-only" }, "Wird geladen...", -1))
    ]));
  }
}), Vd = /* @__PURE__ */ x({
  __name: "PlaceholderShort",
  setup(t) {
    return (e, n) => (u(), D(qt, {
      appearance: "avatar",
      class: "mb-3"
    }));
  }
}), zd = /* @__PURE__ */ x({
  __name: "PlaceholderFull",
  setup(t) {
    return (e, n) => (u(), m(U, null, [
      M(qt, {
        appearance: "avatar",
        class: "mb-6"
      }),
      M(qt, {
        appearance: "list",
        class: "mb-3"
      }),
      M(qt, {
        appearance: "list",
        class: "mb-3"
      })
    ], 64));
  }
}), Ud = { class: "anw-card h-full" }, Qd = /* @__PURE__ */ x({
  __name: "AnwProfileSummary",
  props: {
    profile: { default: () => {
    } },
    practiceAreas: { default: () => [] },
    uuid: {},
    actorType: {},
    component: { default: "short" },
    mode: { default: "production" }
  },
  setup(t) {
    const e = t, n = w(() => e.component === "short" ? Od : Id), a = w(() => e.component === "short" ? Vd : zd), { uuid: i, actorType: r } = st(e);
    return Ue.profileInformation = { uuid: i.value, actorType: r.value }, Ai("mode", e.mode), Os(() => {
      var o;
      if (!Us()) {
        const s = (o = Ca()) == null ? void 0 : o.appContext.app, l = Qs();
        s == null || s.use(l);
      }
      e.profile && (ke().isProfileLoaded = !0, ke().profile = e.profile), e.practiceAreas && (ke().isPracticeAreasLoaded = !0, ke().practiceAreas = e.practiceAreas);
    }), (o, s) => (u(), m("div", Ud, [
      n.value ? (u(), D(Ps, { key: 0 }, [
        (u(), D(Bs, null, {
          fallback: le(() => [
            (u(), D(ht(a.value)))
          ]),
          default: le(() => [
            (u(), D(ht(n.value), null, {
              default: le(() => [
                pe(o.$slots, "default")
              ]),
              _: 3
            }))
          ]),
          _: 3
        }))
      ], 1024)) : T("", !0)
    ]));
  }
});
var en = /* @__PURE__ */ ((t) => (t.COMPANY = "company", t.LAWYER = "lawyer", t))(en || {}), Pt = /* @__PURE__ */ ((t) => (t.FEMALE = "Female", t.MALE = "Male", t))(Pt || {}), ss = /* @__PURE__ */ ((t) => (t.PROD = "prod", t.STAGE = "stage", t.DEV = "dev", t))(ss || {});
const jd = (t) => {
  const e = (l) => l.filter(Boolean).join(" "), { firstname: n, lastname: a, titleAcademicPre: i, titleAcademicPost: r } = t, o = w(() => e([i, n, a, r])), s = w(() => e([n, a]));
  return {
    getFullNameWithTitle: o,
    getFirstNameAndLastName: s
  };
}, Qa = {
  [Pt.FEMALE]: "Rechtsanwältin",
  [Pt.MALE]: "Rechtsanwalt",
  [en.COMPANY]: "Kanzlei"
}, Zd = (t, e, n) => {
  const a = w(() => t === en.COMPANY), i = w(() => a.value ? `${Qa[en.COMPANY]}` : e.sex === Pt.MALE ? `${Qa[Pt.MALE]}` : `${Qa[Pt.FEMALE]}`), r = w(() => a.value ? `Ihre ${i.value}` : e.sex === Pt.MALE ? `Ihr ${i.value}` : `Ihre ${i.value}`), o = w(() => {
    if (n) {
      const s = a.value ? "scale-down" : "cover";
      return `${n}/cdn-cgi/image/format=auto,fit=${s},width=80,height=80${e.imagePath}`;
    }
    return "";
  });
  return {
    getJobType: i,
    getJobTypeWithGenderPronouns: r,
    getProfileImageSrc: o
  };
}, Gd = { class: "mb-6 text-sm text-neutral-700" }, Yd = { class: "mb-3 flex justify-items-start" }, Kd = { class: "relative flex gap-4 xl:items-center" }, $d = ["alt", "src"], Jd = ["href", "title"], Wd = /* @__PURE__ */ x({
  __name: "ProfileInformation",
  props: {
    profile: {},
    mode: {},
    actorType: {},
    imagesCdnUrl: {}
  },
  setup(t) {
    const e = t, { getProfileImageSrc: n, getJobTypeWithGenderPronouns: a, getJobType: i } = Zd(
      e.actorType,
      e.profile,
      e.imagesCdnUrl
    ), { getFullNameWithTitle: r } = jd(e.profile), o = w(() => e.actorType === en.COMPANY), s = w(() => `${i.value} ${r.value}`), l = w(() => o.value ? e.profile.name : s.value);
    return (c, f) => (u(), m(U, null, [
      d("div", Gd, k(p(a)), 1),
      d("div", Yd, [
        d("div", Kd, [
          d("figure", null, [
            c.profile.imagePath ? (u(), m("img", {
              key: 0,
              alt: `Bild von ${l.value}`,
              src: p(n),
              class: "rounded-xl",
              height: "80",
              width: "80"
            }, null, 8, $d)) : T("", !0)
          ]),
          d("div", null, [
            d("a", {
              href: c.profile.uri,
              title: l.value,
              class: "anw-stretch-link anw-text-link text-lg font-semibold",
              target: "_blank"
            }, k(o.value ? c.profile.name : p(r)), 9, Jd),
            c.profile.isRateable && c.profile.ratingCount > 0 ? (u(), D(Hn, {
              key: 0,
              "rating-average": c.profile.ratingAverage,
              "number-of-ratings": c.profile.ratingCount
            }, null, 8, ["rating-average", "number-of-ratings"])) : T("", !0)
          ])
        ])
      ])
    ], 64));
  }
}), qd = {
  key: 0,
  class: "mt-12"
}, Xd = /* @__PURE__ */ x({
  __name: "ProfilePracticeAreas",
  props: {
    practiceAreas: {}
  },
  setup(t) {
    const e = t, n = w(() => e.practiceAreas.filter((r) => !!r.isSpecialPracticeArea).map((r) => ({
      content: r.name
    }))), a = w(
      () => e.practiceAreas.map((i) => ({
        content: i.name
      }))
    );
    return (i, r) => (u(), m(U, null, [
      n.value.length > 0 ? (u(), m("div", qd, [
        M(wt, {
          heading: "Fachanwalt:",
          icon: p(as)
        }, null, 8, ["icon"]),
        M(On, {
          appearance: "dots",
          args: n.value
        }, null, 8, ["args"])
      ])) : T("", !0),
      i.practiceAreas.length > 0 ? (u(), m("div", {
        key: 1,
        class: L(n.value.length === 0 ? "mt-12" : "mt-6")
      }, [
        M(wt, {
          heading: "Rechtsgebiete:",
          icon: p(ts)
        }, null, 8, ["icon"]),
        M(On, {
          appearance: "dots",
          args: a.value
        }, null, 8, ["args"])
      ], 2)) : T("", !0)
    ], 64));
  }
}), e0 = { class: "anw-card h-full" }, t0 = { key: 0 }, n0 = { key: 1 }, a0 = {
  key: 0,
  class: "mt-6 flex gap-2"
}, i0 = /* @__PURE__ */ x({
  __name: "AnwProfileSummarySidebar",
  props: {
    profile: { default: null },
    actorType: { default: en.LAWYER },
    mode: { default: ss.PROD },
    imagesCdnUrl: {},
    isProfileError: { type: Boolean, default: !1 }
  },
  setup(t) {
    return (e, n) => {
      var a;
      return u(), m("div", e0, [
        e.isProfileError ? (u(), m("div", t0, "Die Profilinformationen konnten nicht geladen werden.")) : (u(), m("div", n0, [
          M(Wd, {
            mode: e.mode,
            profile: e.profile,
            "actor-type": e.actorType,
            "images-cdn-url": e.imagesCdnUrl
          }, null, 8, ["mode", "profile", "actor-type", "images-cdn-url"]),
          M(Xd, {
            "practice-areas": e.profile.practiceAreaList
          }, null, 8, ["practice-areas"]),
          (a = e.profile) != null && a.offersOnlineAdvice ? (u(), m("div", a0, [
            M(wt, {
              heading: "Online-Rechtsberatung",
              icon: p(ns),
              class: "mb-0"
            }, null, 8, ["icon"])
          ])) : T("", !0)
        ]))
      ]);
    };
  }
}), r0 = { class: "ml-auto" }, o0 = /* @__PURE__ */ x({
  __name: "AnwAccordion",
  props: {
    label: { default: "" },
    appearance: { default: "white" },
    size: { default: "small" }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "bg-white": e.appearance === "white",
      "bg-info-50": e.appearance === "info",
      "anw-accordion-small": e.size === "small",
      "anw-accordion-large": e.size === "large"
    })), a = w(() => ({
      "text-neutral-900": e.appearance === "white",
      "text-neutral-800": e.appearance === "info"
    })), i = w(() => e.appearance === "white" ? "fill-info-500" : "fill-neutral-800"), r = w(() => e.size === "small" ? "20" : "22"), o = w(() => ({
      "text-neutral-500": e.appearance === "white",
      "text-neutral-700": e.appearance === "info"
    }));
    return (s, l) => (u(), m("details", {
      class: L(["anw-accordion", n.value])
    }, [
      d("summary", {
        class: L(["flex cursor-pointer l ist-none items-center gap-x-2.5 outline-offset-[-2px]", a.value])
      }, [
        pe(s.$slots, "icon"),
        J(" " + k(s.label) + " ", 1),
        d("span", r0, [
          M(p(Q), {
            icon: p(y2),
            class: L([i.value, `text-[${r.value}px]`])
          }, null, 8, ["icon", "class"])
        ])
      ], 2),
      d("div", {
        class: L(["anw-content", o.value])
      }, [
        pe(s.$slots, "default")
      ], 2)
    ], 2));
  }
}), s0 = { class: "anw-accordion-plus relative rounded-[16px]" }, l0 = { class: "pl-4 pr-14 py-3 lg:pl-6 lg:py-7 flex cursor-pointer list-none items-center after:rounded-[16px] after:bg-size-[22px] after:h-[22px] after:w-[22px] after:absolute after:right-4 after:lg:right-[30px] after:transform after:rotate-90 after:content[''] after:transition-transform after:duration-200 rounded-[16px] bg-white" }, c0 = { class: "text-lg anw-hyphens" }, u0 = { class: "px-4 pb-4 lg:px-6 lg:pb-7 lg:-mt-4 text-base" }, d0 = /* @__PURE__ */ x({
  __name: "AnwAccordionPlus",
  props: {
    label: { default: "" }
  },
  setup(t) {
    const e = t;
    return (n, a) => (u(), m("details", s0, [
      d("summary", l0, [
        d("span", c0, k(e.label), 1)
      ]),
      d("div", u0, [
        pe(n.$slots, "default")
      ])
    ]));
  }
}), f0 = ["data-testid"], m0 = ["innerHTML"], ls = /* @__PURE__ */ x({
  __name: "AnwAlert",
  props: {
    label: {},
    appearance: { default: "info" },
    width: { default: "full" },
    rounded: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !0 },
    testid: {},
    iconComponent: { default: null }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "": !0,
      "anw-alert-info": e.appearance === "info",
      "anw-alert-error": e.appearance === "error",
      "anw-alert-success": e.appearance === "success",
      "anw-alert-content": e.width === "content",
      "anw-alert-fluid": e.width === "full",
      "anw-alert-rounded": e.rounded
    }));
    return (a, i) => (u(), m("div", {
      class: L(["anw-alert flex items-center", n.value]),
      role: "alert",
      "data-testid": a.testid ? a.testid : void 0
    }, [
      a.icon ? (u(), D(p(Q), {
        key: 0,
        icon: a.iconComponent || p(C2),
        class: "mr-2 shrink-0 text-[19px]"
      }, null, 8, ["icon"])) : T("", !0),
      d("span", {
        class: "anw-text-p1 font-semibold",
        innerHTML: a.label
      }, null, 8, m0)
    ], 10, f0));
  }
}), p0 = ["alt", "src", "width", "height", "data-testid"], fi = /* @__PURE__ */ x({
  __name: "AnwAvatar",
  props: {
    src: {},
    alt: {},
    size: {},
    aspect: { default: "square" },
    appearance: { default: "square" },
    testid: { default: "" }
  },
  setup(t) {
    const e = t, n = {
      sm: {
        width: 24,
        height: 24
      },
      md: {
        width: 40,
        height: 40
      },
      lg: {
        width: 80,
        height: 80
      },
      xl: {
        width: 120,
        height: 120
      },
      "2xl": {
        width: 176,
        height: 176
      },
      "3xl": {
        width: 180,
        height: 180
      }
    }, a = w(() => {
      const i = {
        circle: "rounded-full",
        square: e.size === "lg" || e.size === "xl" || e.size === "2xl" ? "rounded-xl" : "rounded"
      };
      return {
        "aspect-square": e.aspect === "square",
        [i[e.appearance]]: !0
      };
    });
    return (i, r) => (u(), m("img", {
      alt: i.alt,
      src: i.src,
      class: L(a.value),
      width: n[e.size].width,
      height: n[e.size].height,
      "data-testid": i.testid
    }, null, 10, p0));
  }
}), g0 = { class: "mb-4 flex items-center gap-2 border-b pb-3" }, h0 = { class: "mb-4" }, La = /* @__PURE__ */ x({
  __name: "AnwModal",
  props: {
    heading: { default: "" },
    isModalOpen: { type: Boolean, default: !1 },
    icon: { default: null }
  },
  emits: ["update:isModalOpen"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = N(null), r = () => {
      var c;
      (c = i.value) == null || c.showModal(), a("update:isModalOpen", !0);
    }, o = () => {
      var c;
      (c = i.value) == null || c.close(), a("update:isModalOpen", !1);
    }, s = (c) => {
      c.key === "Escape" && o();
    }, l = (c) => {
      var A;
      const f = (A = i.value) == null ? void 0 : A.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      ), g = f[0], v = f[f.length - 1];
      c.shiftKey && document.activeElement === g ? (v.focus(), c.preventDefault()) : !c.shiftKey && document.activeElement === v && (g.focus(), c.preventDefault());
    };
    return be(
      () => n.isModalOpen,
      (c, f) => {
        c !== f && (c ? r() : o());
      },
      { immediate: !0 }
    ), Ct(() => {
      document.addEventListener("keyup", (c) => s(c));
    }), ya(() => {
      document.removeEventListener("keyup", (c) => s(c));
    }), (c, f) => (u(), m("dialog", {
      ref_key: "dialogRef",
      ref: i,
      class: "anw-modal",
      onKeydown: fa(l, ["tab"])
    }, [
      d("header", g0, [
        c.heading ? (u(), D(wt, {
          key: 0,
          heading: c.heading,
          icon: c.icon,
          class: L("!mb-0")
        }, null, 8, ["heading", "icon"])) : T("", !0),
        d("button", {
          type: "button",
          class: "ml-auto flex h-6 w-6 items-center justify-center",
          onClick: Pn(o, ["prevent"])
        }, [
          f[0] || (f[0] = d("span", { class: "sr-only" }, "Dialog schließen", -1)),
          M(p(Q), {
            icon: p(Ma),
            class: "text-[24px]"
          }, null, 8, ["icon"])
        ])
      ]),
      d("div", h0, [
        pe(c.$slots, "default")
      ])
    ], 544));
  }
}), v0 = ["alt", "src"], A0 = /* @__PURE__ */ x({
  __name: "AnwAvatarVideo",
  props: {
    src: {},
    alt: {},
    modalHeading: {}
  },
  setup(t) {
    const e = N(!1), n = () => e.value = !e.value;
    return (a, i) => (u(), m(U, null, [
      d("div", {
        class: "group w-fit shadow-lg",
        onClick: i[0] || (i[0] = (r) => e.value = !e.value)
      }, [
        d("img", {
          alt: a.alt,
          src: a.src,
          class: "h-[120px] w-[120px] cursor-pointer rounded-t-xl object-cover object-center outline outline-1 outline-offset-[-1px] outline-[rgba(0,0,0,0.08)] md:h-[180px] md:w-[180px]"
        }, null, 8, v0),
        M(is)
      ]),
      M(La, {
        "is-modal-open": e.value,
        "onUpdate:isModalOpen": i[1] || (i[1] = (r) => e.value = r),
        heading: a.modalHeading,
        icon: p(T2)
      }, {
        default: le(() => [
          pe(a.$slots, "video", {
            toggleLightbox: n,
            isOpen: e.value
          })
        ]),
        _: 3
      }, 8, ["is-modal-open", "heading", "icon"])
    ], 64));
  }
}), b0 = { class: "self-top w-16 flex-shrink-0 md:w-11 xl:w-20" }, w0 = ["href", "title"], C0 = { class: "flex flex-col justify-center" }, y0 = {
  key: 0,
  class: "text-xs text-neutral-600"
}, k0 = ["href", "title"], x0 = {
  key: 2,
  class: "text-pretty anw-hyphens font-bold xl:text-lg"
}, E0 = /* @__PURE__ */ x({
  __name: "AnwAvatarRating",
  props: {
    profileImageSrc: {},
    alt: {},
    titleAtrribute: {},
    displayName: {},
    hasRating: { type: Boolean },
    hasInlineRating: { type: Boolean, default: !0 },
    ratingAverage: {},
    numberOfRatings: {},
    ratingSrc: {},
    profileSrc: {},
    profileProductIdText: { default: "" },
    hasMobileFontSize: { type: Boolean }
  },
  setup(t) {
    const e = t;
    return (n, a) => (u(), m("div", {
      class: L([{ "xl:items-top": n.hasRating }, "mb-3 flex gap-4"])
    }, [
      d("div", b0, [
        n.profileSrc ? (u(), m("a", {
          key: 0,
          href: n.profileSrc,
          title: n.titleAtrribute,
          class: "inline-block"
        }, [
          M(fi, {
            alt: n.alt,
            src: n.profileImageSrc,
            size: "xl",
            aspect: "square",
            class: "aspect-square !object-contain outline outline-1 outline-[rgba(0,0,0,0.08)]"
          }, null, 8, ["alt", "src"])
        ], 8, w0)) : (u(), D(fi, {
          key: 1,
          alt: n.alt,
          src: n.profileImageSrc,
          size: "xl",
          aspect: "square",
          class: "aspect-square !object-contain outline outline-1 outline-[rgba(0,0,0,0.08)]"
        }, null, 8, ["alt", "src"]))
      ]),
      d("div", C0, [
        n.profileProductIdText ? (u(), m("p", y0, k(n.profileProductIdText), 1)) : T("", !0),
        n.profileSrc ? (u(), m("a", {
          key: 1,
          href: n.profileSrc,
          title: n.titleAtrribute,
          class: "text-pretty anw-hyphens font-bold text-info-500 hover:text-info-500 xl:text-lg"
        }, k(n.displayName), 9, k0)) : (u(), m("span", x0, k(n.displayName), 1)),
        n.hasRating ? (u(), D(Hn, {
          key: 3,
          "has-inline-rating": e.hasInlineRating,
          "rating-average": n.ratingAverage,
          "number-of-ratings": n.numberOfRatings,
          "rating-variant": "withoutMaxRating",
          "rating-url": n.ratingSrc,
          "has-mobile-font-size": n.hasMobileFontSize
        }, null, 8, ["has-inline-rating", "rating-average", "number-of-ratings", "rating-url", "has-mobile-font-size"])) : T("", !0)
      ])
    ], 2));
  }
});
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */
const {
  entries: cs,
  setPrototypeOf: Rr,
  isFrozen: S0,
  getPrototypeOf: T0,
  getOwnPropertyDescriptor: M0
} = Object;
let {
  freeze: xe,
  seal: Re,
  create: us
} = Object, {
  apply: mi,
  construct: pi
} = typeof Reflect < "u" && Reflect;
xe || (xe = function(e) {
  return e;
});
Re || (Re = function(e) {
  return e;
});
mi || (mi = function(e, n, a) {
  return e.apply(n, a);
});
pi || (pi = function(e, n) {
  return new e(...n);
});
const ta = Ee(Array.prototype.forEach), I0 = Ee(Array.prototype.lastIndexOf), Nr = Ee(Array.prototype.pop), mn = Ee(Array.prototype.push), L0 = Ee(Array.prototype.splice), ua = Ee(String.prototype.toLowerCase), ja = Ee(String.prototype.toString), Dr = Ee(String.prototype.match), pn = Ee(String.prototype.replace), _0 = Ee(String.prototype.indexOf), O0 = Ee(String.prototype.trim), Fe = Ee(Object.prototype.hasOwnProperty), ye = Ee(RegExp.prototype.test), gn = P0(TypeError);
function Ee(t) {
  return function(e) {
    e instanceof RegExp && (e.lastIndex = 0);
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      a[i - 1] = arguments[i];
    return mi(t, e, a);
  };
}
function P0(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++)
      n[a] = arguments[a];
    return pi(t, n);
  };
}
function Y(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ua;
  Rr && Rr(t, null);
  let a = e.length;
  for (; a--; ) {
    let i = e[a];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (S0(e) || (e[a] = r), i = r);
    }
    t[i] = !0;
  }
  return t;
}
function B0(t) {
  for (let e = 0; e < t.length; e++)
    Fe(t, e) || (t[e] = null);
  return t;
}
function It(t) {
  const e = us(null);
  for (const [n, a] of cs(t))
    Fe(t, n) && (Array.isArray(a) ? e[n] = B0(a) : a && typeof a == "object" && a.constructor === Object ? e[n] = It(a) : e[n] = a);
  return e;
}
function hn(t, e) {
  for (; t !== null; ) {
    const a = M0(t, e);
    if (a) {
      if (a.get)
        return Ee(a.get);
      if (typeof a.value == "function")
        return Ee(a.value);
    }
    t = T0(t);
  }
  function n() {
    return null;
  }
  return n;
}
const Hr = xe(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Za = xe(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Ga = xe(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), R0 = xe(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ya = xe(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), N0 = xe(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Fr = xe(["#text"]), Vr = xe(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ka = xe(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), zr = xe(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), na = xe(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), D0 = Re(/\{\{[\w\W]*|[\w\W]*\}\}/gm), H0 = Re(/<%[\w\W]*|[\w\W]*%>/gm), F0 = Re(/\$\{[\w\W]*/gm), V0 = Re(/^data-[\-\w.\u00B7-\uFFFF]+$/), z0 = Re(/^aria-[\-\w]+$/), ds = Re(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), U0 = Re(/^(?:\w+script|data):/i), Q0 = Re(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fs = Re(/^html$/i), j0 = Re(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Ur = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: z0,
  ATTR_WHITESPACE: Q0,
  CUSTOM_ELEMENT: j0,
  DATA_ATTR: V0,
  DOCTYPE_NAME: fs,
  ERB_EXPR: H0,
  IS_ALLOWED_URI: ds,
  IS_SCRIPT_OR_DATA: U0,
  MUSTACHE_EXPR: D0,
  TMPLIT_EXPR: F0
});
const vn = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, Z0 = function() {
  return typeof window > "u" ? null : window;
}, G0 = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let a = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (a = n.getAttribute(i));
  const r = "dompurify" + (a ? "#" + a : "");
  try {
    return e.createPolicy(r, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, Qr = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function ms() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Z0();
  const e = (H) => ms(H);
  if (e.version = "3.2.5", e.removed = [], !t || !t.document || t.document.nodeType !== vn.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const a = n, i = a.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: o,
    Node: s,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: f = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: g,
    DOMParser: v,
    trustedTypes: A
  } = t, y = l.prototype, _ = hn(y, "cloneNode"), C = hn(y, "remove"), b = hn(y, "nextSibling"), S = hn(y, "childNodes"), F = hn(y, "parentNode");
  if (typeof o == "function") {
    const H = n.createElement("template");
    H.content && H.content.ownerDocument && (n = H.content.ownerDocument);
  }
  let V, j = "";
  const {
    implementation: q,
    createNodeIterator: X,
    createDocumentFragment: we,
    getElementsByTagName: ce
  } = n, {
    importNode: Pe
  } = a;
  let W = Qr();
  e.isSupported = typeof cs == "function" && typeof F == "function" && q && q.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: qe,
    ERB_EXPR: rn,
    TMPLIT_EXPR: ut,
    DATA_ATTR: Se,
    ARIA_ATTR: Oa,
    IS_SCRIPT_OR_DATA: yt,
    ATTR_WHITESPACE: Fn,
    CUSTOM_ELEMENT: Ze
  } = Ur;
  let {
    IS_ALLOWED_URI: kt
  } = Ur, re = null;
  const Xe = Y({}, [...Hr, ...Za, ...Ga, ...Ya, ...Fr]);
  let ue = null;
  const on = Y({}, [...Vr, ...Ka, ...zr, ...na]);
  let ee = Object.seal(us(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), dt = null, sn = null, Vn = !0, Dt = !0, zn = !1, ln = !0, et = !1, Ht = !0, Ne = !1, Be = !1, cn = !1, ft = !1, xt = !1, Ft = !1, un = !0, Un = !1;
  const Pa = "user-content-";
  let Ge = !0, Le = !1, _e = {}, mt = null;
  const dn = Y({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let pt = null;
  const Vt = Y({}, ["audio", "video", "img", "source", "image", "track"]);
  let Et = null;
  const St = Y({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), zt = "http://www.w3.org/1998/Math/MathML", Ut = "http://www.w3.org/2000/svg", De = "http://www.w3.org/1999/xhtml";
  let Tt = De, Qt = !1, Mt = null;
  const I = Y({}, [zt, Ut, De], ja);
  let R = Y({}, ["mi", "mo", "mn", "ms", "mtext"]), z = Y({}, ["annotation-xml"]);
  const G = Y({}, ["title", "style", "font", "a", "script"]);
  let Z = null;
  const de = ["application/xhtml+xml", "text/html"], he = "text/html";
  let K = null, He = null;
  const Ba = n.createElement("form"), Qn = function(h) {
    return h instanceof RegExp || h instanceof Function;
  }, Ra = function() {
    let h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(He && He === h)) {
      if ((!h || typeof h != "object") && (h = {}), h = It(h), Z = // eslint-disable-next-line unicorn/prefer-includes
      de.indexOf(h.PARSER_MEDIA_TYPE) === -1 ? he : h.PARSER_MEDIA_TYPE, K = Z === "application/xhtml+xml" ? ja : ua, re = Fe(h, "ALLOWED_TAGS") ? Y({}, h.ALLOWED_TAGS, K) : Xe, ue = Fe(h, "ALLOWED_ATTR") ? Y({}, h.ALLOWED_ATTR, K) : on, Mt = Fe(h, "ALLOWED_NAMESPACES") ? Y({}, h.ALLOWED_NAMESPACES, ja) : I, Et = Fe(h, "ADD_URI_SAFE_ATTR") ? Y(It(St), h.ADD_URI_SAFE_ATTR, K) : St, pt = Fe(h, "ADD_DATA_URI_TAGS") ? Y(It(Vt), h.ADD_DATA_URI_TAGS, K) : Vt, mt = Fe(h, "FORBID_CONTENTS") ? Y({}, h.FORBID_CONTENTS, K) : dn, dt = Fe(h, "FORBID_TAGS") ? Y({}, h.FORBID_TAGS, K) : {}, sn = Fe(h, "FORBID_ATTR") ? Y({}, h.FORBID_ATTR, K) : {}, _e = Fe(h, "USE_PROFILES") ? h.USE_PROFILES : !1, Vn = h.ALLOW_ARIA_ATTR !== !1, Dt = h.ALLOW_DATA_ATTR !== !1, zn = h.ALLOW_UNKNOWN_PROTOCOLS || !1, ln = h.ALLOW_SELF_CLOSE_IN_ATTR !== !1, et = h.SAFE_FOR_TEMPLATES || !1, Ht = h.SAFE_FOR_XML !== !1, Ne = h.WHOLE_DOCUMENT || !1, ft = h.RETURN_DOM || !1, xt = h.RETURN_DOM_FRAGMENT || !1, Ft = h.RETURN_TRUSTED_TYPE || !1, cn = h.FORCE_BODY || !1, un = h.SANITIZE_DOM !== !1, Un = h.SANITIZE_NAMED_PROPS || !1, Ge = h.KEEP_CONTENT !== !1, Le = h.IN_PLACE || !1, kt = h.ALLOWED_URI_REGEXP || ds, Tt = h.NAMESPACE || De, R = h.MATHML_TEXT_INTEGRATION_POINTS || R, z = h.HTML_INTEGRATION_POINTS || z, ee = h.CUSTOM_ELEMENT_HANDLING || {}, h.CUSTOM_ELEMENT_HANDLING && Qn(h.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ee.tagNameCheck = h.CUSTOM_ELEMENT_HANDLING.tagNameCheck), h.CUSTOM_ELEMENT_HANDLING && Qn(h.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ee.attributeNameCheck = h.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), h.CUSTOM_ELEMENT_HANDLING && typeof h.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (ee.allowCustomizedBuiltInElements = h.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), et && (Dt = !1), xt && (ft = !0), _e && (re = Y({}, Fr), ue = [], _e.html === !0 && (Y(re, Hr), Y(ue, Vr)), _e.svg === !0 && (Y(re, Za), Y(ue, Ka), Y(ue, na)), _e.svgFilters === !0 && (Y(re, Ga), Y(ue, Ka), Y(ue, na)), _e.mathMl === !0 && (Y(re, Ya), Y(ue, zr), Y(ue, na))), h.ADD_TAGS && (re === Xe && (re = It(re)), Y(re, h.ADD_TAGS, K)), h.ADD_ATTR && (ue === on && (ue = It(ue)), Y(ue, h.ADD_ATTR, K)), h.ADD_URI_SAFE_ATTR && Y(Et, h.ADD_URI_SAFE_ATTR, K), h.FORBID_CONTENTS && (mt === dn && (mt = It(mt)), Y(mt, h.FORBID_CONTENTS, K)), Ge && (re["#text"] = !0), Ne && Y(re, ["html", "head", "body"]), re.table && (Y(re, ["tbody"]), delete dt.tbody), h.TRUSTED_TYPES_POLICY) {
        if (typeof h.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw gn('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof h.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw gn('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        V = h.TRUSTED_TYPES_POLICY, j = V.createHTML("");
      } else
        V === void 0 && (V = G0(A, i)), V !== null && typeof j == "string" && (j = V.createHTML(""));
      xe && xe(h), He = h;
    }
  }, Ui = Y({}, [...Za, ...Ga, ...R0]), Qi = Y({}, [...Ya, ...N0]), xs = function(h) {
    let E = F(h);
    (!E || !E.tagName) && (E = {
      namespaceURI: Tt,
      tagName: "template"
    });
    const P = ua(h.tagName), ie = ua(E.tagName);
    return Mt[h.namespaceURI] ? h.namespaceURI === Ut ? E.namespaceURI === De ? P === "svg" : E.namespaceURI === zt ? P === "svg" && (ie === "annotation-xml" || R[ie]) : !!Ui[P] : h.namespaceURI === zt ? E.namespaceURI === De ? P === "math" : E.namespaceURI === Ut ? P === "math" && z[ie] : !!Qi[P] : h.namespaceURI === De ? E.namespaceURI === Ut && !z[ie] || E.namespaceURI === zt && !R[ie] ? !1 : !Qi[P] && (G[P] || !Ui[P]) : !!(Z === "application/xhtml+xml" && Mt[h.namespaceURI]) : !1;
  }, Ye = function(h) {
    mn(e.removed, {
      element: h
    });
    try {
      F(h).removeChild(h);
    } catch {
      C(h);
    }
  }, jn = function(h, E) {
    try {
      mn(e.removed, {
        attribute: E.getAttributeNode(h),
        from: E
      });
    } catch {
      mn(e.removed, {
        attribute: null,
        from: E
      });
    }
    if (E.removeAttribute(h), h === "is")
      if (ft || xt)
        try {
          Ye(E);
        } catch {
        }
      else
        try {
          E.setAttribute(h, "");
        } catch {
        }
  }, ji = function(h) {
    let E = null, P = null;
    if (cn)
      h = "<remove></remove>" + h;
    else {
      const ve = Dr(h, /^[\r\n\t ]+/);
      P = ve && ve[0];
    }
    Z === "application/xhtml+xml" && Tt === De && (h = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + h + "</body></html>");
    const ie = V ? V.createHTML(h) : h;
    if (Tt === De)
      try {
        E = new v().parseFromString(ie, Z);
      } catch {
      }
    if (!E || !E.documentElement) {
      E = q.createDocument(Tt, "template", null);
      try {
        E.documentElement.innerHTML = Qt ? j : ie;
      } catch {
      }
    }
    const Ae = E.body || E.documentElement;
    return h && P && Ae.insertBefore(n.createTextNode(P), Ae.childNodes[0] || null), Tt === De ? ce.call(E, Ne ? "html" : "body")[0] : Ne ? E.documentElement : Ae;
  }, Zi = function(h) {
    return X.call(
      h.ownerDocument || h,
      h,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Na = function(h) {
    return h instanceof g && (typeof h.nodeName != "string" || typeof h.textContent != "string" || typeof h.removeChild != "function" || !(h.attributes instanceof f) || typeof h.removeAttribute != "function" || typeof h.setAttribute != "function" || typeof h.namespaceURI != "string" || typeof h.insertBefore != "function" || typeof h.hasChildNodes != "function");
  }, Gi = function(h) {
    return typeof s == "function" && h instanceof s;
  };
  function tt(H, h, E) {
    ta(H, (P) => {
      P.call(e, h, E, He);
    });
  }
  const Yi = function(h) {
    let E = null;
    if (tt(W.beforeSanitizeElements, h, null), Na(h))
      return Ye(h), !0;
    const P = K(h.nodeName);
    if (tt(W.uponSanitizeElement, h, {
      tagName: P,
      allowedTags: re
    }), h.hasChildNodes() && !Gi(h.firstElementChild) && ye(/<[/\w!]/g, h.innerHTML) && ye(/<[/\w!]/g, h.textContent) || h.nodeType === vn.progressingInstruction || Ht && h.nodeType === vn.comment && ye(/<[/\w]/g, h.data))
      return Ye(h), !0;
    if (!re[P] || dt[P]) {
      if (!dt[P] && $i(P) && (ee.tagNameCheck instanceof RegExp && ye(ee.tagNameCheck, P) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(P)))
        return !1;
      if (Ge && !mt[P]) {
        const ie = F(h) || h.parentNode, Ae = S(h) || h.childNodes;
        if (Ae && ie) {
          const ve = Ae.length;
          for (let Te = ve - 1; Te >= 0; --Te) {
            const Ke = _(Ae[Te], !0);
            Ke.__removalCount = (h.__removalCount || 0) + 1, ie.insertBefore(Ke, b(h));
          }
        }
      }
      return Ye(h), !0;
    }
    return h instanceof l && !xs(h) || (P === "noscript" || P === "noembed" || P === "noframes") && ye(/<\/no(script|embed|frames)/i, h.innerHTML) ? (Ye(h), !0) : (et && h.nodeType === vn.text && (E = h.textContent, ta([qe, rn, ut], (ie) => {
      E = pn(E, ie, " ");
    }), h.textContent !== E && (mn(e.removed, {
      element: h.cloneNode()
    }), h.textContent = E)), tt(W.afterSanitizeElements, h, null), !1);
  }, Ki = function(h, E, P) {
    if (un && (E === "id" || E === "name") && (P in n || P in Ba))
      return !1;
    if (!(Dt && !sn[E] && ye(Se, E))) {
      if (!(Vn && ye(Oa, E))) {
        if (!ue[E] || sn[E]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !($i(h) && (ee.tagNameCheck instanceof RegExp && ye(ee.tagNameCheck, h) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(h)) && (ee.attributeNameCheck instanceof RegExp && ye(ee.attributeNameCheck, E) || ee.attributeNameCheck instanceof Function && ee.attributeNameCheck(E)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            E === "is" && ee.allowCustomizedBuiltInElements && (ee.tagNameCheck instanceof RegExp && ye(ee.tagNameCheck, P) || ee.tagNameCheck instanceof Function && ee.tagNameCheck(P)))
          ) return !1;
        } else if (!Et[E]) {
          if (!ye(kt, pn(P, Fn, ""))) {
            if (!((E === "src" || E === "xlink:href" || E === "href") && h !== "script" && _0(P, "data:") === 0 && pt[h])) {
              if (!(zn && !ye(yt, pn(P, Fn, "")))) {
                if (P)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, $i = function(h) {
    return h !== "annotation-xml" && Dr(h, Ze);
  }, Ji = function(h) {
    tt(W.beforeSanitizeAttributes, h, null);
    const {
      attributes: E
    } = h;
    if (!E || Na(h))
      return;
    const P = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ue,
      forceKeepAttr: void 0
    };
    let ie = E.length;
    for (; ie--; ) {
      const Ae = E[ie], {
        name: ve,
        namespaceURI: Te,
        value: Ke
      } = Ae, fn = K(ve);
      let Ce = ve === "value" ? Ke : O0(Ke);
      if (P.attrName = fn, P.attrValue = Ce, P.keepAttr = !0, P.forceKeepAttr = void 0, tt(W.uponSanitizeAttribute, h, P), Ce = P.attrValue, Un && (fn === "id" || fn === "name") && (jn(ve, h), Ce = Pa + Ce), Ht && ye(/((--!?|])>)|<\/(style|title)/i, Ce)) {
        jn(ve, h);
        continue;
      }
      if (P.forceKeepAttr || (jn(ve, h), !P.keepAttr))
        continue;
      if (!ln && ye(/\/>/i, Ce)) {
        jn(ve, h);
        continue;
      }
      et && ta([qe, rn, ut], (qi) => {
        Ce = pn(Ce, qi, " ");
      });
      const Wi = K(h.nodeName);
      if (Ki(Wi, fn, Ce)) {
        if (V && typeof A == "object" && typeof A.getAttributeType == "function" && !Te)
          switch (A.getAttributeType(Wi, fn)) {
            case "TrustedHTML": {
              Ce = V.createHTML(Ce);
              break;
            }
            case "TrustedScriptURL": {
              Ce = V.createScriptURL(Ce);
              break;
            }
          }
        try {
          Te ? h.setAttributeNS(Te, ve, Ce) : h.setAttribute(ve, Ce), Na(h) ? Ye(h) : Nr(e.removed);
        } catch {
        }
      }
    }
    tt(W.afterSanitizeAttributes, h, null);
  }, Es = function H(h) {
    let E = null;
    const P = Zi(h);
    for (tt(W.beforeSanitizeShadowDOM, h, null); E = P.nextNode(); )
      tt(W.uponSanitizeShadowNode, E, null), Yi(E), Ji(E), E.content instanceof r && H(E.content);
    tt(W.afterSanitizeShadowDOM, h, null);
  };
  return e.sanitize = function(H) {
    let h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = null, P = null, ie = null, Ae = null;
    if (Qt = !H, Qt && (H = "<!-->"), typeof H != "string" && !Gi(H))
      if (typeof H.toString == "function") {
        if (H = H.toString(), typeof H != "string")
          throw gn("dirty is not a string, aborting");
      } else
        throw gn("toString is not a function");
    if (!e.isSupported)
      return H;
    if (Be || Ra(h), e.removed = [], typeof H == "string" && (Le = !1), Le) {
      if (H.nodeName) {
        const Ke = K(H.nodeName);
        if (!re[Ke] || dt[Ke])
          throw gn("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (H instanceof s)
      E = ji("<!---->"), P = E.ownerDocument.importNode(H, !0), P.nodeType === vn.element && P.nodeName === "BODY" || P.nodeName === "HTML" ? E = P : E.appendChild(P);
    else {
      if (!ft && !et && !Ne && // eslint-disable-next-line unicorn/prefer-includes
      H.indexOf("<") === -1)
        return V && Ft ? V.createHTML(H) : H;
      if (E = ji(H), !E)
        return ft ? null : Ft ? j : "";
    }
    E && cn && Ye(E.firstChild);
    const ve = Zi(Le ? H : E);
    for (; ie = ve.nextNode(); )
      Yi(ie), Ji(ie), ie.content instanceof r && Es(ie.content);
    if (Le)
      return H;
    if (ft) {
      if (xt)
        for (Ae = we.call(E.ownerDocument); E.firstChild; )
          Ae.appendChild(E.firstChild);
      else
        Ae = E;
      return (ue.shadowroot || ue.shadowrootmode) && (Ae = Pe.call(a, Ae, !0)), Ae;
    }
    let Te = Ne ? E.outerHTML : E.innerHTML;
    return Ne && re["!doctype"] && E.ownerDocument && E.ownerDocument.doctype && E.ownerDocument.doctype.name && ye(fs, E.ownerDocument.doctype.name) && (Te = "<!DOCTYPE " + E.ownerDocument.doctype.name + `>
` + Te), et && ta([qe, rn, ut], (Ke) => {
      Te = pn(Te, Ke, " ");
    }), V && Ft ? V.createHTML(Te) : Te;
  }, e.setConfig = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Ra(H), Be = !0;
  }, e.clearConfig = function() {
    He = null, Be = !1;
  }, e.isValidAttribute = function(H, h, E) {
    He || Ra({});
    const P = K(H), ie = K(h);
    return Ki(P, ie, E);
  }, e.addHook = function(H, h) {
    typeof h == "function" && mn(W[H], h);
  }, e.removeHook = function(H, h) {
    if (h !== void 0) {
      const E = I0(W[H], h);
      return E === -1 ? void 0 : L0(W[H], E, 1)[0];
    }
    return Nr(W[H]);
  }, e.removeHooks = function(H) {
    W[H] = [];
  }, e.removeAllHooks = function() {
    W = Qr();
  }, e;
}
var An = ms();
const Y0 = () => ({
  sanitized: w(() => (e) => {
    var n;
    return ((n = An == null ? void 0 : An.sanitize) == null ? void 0 : n.call(An, e)) ?? e;
  })
}), K0 = { class: "flex flex-col gap-3 sm:flex-row sm:gap-6" }, $0 = { class: "flex shrink-0" }, J0 = ["src", "width", "height", "alt"], W0 = ["href"], q0 = ["src", "width", "height", "alt"], X0 = { class: "text-sm/[22px]" }, ef = { class: "text-neutral-700 sm:text-base" }, tf = ["innerHTML"], nf = {
  key: 0,
  class: "mt-4"
}, af = ["href", "target", "rel"], rf = { class: "flex items-center gap-1.5" }, of = { class: "flex justify-center" }, sf = ["src", "alt"], lf = /* @__PURE__ */ x({
  __name: "AnwCertificate",
  props: {
    image: {},
    title: {},
    desc: {},
    link: {},
    website: {},
    targetBlank: { type: Boolean },
    rel: { default: "noopener noreferrer nofollow" },
    lightbox: { type: Boolean }
  },
  setup(t) {
    const e = N(!1), { sanitized: n } = Y0();
    return (a, i) => (u(), m("div", K0, [
      d("figure", $0, [
        a.lightbox ? (u(), m("button", {
          key: 0,
          type: "button",
          class: "group focus:outline-none",
          onClick: i[0] || (i[0] = (r) => e.value = !e.value)
        }, [
          d("img", {
            src: a.image.src,
            width: a.image.width,
            height: a.image.height,
            class: "box-content rounded-md border-10 border-info-50 group-hover:ring group-focus:ring",
            alt: a.image.alt
          }, null, 8, J0)
        ])) : (u(), m("a", {
          key: 1,
          href: a.link,
          class: "group focus:outline-none"
        }, [
          d("img", {
            src: a.image.src,
            width: a.image.width,
            height: a.image.height,
            class: "box-content rounded-md border-10 border-info-50 group-hover:ring group-focus:ring",
            alt: a.image.alt
          }, null, 8, q0)
        ], 8, W0))
      ]),
      d("div", X0, [
        d("p", ef, k(a.title), 1),
        d("p", {
          class: "mt-2 text-neutral-700",
          innerHTML: p(n)(a.desc)
        }, null, 8, tf),
        a.website !== "" ? (u(), m("p", nf, [
          d("a", {
            href: a.website,
            target: a.targetBlank === !0 ? "_blank" : "_self",
            rel: a.rel,
            class: "flex gap-1.5 text-sm font-semibold"
          }, [
            d("span", rf, [
              i[2] || (i[2] = J(" Website ")),
              M(p(Q), {
                icon: p(l2),
                class: "text-[14px]"
              }, null, 8, ["icon"])
            ])
          ], 8, af)
        ])) : T("", !0)
      ]),
      M(La, {
        "is-modal-open": e.value,
        "onUpdate:isModalOpen": i[1] || (i[1] = (r) => e.value = r),
        heading: "Qualifikationen und Auszeichnungen",
        icon: p(x2)
      }, {
        default: le(() => [
          d("div", of, [
            d("img", {
              src: a.image.preview,
              alt: a.image.alt
            }, null, 8, sf)
          ])
        ]),
        _: 1
      }, 8, ["is-modal-open", "icon"])
    ]));
  }
});
/**
 * Vue 3 Carousel 0.15.0
 * (c) 2025
 * @license MIT
 */
const ps = ["viewport", "carousel"], ba = {
  "bottom-to-top": "btt",
  "left-to-right": "ltr",
  "right-to-left": "rtl",
  "top-to-bottom": "ttb"
}, gs = [
  "ltr",
  "left-to-right",
  "rtl",
  "right-to-left",
  "ttb",
  "top-to-bottom",
  "btt",
  "bottom-to-top"
], cf = {
  ariaGallery: "Gallery",
  ariaNavigateToPage: "Navigate to page {slideNumber}",
  ariaNavigateToSlide: "Navigate to slide {slideNumber}",
  ariaNextSlide: "Navigate to next slide",
  ariaPreviousSlide: "Navigate to previous slide",
  iconArrowDown: "Arrow pointing downwards",
  iconArrowLeft: "Arrow pointing to the left",
  iconArrowRight: "Arrow pointing to the right",
  iconArrowUp: "Arrow pointing upwards",
  itemXofY: "Item {currentSlide} of {slidesCount}"
}, hs = ["slide", "fade"], vs = [
  "center",
  "start",
  "end",
  "center-even",
  "center-odd"
], jr = 10, aa = 0.3, oe = {
  autoplay: 0,
  breakpointMode: ps[0],
  breakpoints: void 0,
  dir: gs[0],
  enabled: !0,
  gap: 0,
  height: "auto",
  i18n: cf,
  ignoreAnimations: !1,
  itemsToScroll: 1,
  itemsToShow: 1,
  modelValue: 0,
  mouseDrag: !0,
  mouseWheel: !1,
  pauseAutoplayOnHover: !1,
  preventExcessiveDragging: !1,
  slideEffect: hs[0],
  snapAlign: vs[0],
  touchDrag: !0,
  transition: 300,
  wrapAround: !1
}, Nt = Symbol("carousel"), uf = (t) => {
  const e = Wa([]), n = (a) => {
    a !== void 0 ? e.slice(a).forEach((i, r) => {
      var o;
      (o = i.exposed) === null || o === void 0 || o.setIndex(a + r);
    }) : e.forEach((i, r) => {
      var o;
      (o = i.exposed) === null || o === void 0 || o.setIndex(r);
    });
  };
  return {
    cleanup: () => {
      e.splice(0, e.length);
    },
    getSlides: () => e,
    registerSlide: (a, i) => {
      if (!a || a.props.isClone)
        return;
      const r = i ?? e.length;
      e.splice(r, 0, a), n(r), t("slide-registered", { slide: a, index: r });
    },
    unregisterSlide: (a) => {
      const i = e.indexOf(a);
      i !== -1 && (t("slide-unregistered", { slide: a, index: i }), e.splice(i, 1), n(i));
    }
  };
};
function df(t) {
  return t.length === 0 ? 0 : t.reduce((n, a) => n + a, 0) / t.length;
}
function Zr({ slides: t, position: e, toShow: n }) {
  const a = [], i = e === "before", r = i ? -n : 0, o = i ? 0 : n;
  if (t.length <= 0)
    return a;
  for (let s = r; s < o; s++) {
    const c = {
      index: i ? s : s + t.length,
      isClone: !0,
      id: void 0,
      // Make sure we don't duplicate the id which would be invalid html
      key: `clone-${e}-${s}`
    }, f = t[(s % t.length + t.length) % t.length].vnode, g = Ds(f, c);
    g.el = null, a.push(g);
  }
  return a;
}
const ff = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
function Gr(t) {
  if (!t.el || !(t.el instanceof Element))
    return;
  const e = t.el.querySelectorAll(ff);
  for (const n of e)
    n instanceof HTMLElement && !n.hasAttribute("disabled") && n.getAttribute("aria-hidden") !== "true" && n.setAttribute("tabindex", "-1");
}
function mf(t, e) {
  return Object.keys(t).filter((n) => !e.includes(n)).reduce((n, a) => (n[a] = t[a], n), {});
}
function pf(t) {
  const { isVertical: e, isReversed: n, dragged: a, effectiveSlideSize: i, threshold: r } = t, o = e ? a.y : a.x;
  if (o === 0)
    return 0;
  const s = o / i, l = Math.abs(s);
  if (l < r)
    return 0;
  const c = l < 1 ? Math.sign(s) : Math.round(s);
  return n ? c : -c;
}
function nt({ val: t, max: e, min: n }) {
  return e < n ? t : Math.min(Math.max(t, isNaN(n) ? t : n), isNaN(e) ? t : e);
}
function gf(t) {
  const { transform: e } = window.getComputedStyle(t);
  return e.split(/[(,)]/).slice(1, -1).map((n) => parseFloat(n));
}
function hf(t) {
  let e = 1, n = 1;
  return t.forEach((a) => {
    const i = gf(a);
    i.length === 6 && (e /= i[0], n /= i[3]);
  }), { widthMultiplier: e, heightMultiplier: n };
}
function vf(t, e) {
  switch (t) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (e - 1) / 2;
    case "center-even":
      return (e - 2) / 2;
    case "end":
      return e - 1;
    default:
      return 0;
  }
}
function Af(t, e, n) {
  switch (t) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (n - e) / 2;
    case "center-even":
      return n / 2 - e;
    case "end":
      return n - e;
    default:
      return 0;
  }
}
function gi({ slideSize: t, viewportSize: e, align: n, itemsToShow: a }) {
  return a !== void 0 ? vf(n, a) : t !== void 0 && e !== void 0 ? Af(n, t, e) : 0;
}
function As(t = "", e = {}) {
  return Object.entries(e).reduce((n, [a, i]) => n.replace(`{${a}}`, String(i)), t);
}
function bs({ val: t, max: e, min: n = 0 }) {
  const a = e - n + 1;
  return ((t - n) % a + a) % a + n;
}
function hi(t, e = 0) {
  let n = !1, a = 0, i = null;
  function r(...o) {
    if (n)
      return;
    n = !0;
    const s = () => {
      i = requestAnimationFrame((l) => {
        l - a > e ? (a = l, t(...o), n = !1) : s();
      });
    };
    s();
  }
  return r.cancel = () => {
    i && (cancelAnimationFrame(i), i = null, n = !1);
  }, r;
}
function ia(t, e = "px") {
  if (!(t == null || t === ""))
    return typeof t == "number" || parseFloat(t).toString() === t ? `${t}${e}` : t;
}
const bf = x({
  name: "CarouselAria",
  setup() {
    const t = lt(Nt);
    return t ? () => fe("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, As(t.config.i18n.itemXofY, {
      currentSlide: t.currentSlide + 1,
      slidesCount: t.slidesCount
    })) : () => "";
  }
});
function wf(t) {
  let e = !1;
  const n = { x: 0, y: 0 }, a = oa({ x: 0, y: 0 }), i = N(!1), { isSliding: r } = t, o = w(() => typeof r == "boolean" ? r : r.value), s = (f) => {
    var g;
    const v = f.target.tagName;
    if (["INPUT", "TEXTAREA", "SELECT"].includes(v) || o.value || (e = f.type === "touchstart", !e && (f.preventDefault(), f.button !== 0)))
      return;
    n.x = e ? f.touches[0].clientX : f.clientX, n.y = e ? f.touches[0].clientY : f.clientY;
    const A = e ? "touchmove" : "mousemove", y = e ? "touchend" : "mouseup";
    document.addEventListener(A, l, { passive: !1 }), document.addEventListener(y, c, { passive: !0 }), (g = t.onDragStart) === null || g === void 0 || g.call(t);
  }, l = hi((f) => {
    var g;
    i.value = !0;
    const v = e ? f.touches[0].clientX : f.clientX, A = e ? f.touches[0].clientY : f.clientY;
    a.x = v - n.x, a.y = A - n.y, (g = t.onDrag) === null || g === void 0 || g.call(t, { deltaX: a.x, deltaY: a.y, isTouch: e });
  }), c = () => {
    var f;
    if (l.cancel(), !e) {
      const A = (y) => {
        y.preventDefault(), window.removeEventListener("click", A);
      };
      window.addEventListener("click", A);
    }
    (f = t.onDragEnd) === null || f === void 0 || f.call(t), a.x = 0, a.y = 0, i.value = !1;
    const g = e ? "touchmove" : "mousemove", v = e ? "touchend" : "mouseup";
    document.removeEventListener(g, l), document.removeEventListener(v, c);
  };
  return {
    dragged: a,
    isDragging: i,
    handleDragStart: s
  };
}
function Cf() {
  const t = N(!1);
  return {
    isHover: t,
    handleMouseEnter: () => {
      t.value = !0;
    },
    handleMouseLeave: () => {
      t.value = !1;
    }
  };
}
function yf(t) {
  const { isVertical: e, isSliding: n, config: a } = t, i = w(() => typeof e == "boolean" ? e : e.value), r = w(() => typeof n == "boolean" ? n : n.value);
  return {
    handleScroll: (s) => {
      var l, c;
      if (s.preventDefault(), !a.mouseWheel || r.value)
        return;
      const f = typeof a.mouseWheel == "object" && (l = a.mouseWheel.threshold) !== null && l !== void 0 ? l : jr, g = Math.abs(s.deltaY) > f ? s.deltaY : 0, v = Math.abs(s.deltaX) > f ? s.deltaX : 0;
      if (g === 0 && v === 0)
        return;
      const A = i.value ? g : v, _ = (A !== 0 ? A : i.value ? v : g) > 0;
      (c = t.onWheel) === null || c === void 0 || c.call(t, { deltaX: v, deltaY: g, isScrollingForward: _ });
    }
  };
}
const kf = {
  // time to auto advance slides in ms
  autoplay: {
    default: oe.autoplay,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: oe.breakpoints,
    type: Object
  },
  // controls the breakpoint mode relative to the carousel container or the viewport
  breakpointMode: {
    default: oe.breakpointMode,
    validator(t) {
      return ps.includes(t);
    }
  },
  clamp: {
    type: Boolean
  },
  // control the direction of the carousel
  dir: {
    type: String,
    default: oe.dir,
    validator(t, e) {
      if (!gs.includes(t))
        return !1;
      const n = t in ba ? ba[t] : t;
      return ["ttb", "btt"].includes(n) && (!e.height || e.height === "auto") && console.warn(`[vue3-carousel]: The dir "${t}" is not supported with height "auto".`), !0;
    }
  },
  // enable/disable the carousel component
  enabled: {
    default: oe.enabled,
    type: Boolean
  },
  // control the gap between slides
  gap: {
    default: oe.gap,
    type: Number
  },
  // set carousel height
  height: {
    default: oe.height,
    type: [Number, String]
  },
  // aria-labels and additional text labels
  i18n: {
    default: oe.i18n,
    type: Object
  },
  ignoreAnimations: {
    default: !1,
    type: [Array, Boolean, String]
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: oe.itemsToScroll,
    type: Number
  },
  // count of items to showed per view
  itemsToShow: {
    default: oe.itemsToShow,
    type: [Number, String]
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging
  mouseDrag: {
    default: oe.mouseDrag,
    type: [Boolean, Object]
  },
  // toggle mouse wheel scrolling
  mouseWheel: {
    default: oe.mouseWheel,
    type: [Boolean, Object]
  },
  // control mouse scroll threshold
  mouseScrollThreshold: {
    default: oe.mouseScrollThreshold,
    type: Number
  },
  pauseAutoplayOnHover: {
    default: oe.pauseAutoplayOnHover,
    type: Boolean
  },
  preventExcessiveDragging: {
    default: !1,
    type: Boolean,
    validator(t, e) {
      return t && e.wrapAround && console.warn('[vue3-carousel]: "preventExcessiveDragging" cannot be used with wrapAround. The setting will be ignored.'), !0;
    }
  },
  slideEffect: {
    type: String,
    default: oe.slideEffect,
    validator(t) {
      return hs.includes(t);
    }
  },
  // control snap position alignment
  snapAlign: {
    default: oe.snapAlign,
    validator(t) {
      return vs.includes(t);
    }
  },
  // toggle touch dragging
  touchDrag: {
    default: oe.touchDrag,
    type: [Boolean, Object]
  },
  // sliding transition time in ms
  transition: {
    default: oe.transition,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: oe.wrapAround,
    type: Boolean
  }
}, Fi = x({
  name: "VueCarousel",
  props: kf,
  emits: [
    "before-init",
    "drag",
    "init",
    "loop",
    "slide-end",
    "slide-registered",
    "slide-start",
    "slide-unregistered",
    "update:modelValue",
    "wheel"
  ],
  setup(t, { slots: e, emit: n, expose: a }) {
    var i;
    const r = uf(n), o = r.getSlides(), s = w(() => o.length), l = N(null), c = N(null), f = N(0), g = w(() => Object.assign(Object.assign(Object.assign({}, oe), mf(t, ["breakpoints", "modelValue"])), { i18n: Object.assign(Object.assign({}, oe.i18n), t.i18n) })), v = Wa(Object.assign({}, g.value)), A = N((i = t.modelValue) !== null && i !== void 0 ? i : 0), y = N(A.value);
    be(A, (I) => y.value = I);
    const _ = N(0), C = w(() => Math.ceil((s.value - 1) / 2)), b = w(() => s.value - 1), S = w(() => 0);
    let F = null, V = null, j = null;
    const q = w(() => f.value + v.gap), X = w(() => {
      const I = v.dir || "ltr";
      return I in ba ? ba[I] : I;
    }), we = w(() => ["rtl", "btt"].includes(X.value)), ce = w(() => ["ttb", "btt"].includes(X.value)), Pe = w(() => v.itemsToShow === "auto"), W = w(() => ce.value ? "height" : "width");
    function qe() {
      var I;
      if (!ee.value)
        return;
      const R = (g.value.breakpointMode === "carousel" ? (I = l.value) === null || I === void 0 ? void 0 : I.getBoundingClientRect().width : typeof window < "u" ? window.innerWidth : 0) || 0, z = Object.keys(t.breakpoints || {}).map((Z) => Number(Z)).sort((Z, de) => +de - +Z), G = {};
      z.some((Z) => R >= Z ? (Object.assign(G, t.breakpoints[Z]), G.i18n && Object.assign(G.i18n, g.value.i18n, t.breakpoints[Z].i18n), !0) : !1), Object.assign(v, g.value, G), Pe.value || (v.itemsToShow = nt({
        val: Number(v.itemsToShow),
        max: t.clamp ? s.value : 1 / 0,
        min: 1
      }));
    }
    const rn = hi(() => {
      qe(), kt(), Ze();
    }), ut = Wa(/* @__PURE__ */ new Set()), Se = N([]);
    function Oa({ widthMultiplier: I, heightMultiplier: R }) {
      Se.value = o.map((z) => {
        var G;
        const Z = (G = z.exposed) === null || G === void 0 ? void 0 : G.getBoundingRect();
        return {
          width: Z.width * I,
          height: Z.height * R
        };
      });
    }
    const yt = N({
      width: 0,
      height: 0
    });
    function Fn({ widthMultiplier: I, heightMultiplier: R }) {
      var z;
      const G = ((z = c.value) === null || z === void 0 ? void 0 : z.getBoundingClientRect()) || { width: 0, height: 0 };
      yt.value = {
        width: G.width * I,
        height: G.height * R
      };
    }
    function Ze() {
      if (!c.value)
        return;
      const I = hf(ut);
      if (Fn(I), Oa(I), Pe.value)
        f.value = df(Se.value.map((R) => R[W.value]));
      else {
        const R = Number(v.itemsToShow), z = (R - 1) * v.gap;
        f.value = (yt.value[W.value] - z) / R;
      }
    }
    function kt() {
      !v.wrapAround && s.value > 0 && (A.value = nt({
        val: A.value,
        max: b.value,
        min: S.value
      }));
    }
    const re = w(() => typeof t.ignoreAnimations == "string" ? t.ignoreAnimations.split(",") : Array.isArray(t.ignoreAnimations) ? t.ignoreAnimations : t.ignoreAnimations ? !1 : []);
    yn(() => kt()), yn(() => {
      Ze();
    });
    let Xe;
    const ue = (I) => {
      const R = I.target;
      if (!(!(R != null && R.contains(l.value)) || Array.isArray(re.value) && re.value.includes(I.animationName)) && (ut.add(R), !Xe)) {
        const z = () => {
          Xe = requestAnimationFrame(() => {
            Ze(), z();
          });
        };
        z();
      }
    }, on = (I) => {
      const R = I.target;
      R && ut.delete(R), Xe && ut.size === 0 && (cancelAnimationFrame(Xe), Ze());
    }, ee = N(!1);
    typeof document < "u" && yn(() => {
      ee.value && re.value !== !1 ? (document.addEventListener("animationstart", ue), document.addEventListener("animationend", on)) : (document.removeEventListener("animationstart", ue), document.removeEventListener("animationend", on));
    }), Ct(() => {
      ee.value = !0, qe(), et(), l.value && (j = new ResizeObserver(rn), j.observe(l.value)), n("init");
    }), uo(() => {
      ee.value = !1, r.cleanup(), V && clearTimeout(V), Xe && cancelAnimationFrame(Xe), F && clearInterval(F), j && (j.disconnect(), j = null), typeof document < "u" && ln(), l.value && (l.value.removeEventListener("transitionend", Ze), l.value.removeEventListener("animationiteration", Ze));
    });
    const { isHover: dt, handleMouseEnter: sn, handleMouseLeave: Vn } = Cf(), Dt = hi((I) => {
      if (!I.ctrlKey)
        switch (I.key) {
          case "ArrowLeft":
          case "ArrowUp":
            ce.value === I.key.endsWith("Up") && (we.value ? Le(!0) : _e(!0));
            break;
          case "ArrowRight":
          case "ArrowDown":
            ce.value === I.key.endsWith("Down") && (we.value ? _e(!0) : Le(!0));
            break;
        }
    }, 200), zn = () => {
      document.addEventListener("keydown", Dt);
    }, ln = () => {
      document.removeEventListener("keydown", Dt);
    };
    function et() {
      !v.autoplay || v.autoplay <= 0 || (F = setInterval(() => {
        v.pauseAutoplayOnHover && dt.value || Le();
      }, v.autoplay));
    }
    function Ht() {
      F && (clearInterval(F), F = null);
    }
    function Ne() {
      Ht(), et();
    }
    const Be = N(!1), cn = ({ deltaX: I, deltaY: R, isTouch: z }) => {
      var G, Z, de, he;
      n("drag", { deltaX: I, deltaY: R });
      const K = z ? typeof v.touchDrag == "object" && (Z = (G = v.touchDrag) === null || G === void 0 ? void 0 : G.threshold) !== null && Z !== void 0 ? Z : aa : typeof v.mouseDrag == "object" && (he = (de = v.mouseDrag) === null || de === void 0 ? void 0 : de.threshold) !== null && he !== void 0 ? he : aa, He = pf({
        isVertical: ce.value,
        isReversed: we.value,
        dragged: { x: I, y: R },
        effectiveSlideSize: q.value,
        threshold: K
      });
      y.value = v.wrapAround ? A.value + He : nt({
        val: A.value + He,
        max: b.value,
        min: S.value
      });
    }, ft = () => Ge(y.value), { dragged: xt, isDragging: Ft, handleDragStart: un } = wf({
      isSliding: Be,
      onDrag: cn,
      onDragEnd: ft
    }), Un = ({ deltaX: I, deltaY: R, isScrollingForward: z }) => {
      n("wheel", { deltaX: I, deltaY: R }), z ? we.value ? _e() : Le() : we.value ? Le() : _e();
    }, { handleScroll: Pa } = yf({
      isVertical: ce,
      isSliding: Be,
      config: v,
      onWheel: Un
    });
    function Ge(I, R = !1) {
      if (!R && Be.value)
        return;
      let z = I, G = I;
      _.value = A.value, v.wrapAround ? G = bs({
        val: z,
        max: b.value,
        min: S.value
      }) : z = nt({
        val: z,
        max: b.value,
        min: S.value
      }), n("slide-start", {
        slidingToIndex: I,
        currentSlideIndex: A.value,
        prevSlideIndex: _.value,
        slidesCount: s.value
      }), Ht(), Be.value = !0, A.value = z, G !== z && dn.pause(), n("update:modelValue", G), V = setTimeout(() => {
        v.wrapAround && G !== z && (dn.resume(), A.value = G, n("loop", {
          currentSlideIndex: A.value,
          slidingToIndex: I
        })), n("slide-end", {
          currentSlideIndex: A.value,
          prevSlideIndex: _.value,
          slidesCount: s.value
        }), Be.value = !1, Ne();
      }, v.transition);
    }
    function Le(I = !1) {
      Ge(A.value + v.itemsToScroll, I);
    }
    function _e(I = !1) {
      Ge(A.value - v.itemsToScroll, I);
    }
    function mt() {
      qe(), kt(), Ze(), Ne();
    }
    be(() => [g.value, t.breakpoints], () => qe(), { deep: !0 }), be(() => t.autoplay, () => Ne());
    const dn = be(() => t.modelValue, (I) => {
      I !== A.value && Ge(Number(I), !0);
    });
    n("before-init");
    const pt = w(() => {
      if (!v.wrapAround)
        return { before: 0, after: 0 };
      if (Pe.value)
        return { before: o.length, after: o.length };
      const I = Number(v.itemsToShow), R = Math.ceil(I + (v.itemsToScroll - 1)), z = R - y.value, G = R - (s.value - (y.value + 1));
      return {
        before: Math.max(0, z),
        after: Math.max(0, G)
      };
    }), Vt = w(() => pt.value.before ? Pe.value ? Se.value.slice(-1 * pt.value.before).reduce((I, R) => I + R[W.value] + v.gap, 0) * -1 : pt.value.before * q.value * -1 : 0), Et = w(() => {
      var I;
      if (Pe.value) {
        const R = (A.value % o.length + o.length) % o.length;
        return gi({
          slideSize: (I = Se.value[R]) === null || I === void 0 ? void 0 : I[W.value],
          viewportSize: yt.value[W.value],
          align: v.snapAlign
        });
      }
      return gi({
        align: v.snapAlign,
        itemsToShow: +v.itemsToShow
      });
    }), St = w(() => {
      let I = 0;
      if (Pe.value) {
        if (A.value < 0 ? I = Se.value.slice(A.value).reduce((R, z) => R + z[W.value] + v.gap, 0) * -1 : I = Se.value.slice(0, A.value).reduce((R, z) => R + z[W.value] + v.gap, 0), I -= Et.value, !v.wrapAround) {
          const R = Se.value.reduce((z, G) => z + G[W.value] + v.gap, 0) - yt.value[W.value] - v.gap;
          I = nt({
            val: I,
            max: R,
            min: 0
          });
        }
      } else {
        let R = A.value - Et.value;
        v.wrapAround || (R = nt({
          val: R,
          max: s.value - +v.itemsToShow,
          min: 0
        })), I = R * q.value;
      }
      return I * (we.value ? 1 : -1);
    }), zt = w(() => {
      var I, R;
      if (!Pe.value) {
        const Z = A.value - Et.value;
        return v.wrapAround ? {
          min: Math.floor(Z),
          max: Math.ceil(Z + Number(v.itemsToShow) - 1)
        } : {
          min: Math.floor(nt({
            val: Z,
            max: s.value - Number(v.itemsToShow),
            min: 0
          })),
          max: Math.ceil(nt({
            val: Z + Number(v.itemsToShow) - 1,
            max: s.value - 1,
            min: 0
          }))
        };
      }
      let z = 0;
      {
        let Z = 0, de = 0 - pt.value.before;
        const he = Math.abs(St.value + Vt.value);
        for (; Z <= he; ) {
          const K = (de % o.length + o.length) % o.length;
          Z += ((I = Se.value[K]) === null || I === void 0 ? void 0 : I[W.value]) + v.gap, de++;
        }
        z = de - 1;
      }
      let G = 0;
      {
        let Z = z, de = 0;
        for (Z < 0 ? de = Se.value.slice(0, Z).reduce((he, K) => he + K[W.value] + v.gap, 0) - Math.abs(St.value + Vt.value) : de = Se.value.slice(0, Z).reduce((he, K) => he + K[W.value] + v.gap, 0) - Math.abs(St.value); de < yt.value[W.value]; ) {
          const he = (Z % o.length + o.length) % o.length;
          de += ((R = Se.value[he]) === null || R === void 0 ? void 0 : R[W.value]) + v.gap, Z++;
        }
        G = Z - 1;
      }
      return {
        min: Math.floor(z),
        max: Math.ceil(G)
      };
    }), Ut = w(() => {
      if (v.slideEffect === "fade")
        return;
      const I = ce.value ? "Y" : "X", R = ce.value ? xt.y : xt.x;
      let z = St.value + R;
      if (!v.wrapAround && v.preventExcessiveDragging) {
        let G = 0;
        Pe.value ? G = Se.value.reduce((he, K) => he + K[W.value], 0) : G = (s.value - Number(v.itemsToShow)) * q.value;
        const Z = we.value ? 0 : -1 * G, de = we.value ? G : 0;
        z = nt({
          val: z,
          min: Z,
          max: de
        });
      }
      return `translate${I}(${z}px)`;
    }), De = w(() => ({
      "--vc-transition-duration": Be.value ? ia(v.transition, "ms") : void 0,
      "--vc-slide-gap": ia(v.gap),
      "--vc-carousel-height": ia(v.height),
      "--vc-cloned-offset": ia(Vt.value)
    })), Qt = oa({
      activeSlide: y,
      config: v,
      currentSlide: A,
      isSliding: Be,
      isVertical: ce,
      maxSlide: b,
      minSlide: S,
      nav: { slideTo: Ge, next: Le, prev: _e },
      normalizedDir: X,
      slideRegistry: r,
      slideSize: f,
      slides: o,
      slidesCount: s,
      viewport: c,
      visibleRange: zt
    });
    Ai(Nt, Qt);
    const Mt = oa({
      config: v,
      currentSlide: A,
      maxSlide: b,
      middleSlide: C,
      minSlide: S,
      slideSize: f,
      slidesCount: s
    });
    return a(oa(Object.assign({
      data: Mt,
      next: Le,
      prev: _e,
      restartCarousel: mt,
      slideTo: Ge,
      updateBreakpointsConfig: qe,
      updateSlideSize: Ze,
      updateSlidesData: kt
    }, st(Qt)))), () => {
      var I;
      const R = e.default || e.slides, z = (R == null ? void 0 : R(Mt)) || [], { before: G, after: Z } = pt.value, de = Zr({
        slides: o,
        position: "before",
        toShow: G
      }), he = Zr({
        slides: o,
        position: "after",
        toShow: Z
      }), K = [...de, ...z, ...he];
      if (!v.enabled || !K.length)
        return fe("section", {
          ref: l,
          class: ["carousel", "is-disabled"]
        }, K);
      const He = ((I = e.addons) === null || I === void 0 ? void 0 : I.call(e, Mt)) || [], Ba = fe("ol", {
        class: "carousel__track",
        style: { transform: Ut.value },
        onMousedownCapture: v.mouseDrag ? un : null,
        onTouchstartPassiveCapture: v.touchDrag ? un : null,
        onWheel: v.mouseWheel ? Pa : null
      }, K), Qn = fe("div", { class: "carousel__viewport", ref: c }, Ba);
      return fe("section", {
        ref: l,
        class: [
          "carousel",
          `is-${X.value}`,
          `is-effect-${v.slideEffect}`,
          {
            "is-vertical": ce.value,
            "is-sliding": Be.value,
            "is-dragging": Ft.value,
            "is-hover": dt.value
          }
        ],
        dir: X.value,
        style: De.value,
        "aria-label": v.i18n.ariaGallery,
        tabindex: "0",
        onFocus: zn,
        onBlur: ln,
        onMouseenter: sn,
        onMouseleave: Vn
      }, [Qn, He, fe(bf)]);
    };
  }
});
var vi;
(function(t) {
  t.arrowDown = "arrowDown", t.arrowLeft = "arrowLeft", t.arrowRight = "arrowRight", t.arrowUp = "arrowUp";
})(vi || (vi = {}));
const Yr = (t) => `icon${t.charAt(0).toUpperCase() + t.slice(1)}`, xf = {
  arrowDown: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
  arrowLeft: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z",
  arrowRight: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z",
  arrowUp: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
};
function Ef(t) {
  return t in vi;
}
const Kr = (t) => t && Ef(t), $r = x({
  props: {
    name: {
      type: String,
      required: !0,
      validator: Kr
    },
    title: {
      type: String,
      default: (t) => t.name ? oe.i18n[Yr(t.name)] : ""
    }
  },
  setup(t) {
    const e = lt(Nt, null);
    return () => {
      const n = t.name;
      if (!n || !Kr(n))
        return;
      const a = xf[n], i = fe("path", { d: a }), r = (e == null ? void 0 : e.config.i18n[Yr(n)]) || t.title, o = fe("title", r);
      return fe("svg", {
        class: "carousel__icon",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-label": r
      }, [o, i]);
    };
  }
}), Sf = x({
  name: "CarouselNavigation",
  inheritAttrs: !1,
  props: {
    carousel: {
      type: Object
    }
  },
  setup(t, { slots: e, attrs: n }) {
    let a = lt(Nt, null);
    const { next: i, prev: r } = e, o = () => ({
      btt: "arrowDown",
      ltr: "arrowLeft",
      rtl: "arrowRight",
      ttb: "arrowUp"
    })[a.normalizedDir], s = () => ({
      btt: "arrowUp",
      ltr: "arrowRight",
      rtl: "arrowLeft",
      ttb: "arrowDown"
    })[a.normalizedDir], l = w(() => !a.config.wrapAround && a.currentSlide <= a.minSlide), c = w(() => !a.config.wrapAround && a.currentSlide >= a.maxSlide);
    return () => {
      if (t.carousel && (a = t.carousel), !a)
        return console.warn("[vue3-carousel]: A carousel component must be provided for the navigation component to display"), "";
      const { i18n: f } = a.config, g = fe("button", Object.assign(Object.assign({ type: "button", disabled: l.value, "aria-label": f.ariaPreviousSlide, title: f.ariaPreviousSlide, onClick: a.nav.prev }, n), { class: [
        "carousel__prev",
        { "carousel__prev--disabled": l.value },
        n.class
      ] }), (r == null ? void 0 : r()) || fe($r, { name: o() })), v = fe("button", Object.assign(Object.assign({ type: "button", disabled: c.value, "aria-label": f.ariaNextSlide, title: f.ariaNextSlide, onClick: a.nav.next }, n), { class: [
        "carousel__next",
        { "carousel__next--disabled": c.value },
        n.class
      ] }), (i == null ? void 0 : i()) || fe($r, { name: s() }));
      return [g, v];
    };
  }
});
x({
  name: "CarouselPagination",
  props: {
    disableOnClick: {
      type: Boolean
    },
    paginateByItemsToShow: {
      type: Boolean
    },
    carousel: {
      type: Object
    }
  },
  setup(t) {
    let e = lt(Nt, null);
    const n = w(() => e.config.itemsToShow), a = w(() => gi({
      align: e.config.snapAlign,
      itemsToShow: n.value
    })), i = w(() => t.paginateByItemsToShow && n.value > 1), r = w(() => Math.ceil((e.activeSlide - a.value) / n.value)), o = w(() => Math.ceil(e.slidesCount / n.value)), s = (l) => bs(i.value ? {
      val: r.value,
      max: o.value - 1,
      min: 0
    } : {
      val: e.activeSlide,
      max: e.maxSlide,
      min: e.minSlide
    }) === l;
    return () => {
      var l, c;
      if (t.carousel && (e = t.carousel), !e)
        return console.warn("[vue3-carousel]: A carousel component must be provided for the pagination component to display"), "";
      const f = [];
      for (let g = i.value ? 0 : e.minSlide; g <= (i.value ? o.value - 1 : e.maxSlide); g++) {
        const v = As(e.config.i18n[i.value ? "ariaNavigateToPage" : "ariaNavigateToSlide"], {
          slideNumber: g + 1
        }), A = s(g), y = fe("button", {
          type: "button",
          class: {
            "carousel__pagination-button": !0,
            "carousel__pagination-button--active": A
          },
          "aria-label": v,
          "aria-pressed": A,
          "aria-controls": (c = (l = e.slides[g]) === null || l === void 0 ? void 0 : l.exposed) === null || c === void 0 ? void 0 : c.id,
          title: v,
          disabled: t.disableOnClick,
          onClick: () => e.nav.slideTo(i.value ? Math.floor(g * +e.config.itemsToShow + a.value) : g)
        }), _ = fe("li", { class: "carousel__pagination-item", key: g }, y);
        f.push(_);
      }
      return fe("ol", { class: "carousel__pagination" }, f);
    };
  }
});
const Vi = x({
  name: "CarouselSlide",
  props: {
    id: {
      type: String,
      default: (t) => t.isClone ? void 0 : Rs()
    },
    index: {
      type: Number,
      default: void 0
    },
    isClone: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { attrs: e, slots: n, expose: a }) {
    const i = lt(Nt);
    if (Ai(Nt, void 0), !i)
      return () => "";
    const r = N(t.index), o = (y) => {
      r.value = y;
    }, s = Ca(), l = () => {
      const y = s.vnode.el;
      return y ? y.getBoundingClientRect() : { width: 0, height: 0 };
    };
    a({
      id: t.id,
      setIndex: o,
      getBoundingRect: l
    });
    const c = w(() => r.value === i.activeSlide), f = w(() => r.value === i.activeSlide - 1), g = w(() => r.value === i.activeSlide + 1), v = w(() => r.value >= i.visibleRange.min && r.value <= i.visibleRange.max), A = w(() => {
      if (i.config.itemsToShow === "auto")
        return;
      const y = i.config.itemsToShow, _ = i.config.gap > 0 && y > 1 ? `calc(${100 / y}% - ${i.config.gap * (y - 1) / y}px)` : `${100 / y}%`;
      return i.isVertical ? { height: _ } : { width: _ };
    });
    return i.slideRegistry.registerSlide(s, t.index), ya(() => {
      i.slideRegistry.unregisterSlide(s);
    }), t.isClone && (Ct(() => {
      Gr(s.vnode);
    }), Ns(() => {
      Gr(s.vnode);
    })), () => {
      var y, _;
      return i.config.enabled ? fe("li", {
        style: [e.style, Object.assign({}, A.value)],
        class: {
          carousel__slide: !0,
          "carousel__slide--clone": t.isClone,
          "carousel__slide--visible": v.value,
          "carousel__slide--active": c.value,
          "carousel__slide--prev": f.value,
          "carousel__slide--next": g.value,
          "carousel__slide--sliding": i.isSliding
        },
        onFocusin: () => {
          i.viewport && (i.viewport.scrollLeft = 0), i.nav.slideTo(r.value);
        },
        id: t.isClone ? void 0 : t.id,
        "aria-hidden": t.isClone || void 0
      }, (_ = n.default) === null || _ === void 0 ? void 0 : _.call(n, {
        currentIndex: r.value,
        isActive: c.value,
        isClone: t.isClone,
        isPrev: f.value,
        isNext: g.value,
        isSliding: i.isSliding,
        isVisible: v.value
      })) : (y = n.default) === null || y === void 0 ? void 0 : y.call(n);
    };
  }
}), Tf = ["src", "alt"], Mf = {
  key: 0,
  class: "mt-2 text-left text-sm"
}, If = { key: 0 }, Lf = {
  key: 1,
  class: "text-gray-400"
}, _f = {
  key: 0,
  class: "mt-4 flex flex-wrap items-center justify-center gap-4"
}, Of = ["aria-label"], Pf = { "aria-hidden": "true" }, Bf = ["aria-label"], ws = /* @__PURE__ */ x({
  __name: "AnwCarouselModal",
  props: {
    content: {},
    modelValue: {},
    transition: {}
  },
  setup(t) {
    const e = {
      ariaNextSlide: "Zum nächsten Bild",
      ariaPreviousSlide: "Zum vorherigen Bild",
      ariaNavigateToSlide: "Zu Bild {slideNumber}",
      ariaGallery: "Galerie",
      itemXofY: "Bild {currentSlide} von {slidesCount}"
    }, n = N(null);
    return (a, i) => (u(), D(p(Fi), {
      ref_key: "carouselModal",
      ref: n,
      "items-to-show": 1,
      "model-value": a.modelValue,
      transition: a.transition,
      i18n: e
    }, {
      addons: le(({ currentSlide: r, slidesCount: o }) => [
        o > 1 ? (u(), m("div", _f, [
          d("button", {
            class: L(["anw-carousel-btn", { "anw-carousel-btn--disabled": r === 0 }]),
            "aria-label": e.ariaPreviousSlide,
            onClick: i[0] || (i[0] = (s) => n.value.prev())
          }, [
            M(p(Q), {
              icon: p(Ia),
              class: "text-[18px]"
            }, null, 8, ["icon"])
          ], 10, Of),
          d("span", Pf, k(r + 1) + " / " + k(o), 1),
          d("button", {
            class: L(["anw-carousel-btn", { "anw-carousel-btn--disabled": r + 1 === o }]),
            "aria-label": e.ariaNextSlide,
            onClick: i[1] || (i[1] = (s) => n.value.next())
          }, [
            M(p(Q), {
              icon: p(an),
              class: "text-[18px]"
            }, null, 8, ["icon"])
          ], 10, Bf)
        ])) : T("", !0)
      ]),
      default: le(() => [
        (u(!0), m(U, null, ne(a.content, (r, o) => (u(), D(p(Vi), { key: o }, {
          default: le(() => [
            d("figure", null, [
              d("img", {
                src: r.src,
                alt: r.alt,
                class: "max-h-[440px]"
              }, null, 8, Tf),
              r.title || r.copyright ? (u(), m("figcaption", Mf, [
                r.title ? (u(), m("p", If, k(r.title), 1)) : T("", !0),
                r.copyright ? (u(), m("p", Lf, k(r.copyright), 1)) : T("", !0)
              ])) : T("", !0)
            ])
          ]),
          _: 2
        }, 1024))), 128))
      ]),
      _: 1
    }, 8, ["model-value", "transition"]));
  }
}), Rf = ["src", "alt", "width", "height"], Jr = /* @__PURE__ */ x({
  __name: "AnwCarouselThumbnail",
  props: {
    src: { default: "" },
    width: { default: "" },
    height: { default: "" },
    thumbnail: { default: "" },
    alt: { default: "" }
  },
  setup(t) {
    return (e, n) => (u(), m("img", {
      src: e.thumbnail || e.src,
      alt: e.alt,
      class: "w-full rounded-xl object-cover object-center",
      loading: "lazy",
      width: e.width,
      height: e.height,
      style: bi({ width: `${e.width}px`, height: `${e.height}px` })
    }, null, 12, Rf));
  }
}), Nf = ["onClick"], Df = /* @__PURE__ */ x({
  __name: "AnwCarousel",
  props: {
    content: {},
    itemsToShow: {},
    wrapAround: { type: Boolean },
    breakpoints: {},
    transition: {},
    lightbox: { type: Boolean },
    dataAttributes: {}
  },
  setup(t) {
    const e = {
      ariaNextSlide: "Zum nächsten Bild",
      ariaPreviousSlide: "Zum vorherigen Bild",
      ariaNavigateToSlide: "Zu Bild {slideNumber}",
      ariaGallery: "Galerie",
      itemXofY: "Bild {currentSlide} von {slidesCount}"
    }, n = N(!1), a = N(0);
    return (i, r) => (u(), m(U, null, [
      M(p(Fi), {
        "items-to-show": i.itemsToShow,
        "snap-align": "start",
        "wrap-around": i.wrapAround,
        breakpoints: i.breakpoints,
        transition: i.transition,
        i18n: e,
        class: "-mx-1"
      }, {
        addons: le(() => [
          M(p(Sf), null, {
            prev: le(() => [
              M(p(Q), {
                icon: p(Ia),
                class: "text-[24px]"
              }, null, 8, ["icon"])
            ]),
            next: le(() => [
              M(p(Q), {
                icon: p(an),
                class: "text-[24px]"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        default: le(() => [
          (u(!0), m(U, null, ne(i.content, (o, s) => (u(), D(p(Vi), {
            key: s,
            class: L("p-1")
          }, {
            default: le(() => [
              i.lightbox ? (u(), m("button", ge({
                key: 0,
                class: "w-full",
                type: "button",
                ref_for: !0
              }, i.dataAttributes, {
                onClick: (l) => (n.value = !n.value, a.value = s)
              }), [
                M(Jr, {
                  src: o.src,
                  alt: o.alt,
                  thumbnail: o.thumbnail,
                  width: o.width,
                  height: o.height
                }, null, 8, ["src", "alt", "thumbnail", "width", "height"])
              ], 16, Nf)) : (u(), D(Jr, {
                key: 1,
                src: o.src,
                alt: o.alt,
                thumbnail: o.thumbnail,
                width: o.width,
                height: o.height
              }, null, 8, ["src", "alt", "thumbnail", "width", "height"]))
            ]),
            _: 2
          }, 1024))), 128))
        ]),
        _: 1
      }, 8, ["items-to-show", "wrap-around", "breakpoints", "transition"]),
      M(La, {
        "is-modal-open": n.value,
        "onUpdate:isModalOpen": r[0] || (r[0] = (o) => n.value = o),
        heading: "Bilder",
        icon: p(v2)
      }, {
        default: le(() => [
          n.value ? (u(), D(ws, {
            key: 0,
            content: i.content,
            "model-value": a.value
          }, null, 8, ["content", "model-value"])) : T("", !0)
        ]),
        _: 1
      }, 8, ["is-modal-open", "icon"])
    ], 64));
  }
});
var Hf = {
  prefix: "fas",
  iconName: "quote-right",
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"]
}, Ff = {
  prefix: "fas",
  iconName: "square-full",
  icon: [512, 512, [128997, 128998, 128999, 129e3, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
};
const Vf = { class: "anw-hint-box anw-gradient-box w-full items-center rounded-[5px] border border-solid border-transparent px-2.5 py-2 sm:px-5 sm:py-4" }, zf = {
  key: 0,
  class: "anw-item-icon flex items-center"
}, Uf = {
  "aria-hidden": "true",
  class: "anw-gradient-border flex aspect-square shrink-0 rounded-full p-0.5"
}, Qf = { class: "grid place-items-center overflow-hidden rounded-full bg-white p-[0.2rem]" }, jf = { class: "anw-item-heading" }, Zf = {
  key: 0,
  class: "font-bold"
}, Gf = { class: "anw-item-text mt-2 sm:mt-0" }, Yf = ["innerHTML"], Kf = /* @__PURE__ */ x({
  __name: "AnwHintBox",
  props: {
    heading: { default: "" },
    text: { default: "" },
    icon: { default: null },
    iconClass: { default: "" }
  },
  setup(t) {
    return (e, n) => (u(), m("div", Vf, [
      e.icon ? (u(), m("div", zf, [
        d("div", Uf, [
          d("div", Qf, [
            M(p(Q), {
              class: L([e.iconClass, "anw-gradient-icon relative -left-[0.05rem] shrink-0 text-[33px] text-white"]),
              icon: e.icon,
              mask: p(Ff),
              "fixed-width": ""
            }, null, 8, ["class", "icon", "mask"])
          ])
        ])
      ])) : T("", !0),
      d("div", jf, [
        e.heading ? (u(), m("div", Zf, k(e.heading), 1)) : T("", !0)
      ]),
      d("div", Gf, [
        e.text ? (u(), m("div", {
          key: 0,
          innerHTML: e.text
        }, null, 8, Yf)) : T("", !0)
      ])
    ]));
  }
});
var wn = /* @__PURE__ */ ((t) => (t.ORANGE = "orange", t.GREEN = "green", t.BLUE = "blue", t.RED = "red", t))(wn || {});
const $f = {
  orange: "bg-primary-500",
  green: "bg-success-400",
  blue: "bg-info-300",
  red: "bg-error-400"
}, Wr = [wn.RED, wn.ORANGE, wn.BLUE, wn.GREEN], Jf = (t) => t.split("").map((e) => e.charCodeAt(0)).reduce((e, n) => e + n, 0), Wf = (t) => Wr[Jf(t) % Wr.length], qf = (t) => {
  const e = t.split(" "), n = e[0].charAt(0).toUpperCase(), a = e[e.length - 1];
  return e.length === 1 ? n : n + a.charAt(0).toUpperCase();
}, Xf = {
  class: "anw-initials",
  role: "status"
}, e4 = /* @__PURE__ */ x({
  __name: "AnwInitialsBadge",
  props: {
    content: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", Xf, [
      d("div", {
        class: L(["anw-initial-badge text-white", p($f)[p(Wf)(e.content)]])
      }, k(p(qf)(e.content)), 3)
    ]));
  }
}), t4 = { class: "anw-group" }, n4 = { class: "anw-group-title" }, a4 = { class: "anw-group-list" }, i4 = {
  class: "anw-group-icon",
  "aria-hidden": "true"
}, r4 = /* @__PURE__ */ x({
  __name: "AnwListGroup",
  props: {
    args: {},
    title: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", t4, [
      d("p", n4, k(e.title), 1),
      d("ul", a4, [
        (u(!0), m(U, null, ne(e.args, (a, i) => (u(), m("li", {
          key: i,
          class: "anw-group-item"
        }, [
          d("span", i4, [
            M(p(Q), { icon: p(b2) }, null, 8, ["icon"])
          ]),
          J(k(a), 1)
        ]))), 128))
      ])
    ]));
  }
}), o4 = { "data-test-id": "arrow-page-left" }, s4 = {
  key: 0,
  "aria-hidden": "true",
  class: "mr-0 flex h-10 items-center justify-center bg-white pl-4 pr-2.5 leading-tight text-neutral-300 sm:pr-4 lg:mr-6"
}, l4 = ["href"], c4 = { class: "sr-only" }, u4 = /* @__PURE__ */ x({
  __name: "PreviousButton",
  props: {
    currentPage: {},
    baseUrl: {}
  },
  emits: ["update:currentPage"],
  setup(t, { emit: e }) {
    const n = e;
    return (a, i) => (u(), m("li", o4, [
      a.currentPage === 1 ? (u(), m("span", s4, i[1] || (i[1] = [
        d("svg", {
          fill: "none",
          height: "12",
          viewBox: "0 0 7 12",
          width: "7",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          d("path", {
            d: "M5.75 10.5L1.25 6L5.75 1.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5"
          })
        ], -1)
      ]))) : (u(), m("a", {
        key: 1,
        href: `${a.baseUrl}?p=${a.currentPage - 1}`,
        class: "mr-0 flex h-10 cursor-pointer items-center justify-center bg-white pl-4 pr-2.5 leading-tight text-info-400 outline-2 -outline-offset-2 hover:bg-info-50 active:bg-info-100/25 sm:pr-4 lg:mr-6",
        onClick: i[0] || (i[0] = Pn((r) => n("update:currentPage", a.currentPage - 1), ["prevent"]))
      }, [
        d("span", c4, k(`Gehe zur Seite ${a.currentPage - 1}`), 1),
        i[2] || (i[2] = d("svg", {
          "aria-hidden": "true",
          fill: "none",
          height: "12",
          viewBox: "0 0 7 12",
          width: "7",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          d("path", {
            d: "M5.75 10.5L1.25 6L5.75 1.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5"
          })
        ], -1))
      ], 8, l4))
    ]));
  }
}), d4 = { "data-test-id": "arrow-page-right" }, f4 = {
  key: 0,
  "aria-hidden": "true",
  class: "ml-0 flex h-10 items-center justify-center bg-white pl-2.5 pr-4 leading-tight text-neutral-300 sm:pl-4 lg:ml-6"
}, m4 = ["href"], p4 = { class: "sr-only" }, g4 = /* @__PURE__ */ x({
  __name: "NextButton",
  props: {
    currentPage: {},
    lastPage: {},
    baseUrl: {}
  },
  emits: ["update:currentPage"],
  setup(t, { emit: e }) {
    const n = e;
    return (a, i) => (u(), m("li", d4, [
      a.currentPage === a.lastPage ? (u(), m("span", f4, i[1] || (i[1] = [
        d("svg", {
          fill: "none",
          height: "12",
          viewBox: "0 0 7 12",
          width: "7",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          d("path", {
            d: "M1.25 10.5L5.75 6L1.25 1.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5"
          })
        ], -1)
      ]))) : (u(), m("a", {
        key: 1,
        href: `${a.baseUrl}?p=${a.currentPage + 1}`,
        class: "ml-0 flex h-10 cursor-pointer items-center justify-center bg-white pl-2.5 pr-4 leading-tight text-info-400 outline-2 -outline-offset-2 hover:bg-info-50 active:bg-info-100/25 sm:pl-4 lg:ml-6",
        onClick: i[0] || (i[0] = Pn((r) => n("update:currentPage", a.currentPage + 1), ["prevent"]))
      }, [
        d("span", p4, k(`Gehe zur Seite ${a.currentPage + 1}`), 1),
        i[2] || (i[2] = d("svg", {
          "aria-hidden": "true",
          fill: "none",
          height: "12",
          viewBox: "0 0 7 12",
          width: "7",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          d("path", {
            d: "M1.25 10.5L5.75 6L1.25 1.5",
            stroke: "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5"
          })
        ], -1))
      ], 8, m4))
    ]));
  }
}), h4 = ["data-test-id"], v4 = ["href", "aria-current", "onClick"], A4 = {
  key: 1,
  class: "h-10 px-1 leading-tight sm:px-2 lg:px-4"
}, $a = 4, b4 = /* @__PURE__ */ x({
  __name: "PageNumbers",
  props: {
    currentPage: {},
    numberOfPages: {},
    baseUrl: {}
  },
  emits: ["update:currentPage"],
  setup(t) {
    const e = t, n = w(() => {
      const a = Math.ceil($a / 2);
      let i = e.currentPage - a + 1, r = e.currentPage + a - 1;
      i < 1 && (i = 1, r = Math.min(e.numberOfPages, $a)), r > e.numberOfPages && (r = e.numberOfPages, i = Math.max(1, r - $a + 1));
      const o = [];
      i > 1 && (o.push(1), i > 2 && o.push("..."));
      for (let s = i; s <= r; s++)
        o.push(s);
      return r < e.numberOfPages && (r < e.numberOfPages - 1 && o.push("..."), o.push(e.numberOfPages)), o;
    });
    return (a, i) => (u(!0), m(U, null, ne(n.value, (r) => (u(), m("li", {
      key: r,
      "data-test-id": `button-page-${r}`
    }, [
      isNaN(r) ? (u(), m("span", A4, k(r), 1)) : (u(), m("a", {
        key: 0,
        href: `${a.baseUrl}?p=${r}`,
        class: L([
          "flex h-10 cursor-pointer items-center justify-center rounded-sm px-3.5 leading-tight outline-2 hover:!no-underline sm:px-4",
          r === a.currentPage ? "bg-info-300 !text-white" : "bg-white text-neutral-900 -outline-offset-2 hover:bg-info-50 hover:text-neutral-900 active:bg-info-100/25"
        ]),
        "aria-current": r === a.currentPage,
        onClick: Pn((o) => a.$emit("update:currentPage", r), ["prevent"])
      }, k(r), 11, v4))
    ], 8, h4))), 128));
  }
}), w4 = ["aria-label"], C4 = { class: "flex h-10 items-center justify-center gap-0.5 -space-x-px text-base lg:gap-1" }, y4 = /* @__PURE__ */ x({
  __name: "AnwPagination",
  props: {
    currentPage: {},
    numberOfPages: {},
    baseUrl: { default: "" }
  },
  emits: ["update:currentPage"],
  setup(t, { emit: e }) {
    const n = t, a = N(n.currentPage), i = e;
    be(
      () => n.currentPage,
      (o) => {
        a.value = o;
      }
    );
    const r = (o) => {
      a.value = o, i("update:currentPage", o);
    };
    return (o, s) => o.numberOfPages > 1 ? (u(), m("nav", {
      key: 0,
      "aria-label": "Seitennummerierung, Seite " + a.value
    }, [
      d("ul", C4, [
        M(u4, {
          "base-url": o.baseUrl,
          "current-page": a.value,
          "onUpdate:currentPage": r
        }, null, 8, ["base-url", "current-page"]),
        M(b4, {
          "base-url": o.baseUrl,
          "number-of-pages": o.numberOfPages,
          "current-page": a.value,
          "onUpdate:currentPage": r
        }, null, 8, ["base-url", "number-of-pages", "current-page"]),
        M(g4, {
          "base-url": o.baseUrl,
          "last-page": o.numberOfPages,
          "current-page": a.value,
          "onUpdate:currentPage": r
        }, null, 8, ["base-url", "last-page", "current-page"])
      ])
    ], 8, w4)) : T("", !0);
  }
}), Cs = (t) => {
  const e = N(), n = N(), a = N(null), i = N(null), r = N(null), o = w(() => ({
    "anw-position-invert": r.value < a.value || i.value < a.value
  }));
  return be(
    () => t.value,
    (s) => {
      s && wi(() => {
        const l = n.value.getBoundingClientRect(), { left: c, right: f } = e.value.getBoundingClientRect();
        a.value = l.width, i.value = c + a.value, r.value = window.innerWidth - f + a.value;
      });
    }
  ), { elementRef: e, wrapperRef: n, elementWidth: a, elementPosLeft: i, elementPosRight: r, invertClass: o };
}, k4 = { class: "flex items-center justify-between" }, x4 = { class: "anw-text-p3 font-semibold text-neutral-900" }, E4 = { class: "flex flex-col gap-6" }, S4 = /* @__PURE__ */ x({
  __name: "AnwPopup",
  props: {
    title: { default: "" },
    position: { default: "bottom-left" },
    isVisible: { type: Boolean },
    ignoreElRef: { default: null }
  },
  emits: ["update:isVisible"],
  setup(t, { emit: e }) {
    const n = t, a = e, i = (v) => {
      v.key === "Escape" && g();
    }, { isVisible: r, ignoreElRef: o } = st(n), { elementRef: s, wrapperRef: l, invertClass: c } = Cs(r), f = w(() => ({
      "bottom-left": "absolute top-full right-0 mt-3",
      "bottom-right": "absolute top-full left-0 mt-3",
      center: "fixed inset-0 m-auto"
    })[n.position || "bottom-left"]), g = () => {
      a("update:isVisible", !1);
    };
    return Dn(s, g, { ignore: [o] }), Ct(() => {
      document.addEventListener("keyup", (v) => i(v)), window.addEventListener("resize", g);
    }), ya(() => {
      document.removeEventListener("keyup", (v) => i(v)), window.removeEventListener("resize", g);
    }), (v, A) => p(r) ? (u(), m("div", {
      key: 0,
      ref_key: "popupWrapperRef",
      ref: l
    }, [
      d("div", {
        ref_key: "popupRef",
        ref: s,
        class: L(["align-start flex h-52 w-96 flex-col gap-8 rounded bg-white p-6 shadow-full", [f.value, p(c)]])
      }, [
        d("div", k4, [
          d("p", x4, k(v.title), 1),
          d("button", {
            type: "button",
            class: "text-neutral-800",
            onClick: g
          }, [
            A[0] || (A[0] = d("span", { class: "sr-only" }, "Schließen", -1)),
            M(p(Q), {
              icon: p(Ma),
              class: "text-[24px]"
            }, null, 8, ["icon"])
          ])
        ]),
        d("div", E4, [
          pe(v.$slots, "default")
        ])
      ], 2)
    ], 512)) : T("", !0);
  }
});
function T4(t, e, n, a) {
  function i(r) {
    return r instanceof n ? r : new n(function(o) {
      o(r);
    });
  }
  return new (n || (n = Promise))(function(r, o) {
    function s(f) {
      try {
        c(a.next(f));
      } catch (g) {
        o(g);
      }
    }
    function l(f) {
      try {
        c(a.throw(f));
      } catch (g) {
        o(g);
      }
    }
    function c(f) {
      f.done ? r(f.value) : i(f.value).then(s, l);
    }
    c((a = a.apply(t, [])).next());
  });
}
function M4(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var I4 = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) return !1;
    var a, i, r;
    if (Array.isArray(e)) {
      if (a = e.length, a != n.length) return !1;
      for (i = a; i-- !== 0; )
        if (!t(e[i], n[i])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
    if (r = Object.keys(e), a = r.length, a !== Object.keys(n).length) return !1;
    for (i = a; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, r[i])) return !1;
    for (i = a; i-- !== 0; ) {
      var o = r[i];
      if (!t(e[o], n[o])) return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, L4 = /* @__PURE__ */ M4(I4);
const qr = "__googleMapsScriptId";
var $t;
(function(t) {
  t[t.INITIALIZED = 0] = "INITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.SUCCESS = 2] = "SUCCESS", t[t.FAILURE = 3] = "FAILURE";
})($t || ($t = {}));
class Lt {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: e, authReferrerPolicy: n, channel: a, client: i, id: r = qr, language: o, libraries: s = [], mapIds: l, nonce: c, region: f, retries: g = 3, url: v = "https://maps.googleapis.com/maps/api/js", version: A }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = n, this.channel = a, this.client = i, this.id = r || qr, this.language = o, this.libraries = s, this.mapIds = l, this.nonce = c, this.region = f, this.retries = g, this.url = v, this.version = A, Lt.instance) {
      if (!L4(this.options, Lt.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Lt.instance.options)}`);
      return Lt.instance;
    }
    Lt.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? $t.FAILURE : this.done ? $t.SUCCESS : this.loading ? $t.LOADING : $t.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let e = this.url;
    return e += "?callback=__googleMapsCallback&loading=async", this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((e, n) => {
      this.loadCallback((a) => {
        a ? n(a.error) : e(window.google);
      });
    });
  }
  importLibrary(e) {
    return this.execute(), google.maps.importLibrary(e);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var e, n;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const a = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(a).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (r) => !a[r] && delete a[r]
    ), !((n = (e = window == null ? void 0 : window.google) === null || e === void 0 ? void 0 : e.maps) === null || n === void 0) && n.importLibrary || ((r) => {
      let o, s, l, c = "The Google Maps JavaScript API", f = "google", g = "importLibrary", v = "__ib__", A = document, y = window;
      y = y[f] || (y[f] = {});
      const _ = y.maps || (y.maps = {}), C = /* @__PURE__ */ new Set(), b = new URLSearchParams(), S = () => (
        // @ts-ignore
        o || (o = new Promise((F, V) => T4(this, void 0, void 0, function* () {
          var j;
          yield s = A.createElement("script"), s.id = this.id, b.set("libraries", [...C] + "");
          for (l in r)
            b.set(l.replace(/[A-Z]/g, (q) => "_" + q[0].toLowerCase()), r[l]);
          b.set("callback", f + ".maps." + v), s.src = this.url + "?" + b, _[v] = F, s.onerror = () => o = V(Error(c + " could not load.")), s.nonce = this.nonce || ((j = A.querySelector("script[nonce]")) === null || j === void 0 ? void 0 : j.nonce) || "", A.head.append(s);
        })))
      );
      _[g] ? console.warn(c + " only loads once. Ignoring:", r) : _[g] = (F, ...V) => C.add(F) && S().then(() => _[g](F, ...V));
    })(a);
    const i = this.libraries.map((r) => this.importLibrary(r));
    i.length || i.push(this.importLibrary("core")), Promise.all(i).then(() => this.callback(), (r) => {
      const o = new ErrorEvent("error", { error: r });
      this.loadErrorCallback(o);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const n = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${n} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, n);
    } else
      this.onerrorEvent = e, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
const _4 = {
  key: 0,
  class: "relative mb-3 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
}, O4 = /* @__PURE__ */ x({
  __name: "AnwApiMap",
  props: {
    apiKey: {},
    marker: {},
    mapCenter: { default: null },
    mapWidth: { default: "100%" },
    mapHeight: {},
    zoom: { default: 16 },
    maxZoomLevel: { default: 22 },
    refMapContainer: { default: null },
    destinationAddress: { default: "" },
    dataAttributes: { default: () => ({}) }
  },
  setup(t) {
    const e = t, n = {
      version: "weekly",
      language: "de",
      region: "de",
      libraries: [],
      apiKey: ""
    };
    e.apiKey !== "editme" && (n.apiKey = e.apiKey, n.libraries = ["marker"]);
    const a = new Lt(n), i = (c) => {
      a.importLibrary("maps").then(({ Map: f }) => {
        const g = Array.from(document.getElementsByClassName(`map-element-${c}`));
        let v;
        for (v = 0; v < g.length; v++)
          if (!g[v].dataset.coordinates) {
            g[v].dataset.coordinates = e.marker.lat + "," + e.marker.lng;
            break;
          }
        const A = new f(g[v], {
          center: {
            lat: e.mapCenter ? e.mapCenter.lat : e.marker.lat,
            lng: e.mapCenter ? e.mapCenter.lng : e.marker.lng
          },
          zoom: e.zoom,
          maxZoom: e.maxZoomLevel,
          controlSize: 25,
          fullscreenControl: !1
        });
        if (e.destinationAddress) {
          const y = document.createElement("A");
          y.classList.add("anw-btn", "anw-btn-secondary-outline", "!min-h-[25px]", "!bottom-4"), y.target = "_blank", y.innerText = "Route planen", y.href = `https://maps.google.de/maps?daddr=${encodeURI(e.destinationAddress)}`;
          for (const [_, C] of Object.entries(e.dataAttributes || {}))
            y.setAttribute(_, C);
          A.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(y);
        }
        new google.maps.Marker({
          position: { lat: e.marker.lat, lng: e.marker.lng },
          map: A
        });
      });
    }, r = (c, f) => `width: ${c}; height: ${f}`, o = {
      [e.refMapContainer]: N()
    }, s = {
      [e.refMapContainer]: N(!1)
    }, { stop: l } = pu(o[e.refMapContainer], ([{ isIntersecting: c }]) => {
      s[e.refMapContainer].value = c;
    });
    return be(
      () => s[e.refMapContainer].value,
      () => {
        s[e.refMapContainer].value && (i(e.refMapContainer), l());
      }
    ), (c, f) => (u(), m("div", {
      ref: o[c.refMapContainer],
      class: "map-container"
    }, [
      c.apiKey === "" ? (u(), m("div", _4, " Specify API Key to proceed ")) : T("", !0),
      d("div", {
        class: L("map-element-" + c.refMapContainer),
        style: bi(r(c.mapWidth, c.mapHeight))
      }, null, 6)
    ], 512));
  }
}), P4 = ["src"], B4 = /* @__PURE__ */ x({
  __name: "AnwStaticMap",
  props: {
    marker: {},
    mapWidth: {},
    mapHeight: {}
  },
  setup(t) {
    const e = t, n = w(() => `https://maps.google.com/maps?hl=en&gl=US&q=${e.marker.lat},${e.marker.lng}&output=embed`), a = (i, r) => `width: ${i}px; height: ${r}px`;
    return (i, r) => (u(), m("div", {
      class: "relative max-w-full",
      style: bi(a(i.mapWidth, i.mapHeight))
    }, [
      d("iframe", {
        class: "absolute inset-0 h-full w-full",
        src: n.value
      }, null, 8, P4)
    ], 4));
  }
}), R4 = { class: "tabs" }, N4 = ["aria-label"], D4 = ["id", "data-test-id", "aria-selected", "aria-controls", "tabindex", "onClick", "onKeydown"], H4 = ["id", "data-test-id", "aria-labelledby"], F4 = /* @__PURE__ */ x({
  __name: "AnwTabs",
  props: {
    label: {},
    idKey: {},
    list: {}
  },
  setup(t) {
    const e = t, n = N(0), a = N(0), i = (s) => {
      n.value = s;
    }, r = (s) => {
      const l = document.querySelectorAll(".tabs button"), c = e.list.length;
      a.value = s > 0 ? s - 1 : c - 1, l[a.value].focus();
    }, o = (s) => {
      const l = document.querySelectorAll(".tabs button");
      a.value = s < e.list.length - 1 ? s + 1 : 0, l[a.value].focus();
    };
    return (s, l) => (u(), m("div", R4, [
      d("div", {
        role: "tablist",
        "aria-label": s.label,
        class: "mb-4 flex flex-wrap gap-[15px]"
      }, [
        (u(!0), m(U, null, ne(s.list, (c, f) => (u(), m("button", {
          id: `${s.idKey}-${f}`,
          key: f,
          "data-test-id": `${s.idKey}-${f}`,
          type: "button",
          role: "tab",
          "aria-selected": f === n.value,
          "aria-controls": s.idKey + "panel-" + f,
          class: L(["rounded-md border bg-neutral-50 px-2.5 py-[5px] text-xs text-neutral-900 hover:bg-neutral-200", f === n.value ? "border-primary" : "border-neutral-50"]),
          tabindex: f !== n.value ? "-1" : void 0,
          onClick: (g) => i(f),
          onKeydown: [
            fa((g) => r(f), ["arrow-left"]),
            fa((g) => o(f), ["arrow-right"])
          ]
        }, k(c.tab), 43, D4))), 128))
      ], 8, N4),
      (u(!0), m(U, null, ne(s.list, (c, f) => (u(), m("div", {
        id: `${s.idKey}panel-${f}`,
        key: f,
        "data-test-id": `${s.idKey}panel-${f}`,
        role: "tabpanel",
        "aria-labelledby": s.idKey + "-" + f,
        class: L({ hidden: f !== n.value })
      }, [
        (u(), D(ht(c.panel)))
      ], 10, H4))), 128))
    ]));
  }
}), V4 = {
  "top-right": "anw-toast-top-right",
  "top-left": "anw-toast-top-left",
  "top-center": "anw-toast-top-center",
  "bottom-right": "anw-toast-bottom-right",
  "bottom-left": "anw-toast-bottom-left",
  "bottom-center": "anw-toast-bottom-center"
}, z4 = { class: "anw-text-p3 font-semibold text-neutral-900" }, U4 = /* @__PURE__ */ x({
  __name: "AnwToast",
  props: {
    message: {},
    isVisible: { type: Boolean },
    position: { default: null },
    timeout: { default: null }
  },
  emits: ["update:isVisible"],
  setup(t, { emit: e }) {
    const n = t, a = e;
    let i;
    function r() {
      n.timeout && clearTimeout(i);
    }
    function o() {
      n.timeout && (i = window.setTimeout(() => s(), n.timeout * 1e3));
    }
    function s() {
      a("update:isVisible", !1);
    }
    return be(
      () => n.isVisible,
      () => {
        if (n.isVisible && n.timeout) {
          o();
          return;
        }
        n.timeout && r();
      }
    ), (l, c) => l.isVisible ? (u(), m("div", {
      key: 0,
      id: "toast-default",
      class: L(["anw-toast", { [p(V4)[l.position]]: l.position }]),
      role: "alert",
      onMouseover: r,
      onMouseleave: o
    }, [
      d("p", z4, k(l.message), 1),
      d("button", {
        class: "ml-auto text-neutral-800",
        onClick: s
      }, [
        M(p(Q), {
          icon: p(Ma),
          class: "text-[24px]"
        }, null, 8, ["icon"])
      ])
    ], 34)) : T("", !0);
  }
}), Q4 = {
  key: 0,
  class: "anw-tooltip-backdrop block"
}, j4 = { class: "flex items-center justify-between" }, Z4 = { class: "align-center flex items-center gap-2" }, G4 = { class: "anw-text-p1 font-normal text-neutral-900" }, Y4 = { class: "flex flex-col gap-6" }, K4 = /* @__PURE__ */ x({
  __name: "AnwTooltip",
  props: {
    title: { default: "" },
    icon: { default: null },
    position: { default: "bottom-left" },
    isVisible: { type: Boolean, default: !0 },
    ignoreElRef: { default: null }
  },
  emits: ["update:isVisible"],
  setup(t, { emit: e }) {
    const n = t, { isVisible: a, ignoreElRef: i } = st(n), { elementRef: r, wrapperRef: o, invertClass: s } = Cs(a), l = mu("(max-width: 480px)"), c = w(() => ({
      "fixed h-min inset-0 m-auto": n.position === "center" || l.value,
      "absolute top-full right-0 mt-3": n.position === "bottom-left" && !l.value,
      "absolute top-full left-0 mt-3": n.position === "bottom-right" && !l.value,
      invertClass: s.value && !l.value
    })), f = () => g("update:isVisible", !1);
    Dn(r, f, { ignore: [i] });
    const g = e, v = (A) => {
      A.key === "Escape" && f();
    };
    return Ct(() => {
      document.addEventListener("keyup", (A) => v(A));
    }), ya(() => {
      document.removeEventListener("keyup", (A) => v(A));
    }), (A, y) => (u(), m(U, null, [
      p(a) ? (u(), m("div", Q4)) : T("", !0),
      p(a) ? (u(), m("div", {
        key: 1,
        ref_key: "tooltipWrapperRef",
        ref: o
      }, [
        d("div", ge({
          ref_key: "tooltipRef",
          ref: r,
          class: "align-start flex w-96 flex-col gap-4 rounded-xl border border-neutral-200 bg-white p-6 drop-shadow-lg"
        }, A.$attrs, { class: c.value }), [
          d("div", j4, [
            d("div", Z4, [
              A.icon ? (u(), D(p(Q), {
                key: 0,
                icon: A.icon,
                class: "shrink-0 text-[14px]",
                "aria-hidden": "true"
              }, null, 8, ["icon"])) : T("", !0),
              d("p", G4, k(A.title), 1)
            ]),
            d("button", {
              class: "text-neutral-800",
              onClick: f
            }, [
              M(p(Q), {
                icon: p(Ma),
                class: "text-[24px]"
              }, null, 8, ["icon"])
            ])
          ]),
          y[0] || (y[0] = d("span", { class: "border-b border-info-50" }, null, -1)),
          d("div", Y4, [
            pe(A.$slots, "default")
          ])
        ], 16)
      ], 512)) : T("", !0)
    ], 64));
  }
}), $4 = { class: "relative z-10 min-h-[48px] text-base text-neutral-700" }, J4 = ["innerHTML"], W4 = /* @__PURE__ */ x({
  __name: "AnwQuote",
  props: {
    content: {}
  },
  setup(t) {
    return (e, n) => (u(), m("blockquote", null, [
      d("div", $4, [
        M(p(Q), {
          icon: p(Hf),
          class: "absolute -left-0.5 -top-6 -z-10 text-[96px] text-neutral-100",
          "aria-hidden": "true"
        }, null, 8, ["icon"]),
        d("div", {
          class: "ps-4",
          innerHTML: e.content
        }, null, 8, J4)
      ])
    ]));
  }
}), q4 = { class: "grid justify-items-start gap-4" }, X4 = ["innerHTML"], e3 = /* @__PURE__ */ x({
  __name: "AnwReadMore",
  props: {
    text: {},
    isExpanded: { type: Boolean, default: !1 },
    areaLabel: { default: "" }
  },
  setup(t) {
    const e = t, { isExpanded: n } = st(e), a = {
      readMore: "Weiterlesen"
    }, i = N(n.value), r = N(!0), o = N();
    return be(
      () => {
        var s;
        return [n.value, (s = o.value) == null ? void 0 : s.scrollHeight];
      },
      () => {
        var s, l;
        i.value = n.value, ((s = o.value) == null ? void 0 : s.clientHeight) >= ((l = o.value) == null ? void 0 : l.scrollHeight) && (r.value = !1);
      }
    ), (s, l) => (u(), m("div", q4, [
      d("div", {
        ref_key: "readMore",
        ref: o,
        class: L([{ "anw-collapse": !i.value }, "anw-wysiwyg"]),
        innerHTML: s.text
      }, null, 10, X4),
      r.value ? (u(), D(Hi, {
        key: 0,
        "aria-label": i.value ? "" : s.areaLabel,
        icon: i.value ? p(es) : p(Xo),
        label: a.readMore,
        appearance: "link",
        "aria-expanded": "false",
        class: "text-info-500 hover:underline",
        "icon-position": "right",
        onClick: l[0] || (l[0] = (c) => i.value = !i.value)
      }, null, 8, ["aria-label", "icon", "label"])) : T("", !0)
    ]));
  }
}), t3 = ["href", "target"], n3 = {
  key: 0,
  class: "sr-only"
}, a3 = {
  key: 1,
  class: "sr-only"
}, _a = /* @__PURE__ */ x({
  __name: "AnwLink",
  props: {
    href: {},
    targetBlank: { type: Boolean },
    stretch: { type: Boolean },
    label: {},
    srLabelExtension: { default: "" },
    appearance: { default: "link" },
    fontWeight: { default: "normal" },
    attributeGA: { default: () => ({}) }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "anw-link-block": e.appearance === "block",
      "anw-link-block-outline": e.appearance === "block-outline",
      "anw-text-link": e.appearance === "text-link",
      "anw-link": e.appearance === "link",
      "anw-link-secondary-outline": e.appearance === "secondary-outline",
      "font-normal": e.fontWeight === "normal",
      "font-semibold": e.fontWeight === "semibold",
      "before:absolute before:inset-0": e.stretch === !0
    })), a = w(() => e.targetBlank ? "_blank" : void 0);
    return (i, r) => (u(), m("a", ge({
      href: i.href,
      class: n.value,
      target: a.value
    }, { ...i.attributeGA }), [
      J(k(i.label) + " ", 1),
      i.srLabelExtension ? (u(), m("span", n3, k(i.srLabelExtension), 1)) : T("", !0),
      i.targetBlank ? (u(), m("span", a3, "Link in einem neuen Tab öffnen")) : T("", !0),
      i.appearance === "link" ? (u(), D(p(Q), {
        key: 2,
        icon: p(an),
        class: "ml-1 text-[18px]",
        "aria-hidden": "true"
      }, null, 8, ["icon"])) : T("", !0)
    ], 16, t3));
  }
}), i3 = { class: "grid justify-items-start gap-4" }, r3 = ["innerHTML"], o3 = /* @__PURE__ */ x({
  __name: "AnwReadMoreExternal",
  props: {
    text: {},
    previewLength: { default: 242 },
    areaLabel: { default: "" },
    title: { default: "" },
    href: { default: "" },
    targetBlank: { type: Boolean, default: !0 },
    showFollowLink: { type: Boolean, default: !0 },
    labelFollowLink: { default: "Weiterlesen" },
    attributeGA: { default: () => ({}) }
  },
  setup(t) {
    const e = t, n = N("");
    Ct(async () => {
      await wi(), n.value = a();
    });
    const a = () => {
      const { previewLength: i, text: r } = e, o = "...";
      if (i >= r.length) return r;
      let f = new DOMParser().parseFromString(r, "text/html").body.innerHTML.slice(0, i) + o;
      const g = f.match(/<[^/].*?>/g) || [], v = f.match(/<\/.*?>/g) || [], A = g.length, y = v.length;
      if (A > y) {
        const _ = A - y;
        for (let C = 0; C < _; C++)
          f += `</${g[A - C - 1].substring(1)}`;
      }
      return f;
    };
    return (i, r) => (u(), m("div", i3, [
      d("div", ge({ class: "anw-wysiwyg" }, i.$attrs, { innerHTML: n.value }), null, 16, r3),
      i.showFollowLink ? (u(), D(_a, {
        key: 0,
        class: "flex w-full justify-center sm:justify-start",
        "attribute-g-a": i.attributeGA,
        href: i.href,
        label: i.labelFollowLink,
        title: i.title,
        "font-weight": "semibold",
        "target-blank": i.targetBlank,
        "aria-label": i.areaLabel
      }, null, 8, ["attribute-g-a", "href", "label", "title", "target-blank", "aria-label"])) : T("", !0)
    ]));
  }
}), s3 = ["innerHTML"], l3 = /* @__PURE__ */ x({
  __name: "AnwReadMoreFaded",
  props: {
    text: {},
    isExpanded: { type: Boolean, default: !1 },
    areaLabel: { default: "" }
  },
  setup(t) {
    const e = t, { isExpanded: n } = st(e), a = {
      readMore: "Weiterlesen",
      readLess: "Weniger anzeigen"
    }, i = N(n.value), r = N(!0), o = N(), s = N(null);
    be(
      () => {
        var c;
        return [n.value, (c = o.value) == null ? void 0 : c.scrollHeight];
      },
      () => {
        var c, f;
        i.value = n.value, ((c = o.value) == null ? void 0 : c.clientHeight) >= ((f = o.value) == null ? void 0 : f.scrollHeight) && (r.value = !1);
      }
    );
    const l = () => {
      i.value = !i.value;
    };
    return (c, f) => (u(), m(U, null, [
      d("div", {
        class: L([{ "anw-collapse-gradient": !i.value }, "anw-wysiwyg mb-4"]),
        innerHTML: c.text
      }, null, 10, s3),
      d("div", {
        ref_key: "readMoreBtn",
        ref: s,
        tabindex: "0",
        class: "flex justify-center focus:outline-none sm:justify-start"
      }, [
        r.value ? (u(), D(Hi, {
          key: 0,
          "aria-label": i.value ? "" : c.areaLabel,
          icon: i.value ? p(es) : p(Xo),
          label: i.value ? a.readLess : a.readMore,
          appearance: "link",
          "aria-expanded": "false",
          class: "text-info-500 hover:underline",
          "icon-position": "right",
          onClick: l
        }, null, 8, ["aria-label", "icon", "label"])) : T("", !0)
      ], 512)
    ], 64));
  }
}), zi = () => ({
  formatRatingAverage: (e) => Intl.NumberFormat("de-DE", { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(e)
}), c3 = { class: "relative flex gap-2 rounded-xl bg-neutral-50 p-2.5 text-left" }, u3 = { class: "shrink-0" }, d3 = ["src", "alt"], f3 = { class: "text-xs text-neutral-600" }, m3 = ["href", "target", "title"], p3 = { class: "mt-1.5 flex items-center gap-1.5 text-sm font-bold" }, g3 = { class: "mt-0.5 text-xs text-neutral-600" }, h3 = {
  key: 1,
  class: "mt-0.5 text-xs/[22px] text-neutral-600"
}, v3 = ["innerHTML"], A3 = /* @__PURE__ */ x({
  __name: "CardLawyerHorizontal",
  props: {
    uri: {},
    imageUri: {},
    imageAlt: {},
    lawyerTitle: {},
    linkTitle: {},
    fullName: {},
    ratingAverage: {},
    ratingCount: {},
    formatterTextRating: {},
    dataAttributes: {},
    hideRating: { type: Boolean },
    linkTarget: {},
    practiceAreas: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", c3, [
      d("figure", u3, [
        d("img", {
          src: e.imageUri,
          width: "70",
          height: "70",
          class: "rounded-md",
          alt: e.imageAlt
        }, null, 8, d3)
      ]),
      d("div", null, [
        d("div", null, [
          d("p", f3, k(e.lawyerTitle), 1),
          d("a", ge(e.dataAttributes, {
            href: e.uri,
            target: e.linkTarget,
            title: e.linkTitle,
            class: "anw-default text-sm/[22px] font-semibold text-neutral-900 after:absolute after:inset-0 after:rounded-xl after:content-[''] hover:!text-neutral-900 hover:underline focus-visible:outline-none focus-visible:after:ring"
          }), [
            J(k(e.fullName) + " ", 1),
            n[0] || (n[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
          ], 16, m3)
        ]),
        !e.hideRating && e.ratingAverage > 0 ? (u(), m(U, { key: 0 }, [
          d("div", p3, [
            J(k(p(zi)().formatRatingAverage(e.ratingAverage)) + "/", 1),
            n[1] || (n[1] = d("span", { class: "-ml-1.5 text-neutral-500" }, "5", -1)),
            M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"])
          ]),
          d("div", g3, [
            d("span", null, k(e.ratingCount) + " " + k(e.formatterTextRating), 1)
          ])
        ], 64)) : (u(), m("p", h3, "Noch nicht bewertet")),
        d("div", {
          class: "mt-1.5 break-words text-xs font-semibold text-neutral-700",
          innerHTML: e.practiceAreas
        }, null, 8, v3)
      ])
    ]));
  }
}), b3 = { class: "relative flex h-full w-full max-w-[240px] flex-col gap-1.5 rounded-xl bg-neutral-50 p-2.5 text-left" }, w3 = { class: "mb-0.5 shrink-0" }, C3 = ["src", "alt"], y3 = { class: "text-xs text-neutral-600" }, k3 = ["href", "target", "title"], x3 = {
  key: 0,
  class: "gap-row-1.5 mt-1.5 text-sm font-bold"
}, E3 = { class: "text-xs font-normal text-neutral-600" }, S3 = {
  key: 1,
  class: "text-xs/[22px] text-neutral-600"
}, T3 = ["innerHTML"], M3 = /* @__PURE__ */ x({
  __name: "CardLawyerVertical",
  props: {
    uri: {},
    imageUri: {},
    imageAlt: {},
    lawyerTitle: {},
    linkTitle: {},
    fullName: {},
    ratingAverage: {},
    ratingCount: {},
    dataAttributes: {},
    formatterTextRating: {},
    hideRating: { type: Boolean },
    linkTarget: {},
    practiceAreas: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", b3, [
      d("figure", w3, [
        d("img", {
          src: e.imageUri,
          width: "120",
          height: "120",
          class: "w-full rounded-md",
          alt: e.imageAlt
        }, null, 8, C3)
      ]),
      d("div", null, [
        d("p", y3, k(e.lawyerTitle), 1),
        d("a", ge(e.dataAttributes, {
          href: e.uri,
          target: e.linkTarget,
          title: e.linkTitle,
          class: "anw-default text-sm/[22px] font-semibold text-neutral-900 after:absolute after:inset-0 after:rounded-xl after:content-[''] hover:!text-neutral-900 hover:underline focus-visible:outline-none focus-visible:after:ring"
        }), [
          J(k(e.fullName) + " ", 1),
          n[0] || (n[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
        ], 16, k3)
      ]),
      !e.hideRating && e.ratingCount > 0 ? (u(), m("div", x3, [
        J(k(p(zi)().formatRatingAverage(e.ratingAverage)) + "/", 1),
        n[1] || (n[1] = d("span", { class: "text-neutral-500" }, "5", -1)),
        M(je, {
          "rating-average": e.ratingAverage,
          class: "!my-0.5"
        }, null, 8, ["rating-average"]),
        d("span", E3, k(e.ratingCount) + " " + k(e.formatterTextRating), 1)
      ])) : (u(), m("p", S3, "Noch nicht bewertet")),
      d("div", {
        class: "mt-1.5 break-words text-xs font-semibold text-neutral-700",
        innerHTML: e.practiceAreas
      }, null, 8, T3)
    ]));
  }
}), I3 = { class: "relative flex w-full max-w-[240px] flex-col gap-2 rounded-xl bg-neutral-50 p-2.5 text-left lg:max-w-none lg:flex-row" }, L3 = { class: "shrink-0" }, _3 = ["src", "alt"], O3 = { class: "flex flex-col" }, P3 = { class: "text-xs text-neutral-600" }, B3 = ["href", "target", "title"], R3 = { class: "mt-1.5 flex flex-wrap items-center gap-1.5 text-sm font-bold" }, N3 = { class: "mt-0.5 text-xs text-neutral-600" }, D3 = {
  key: 1,
  class: "text-xs/[22px] text-neutral-600"
}, H3 = ["innerHTML"], F3 = /* @__PURE__ */ x({
  __name: "CardLawyerResponsive",
  props: {
    uri: {},
    imageUri: {},
    imageAlt: {},
    lawyerTitle: {},
    linkTitle: {},
    fullName: {},
    ratingAverage: {},
    ratingCount: {},
    dataAttributes: {},
    formatterTextRating: {},
    hideRating: { type: Boolean },
    linkTarget: {},
    practiceAreas: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", I3, [
      d("figure", L3, [
        d("img", {
          src: e.imageUri,
          width: "120",
          height: "120",
          class: "w-full rounded-md lg:w-[70px]",
          alt: e.imageAlt
        }, null, 8, _3)
      ]),
      d("div", O3, [
        d("div", null, [
          d("p", P3, k(e.lawyerTitle), 1),
          d("a", ge(e.dataAttributes, {
            href: e.uri,
            target: e.linkTarget,
            title: e.linkTitle,
            class: "anw-default text-sm/[22px] font-semibold text-neutral-900 after:absolute after:inset-0 after:rounded-xl after:content-[''] hover:!text-neutral-900 hover:underline focus-visible:outline-none focus-visible:after:ring"
          }), [
            J(k(e.fullName) + " ", 1),
            n[0] || (n[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
          ], 16, B3)
        ]),
        !e.hideRating && e.ratingCount > 0 ? (u(), m(U, { key: 0 }, [
          d("div", R3, [
            J(k(p(zi)().formatRatingAverage(e.ratingAverage)) + "/", 1),
            n[1] || (n[1] = d("span", { class: "-ml-1.5 text-neutral-500" }, "5", -1)),
            M(je, {
              "rating-average": e.ratingAverage,
              class: "!my-0"
            }, null, 8, ["rating-average"])
          ]),
          d("div", N3, [
            d("span", null, k(e.ratingCount) + " " + k(e.formatterTextRating), 1)
          ])
        ], 64)) : (u(), m("p", D3, "Noch nicht bewertet")),
        d("div", {
          class: "mt-1.5 break-words text-xs font-semibold text-neutral-700",
          innerHTML: e.practiceAreas
        }, null, 8, H3)
      ])
    ]));
  }
}), ys = /* @__PURE__ */ x({
  __name: "AnwCardLawyer",
  props: {
    uri: {},
    imageUri: {},
    imageAlt: { default: "" },
    linkTitle: { default: "" },
    lawyerTitle: { default: "" },
    fullName: {},
    ratingAverage: {},
    ratingCount: {},
    appearance: { default: "responsive" },
    dataAttributes: { default: null },
    hideRating: { type: Boolean, default: !1 },
    linkTarget: { default: "_parent" },
    practiceAreas: { default: void 0 },
    sex: { default: "" }
  },
  setup(t) {
    const e = t, n = w(() => e.ratingAverage.toFixed(1)), a = w(() => {
      switch (e.appearance) {
        case "horizontal":
          return A3;
        case "vertical":
          return M3;
        case "responsive":
        default:
          return F3;
      }
    }), i = w(() => {
      const o = e.sex === "Male" ? "Fachanwalt" : "Fachanwältin";
      return e.practiceAreas ? e.practiceAreas.map((s) => `${o} für ${s}`).join(", ") : "";
    }), r = w(() => e.ratingCount === 1 ? "Bewertung" : "Bewertungen");
    return (o, s) => (u(), D(ht(a.value), {
      uri: o.uri,
      "image-uri": o.imageUri,
      "image-alt": o.imageAlt,
      "link-title": o.linkTitle,
      "lawyer-title": o.lawyerTitle,
      "full-name": o.fullName,
      "rating-average": n.value,
      "rating-count": o.ratingCount,
      "data-attributes": o.dataAttributes,
      "hide-rating": o.hideRating,
      "practice-areas": i.value,
      "link-target": o.linkTarget,
      "formatter-text-rating": r.value
    }, null, 8, ["uri", "image-uri", "image-alt", "link-title", "lawyer-title", "full-name", "rating-average", "rating-count", "data-attributes", "hide-rating", "practice-areas", "link-target", "formatter-text-rating"]));
  }
}), V3 = { class: "relative flex w-[310px] gap-4 rounded-xl bg-neutral-50 p-2.5 text-left" }, z3 = { class: "shrink-0" }, U3 = ["src", "alt"], Q3 = { class: "flex flex-1 flex-col gap-1" }, j3 = ["href", "target", "title"], Z3 = /* @__PURE__ */ x({
  __name: "AnwCardWithImage",
  props: {
    uri: {},
    imageUri: {},
    imageAlt: {},
    linkTitle: {},
    title: {},
    dataAttributes: {},
    linkTarget: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", V3, [
      d("figure", z3, [
        d("img", {
          src: e.imageUri,
          width: "72",
          class: "rounded-xl",
          alt: e.imageAlt
        }, null, 8, U3)
      ]),
      d("div", Q3, [
        d("a", ge(e.dataAttributes, {
          href: e.uri,
          target: e.linkTarget,
          title: e.linkTitle,
          class: "anw-default grow text-base/[22px] font-semibold text-neutral-900 after:absolute after:inset-0 after:content-[''] hover:underline focus-visible:outline-none focus-visible:after:ring"
        }), [
          J(k(e.title) + " ", 1),
          n[0] || (n[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
        ], 16, j3),
        pe(e.$slots, "content")
      ])
    ]));
  }
}), G3 = ["disabled"], Y3 = { class: "sr-only" }, K3 = ["disabled"], $3 = { class: "sr-only" }, J3 = /* @__PURE__ */ x({
  __name: "AnwCarouselLawyers",
  props: {
    content: {},
    itemsToShow: {},
    wrapAround: { type: Boolean },
    breakpoints: {},
    transition: {},
    dataAttributes: {}
  },
  setup(t) {
    const e = {
      ariaNextSlide: "Zum nächsten Bild",
      ariaPreviousSlide: "Zum vorherigen Bild",
      ariaNavigateToSlide: "Zu Bild {slideNumber}",
      ariaGallery: "Galerie",
      itemXofY: "Bild {currentSlide} von {slidesCount}"
    }, n = N(null);
    return (a, i) => (u(), D(p(Fi), {
      ref_key: "carouselLawyers",
      ref: n,
      "items-to-show": a.itemsToShow,
      "snap-align": "start",
      "wrap-around": a.wrapAround,
      breakpoints: a.breakpoints,
      transition: a.transition,
      i18n: e,
      class: "anw-carousel-nav-bottom -mx-1.5"
    }, {
      addons: le(({ currentSlide: r, slidesCount: o }) => [
        o > 1 ? (u(), m(U, { key: 0 }, [
          d("button", {
            type: "button",
            class: "anw-carousel-btn",
            tabindex: "-1",
            disabled: r === 0,
            onClick: i[0] || (i[0] = (s) => n.value.prev())
          }, [
            d("span", Y3, k(e.ariaPreviousSlide), 1),
            M(p(Q), {
              icon: p(Ia),
              class: "text-[24px]",
              "aria-label": "true"
            }, null, 8, ["icon"])
          ], 8, G3),
          d("button", {
            type: "button",
            class: "anw-carousel-btn",
            tabindex: "-1",
            disabled: a.itemsToShow + r === o || r + 1 === o,
            onClick: i[1] || (i[1] = (s) => n.value.next())
          }, [
            d("span", $3, k(e.ariaNextSlide), 1),
            M(p(Q), {
              icon: p(an),
              class: "text-[24px]",
              "aria-label": "true"
            }, null, 8, ["icon"])
          ], 8, K3)
        ], 64)) : T("", !0)
      ]),
      default: le(() => [
        (u(!0), m(U, null, ne(a.content, (r) => (u(), D(p(Vi), {
          key: r.id,
          class: L("p-1.5")
        }, {
          default: le(() => [
            M(ys, {
              "data-attributes": a.dataAttributes,
              uri: r.uri,
              "image-uri": r.imageUri,
              "full-name": r.fullName,
              "lawyer-title": r.lawyerTitle,
              "rating-average": r.ratingAverage,
              "rating-count": r.ratingCount,
              "practice-areas": r.practiceAreas,
              sex: r.sex,
              appearance: "vertical"
            }, null, 8, ["data-attributes", "uri", "image-uri", "full-name", "lawyer-title", "rating-average", "rating-count", "practice-areas", "sex"])
          ]),
          _: 2
        }, 1024))), 128))
      ]),
      _: 1
    }, 8, ["items-to-show", "wrap-around", "breakpoints", "transition"]));
  }
}), W3 = ["aria-label", "title"], q3 = /* @__PURE__ */ x({
  __name: "AnwCopyToClipboard",
  props: {
    title: { default: null },
    content: {},
    appearance: { default: "button" },
    icon: { default: null },
    iconSize: { default: 24 },
    iconColor: { default: "text-info-500" },
    customClass: { default: null },
    titleAttribute: { default: null },
    ariaLabel: { default: "Link in die Zwischenablage kopieren" },
    attributeGA: { default: () => ({}) }
  },
  setup(t) {
    const e = t, n = () => {
      navigator == null || navigator.clipboard.writeText(e.content).then(() => {
        console.log(e.content + " copied to clipboard");
      }).catch((r) => {
        console.error("Failed to copy to clipboard:", r);
      });
    }, a = w(() => ({
      "anw-clipboard-btn": e.appearance === "button",
      "inline-flex items-center": e.appearance === "icon"
    })), i = w(() => e.icon ? e.icon : e.appearance === "icon" ? S2 : g2);
    return (r, o) => (u(), m("button", ge({ ...r.attributeGA }, {
      "data-test-id": "copy-url-to-clipboard",
      type: "button",
      class: a.value,
      "aria-label": r.ariaLabel,
      title: r.titleAttribute,
      onClick: n
    }), [
      J(k(r.title) + " ", 1),
      M(p(Q), {
        icon: i.value,
        class: L([`text-[${r.iconSize}px] ${r.iconColor} ${r.customClass}`, "ms-1.5"]),
        "aria-hidden": "true"
      }, null, 8, ["icon", "class"])
    ], 16, W3));
  }
}), X3 = {}, e6 = { class: "anw-badge" };
function t6(t, e) {
  return u(), m("div", e6, [
    pe(t.$slots, "default")
  ]);
}
const n6 = /* @__PURE__ */ tn(X3, [["render", t6]]), a6 = /* @__PURE__ */ x({
  __name: "AnwPill",
  props: {
    pillText: {},
    bgColor: { default: "white" }
  },
  setup(t) {
    return (e, n) => (u(), m("div", {
      class: L(["anw-pill", `anw-pill-${e.bgColor}`])
    }, k(e.pillText), 3));
  }
}), i6 = { class: "anw-text-p2 mt-1 font-semibold" }, r6 = /* @__PURE__ */ x({
  __name: "AnwRatingText",
  props: {
    ratingAverage: {}
  },
  setup(t) {
    return (e, n) => (u(), m(U, null, [
      M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"]),
      d("p", i6, k(p(go)[Math.floor(e.ratingAverage) - 1]), 1)
    ], 64));
  }
}), o6 = { class: "anw-rating-icon-container" }, s6 = { class: "anw-rating-icon" }, l6 = {
  key: 0,
  class: "text-4xl/6 font-bold text-white"
}, c6 = { class: "flex flex-grow flex-col justify-center" }, u6 = {
  key: 0,
  class: "anw-text-p2 font-bold text-neutral-700"
}, d6 = /* @__PURE__ */ x({
  __name: "AnwRatingBadge",
  props: {
    ratingAverage: {},
    numberOfRatings: {},
    showRatingText: { type: Boolean },
    showAmountOfRatingsText: { type: Boolean }
  },
  setup(t) {
    return (e, n) => (u(), m("div", o6, [
      d("div", s6, [
        e.ratingAverage > 0 ? (u(), m("span", l6, k(new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(e.ratingAverage)), 1)) : T("", !0)
      ]),
      d("div", c6, [
        e.showRatingText ? (u(), m("span", u6, k(p(go)[Math.ceil(e.ratingAverage - 1)]), 1)) : T("", !0),
        e.showAmountOfRatingsText ? (u(), D(Hn, {
          key: 1,
          "rating-variant": "basic",
          "rating-average": e.ratingAverage,
          "number-of-ratings": e.numberOfRatings
        }, null, 8, ["rating-average", "number-of-ratings"])) : (u(), D(je, {
          key: 2,
          "rating-average": e.ratingAverage
        }, null, 8, ["rating-average"]))
      ])
    ]));
  }
}), f6 = { class: "relative inline-flex flex-col gap-y-0.5 rounded-xl border border-neutral-300 p-2 pt-1.5" }, m6 = { class: "flex items-center gap-1.5" }, p6 = { class: "text-base font-bold" }, g6 = { class: "text-neutral-700" }, h6 = { class: "flex justify-between text-xs/[18px] font-medium" }, v6 = ["href"], A6 = {
  key: 1,
  class: "text-neutral-600"
}, b6 = /* @__PURE__ */ x({
  __name: "AnwRatingMinimal",
  props: {
    ratingAverage: {},
    ratingCount: {},
    ratingLink: {}
  },
  setup(t) {
    return (e, n) => (u(), m("div", f6, [
      d("div", m6, [
        d("span", p6, [
          d("span", g6, k(new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(e.ratingAverage)), 1),
          n[0] || (n[0] = d("span", { class: "text-neutral-500" }, "/5", -1))
        ]),
        M(je, { "rating-average": e.ratingAverage }, null, 8, ["rating-average"])
      ]),
      d("div", h6, [
        e.ratingLink ? (u(), m(U, { key: 0 }, [
          d("a", {
            href: e.ratingLink,
            class: "!text-neutral-600 before:absolute before:inset-0 before:content-['']"
          }, k(Intl.NumberFormat("de-DE").format(e.ratingCount)) + " " + k(p(er)[e.ratingCount === 1 ? 0 : 1]), 9, v6),
          M(p(Q), {
            icon: p(an),
            class: "text-[16px]",
            "aria-hidden": "true"
          }, null, 8, ["icon"])
        ], 64)) : (u(), m("span", A6, k(e.ratingCount) + " " + k(p(er)[e.ratingCount === 1 ? 0 : 1]), 1))
      ])
    ]));
  }
}), w6 = /* @__PURE__ */ x({
  __name: "AnwWrappedIcon",
  props: {
    icon: {},
    appearance: { default: "white" }
  },
  setup(t) {
    const e = t, n = w(() => ({
      "": !0,
      "anw-wrapped-icon-white": e.appearance === "white",
      "anw-wrapped-icon-neutral": e.appearance === "neutral",
      "anw-wrapped-icon-success": e.appearance === "success"
    }));
    return (a, i) => (u(), m("div", {
      class: L(["anw-wrapped-icon", n.value])
    }, [
      a.icon ? (u(), D(p(Q), {
        key: 0,
        icon: a.icon,
        class: "shrink-0 text-[28px]",
        "aria-hidden": "true"
      }, null, 8, ["icon"])) : T("", !0)
    ], 2));
  }
}), C6 = [
  { domain: "gmail.com", url: "https://mail.google.com/mail/u/1/#inbox", label: "Gmail-Postfach öffnen" },
  { domain: "web.de", url: "https://web.de/", label: "WEB.DE-Postfach öffnen" },
  { domain: "gmx.de", url: "https://www.gmx.net/", label: "GMX-Postfach öffnen" },
  { domain: "t-online.de", url: "https://email.t-online.de/em", label: "T-Online-Postfach öffnen" },
  { domain: "yahoo.de", url: "https://mail.yahoo.com/d/folders/1", label: "yahoo-Postfach öffnen" },
  { domain: "hotmail.de", url: "https://outlook.live.com/mail/0/", label: "Hotmail/Outlook-Postfach öffnen" },
  { domain: "googlemail.com", url: "https://mail.google.com/mail/u/1/#inbox", label: "Gmail-Postfach öffnen" },
  { domain: "hotmail.com", url: "https://outlook.live.com/mail/0/", label: "Hotmail/Outlook-Postfach öffnen" },
  { domain: "gmx.net", url: "https://www.gmx.net/", label: "GMX-Postfach öffnen" },
  { domain: "yahoo.com", url: "https://mail.yahoo.com/d/folders/1", label: "yahoo-Postfach öffnen" },
  { domain: "freenet.de", url: "https://webmail.freenet.de/web/#email/", label: "freenet-Postfach öffnen" },
  { domain: "icloud.com", url: "https://www.icloud.com/mail/", label: "iCloud-Postfach öffnen" },
  { domain: "outlook.de", url: "https://outlook.live.com/mail/0/", label: "Outlook-Postfach öffnen" },
  { domain: "outlook.com", url: "https://outlook.live.com/mail/0/", label: "Outlook-Postfach öffnen" }
], y6 = { key: 0 }, k6 = ["href"], x6 = /* @__PURE__ */ x({
  __name: "AnwLinkMail",
  props: {
    email: { default: "" }
  },
  setup(t) {
    const e = t;
    function n() {
      const i = /@(?<domain>[\w.]+)/gi.exec(e.email);
      return i ? C6.find((r) => {
        var o;
        return r.domain === ((o = i.groups) == null ? void 0 : o.domain);
      }) : null;
    }
    return (a, i) => {
      var r, o;
      return n() ? (u(), m("div", y6, [
        d("a", {
          href: (r = n()) == null ? void 0 : r.url,
          class: "anw-btn anw-btn-secondary-outline",
          target: "_blank"
        }, [
          J(k((o = n()) == null ? void 0 : o.label) + " ", 1),
          i[0] || (i[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
        ], 8, k6)
      ])) : T("", !0);
    };
  }
}), E6 = /* @__PURE__ */ x({
  __name: "EmailLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(w2),
      class: "text-[18px]"
    }, null, 8, ["icon"]));
  }
}), S6 = /* @__PURE__ */ x({
  __name: "LinkedinLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(Go),
      class: "text-[22px]"
    }, null, 8, ["icon"]));
  }
}), T6 = {};
function M6(t, e) {
  return u(), m("span", null, e[0] || (e[0] = [
    Ie('<svg class="hidden group-hover:block" width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><mask id="instagram-mask" style="mask-type:alpha;"><circle cx="20" cy="20" r="20" fill="currentColor"></circle></mask><g mask="url(#instagram-mask)"><path d="M20.0065 0C11.6567 0 9.2147 0.0086172 8.74003 0.0479999C7.02651 0.190473 5.96026 0.460347 4.79861 1.03884C3.90341 1.48351 3.19738 1.99893 2.50058 2.72146C1.2316 4.03911 0.462512 5.66016 0.184097 7.5871C0.0487445 8.52256 0.00936147 8.71334 0.00136399 13.4916C-0.00170499 15.0844 0.00136399 17.1805 0.00136399 19.9921C0.00136399 28.3375 0.010586 30.7777 0.0505885 31.2516C0.189025 32.9194 0.450508 33.9687 1.00425 35.1165C2.06252 37.3136 4.08366 38.963 6.46477 39.5784C7.28923 39.7908 8.19983 39.9077 9.36883 39.9631C9.86413 39.9846 14.9124 40 19.9638 40C25.0151 40 30.0665 39.9938 30.5495 39.9692C31.9031 39.9055 32.6891 39.8 33.5581 39.5753C35.9546 38.9568 37.9389 37.3321 39.0186 35.1042C39.5616 33.9841 39.837 32.8948 39.9616 31.314C39.9886 30.9694 40 25.4745 40 19.9869C40 14.4985 39.9877 9.01368 39.9606 8.66903C39.8345 7.06274 39.5592 5.98266 38.9987 4.84102C38.5387 3.90648 38.0281 3.20856 37.2867 2.49499C35.9635 1.23087 34.3454 0.461571 32.4171 0.183398C31.4828 0.0483024 31.2967 0.00829984 26.5161 0H20.0065Z" fill="url(#instagram-gradient-hover-0)"></path><path d="M20.0065 0C11.6567 0 9.2147 0.0086172 8.74003 0.0479999C7.02651 0.190473 5.96026 0.460347 4.79861 1.03884C3.90341 1.48351 3.19738 1.99893 2.50058 2.72146C1.2316 4.03911 0.462512 5.66016 0.184097 7.5871C0.0487445 8.52256 0.00936147 8.71334 0.00136399 13.4916C-0.00170499 15.0844 0.00136399 17.1805 0.00136399 19.9921C0.00136399 28.3375 0.010586 30.7777 0.0505885 31.2516C0.189025 32.9194 0.450508 33.9687 1.00425 35.1165C2.06252 37.3136 4.08366 38.963 6.46477 39.5784C7.28923 39.7908 8.19983 39.9077 9.36883 39.9631C9.86413 39.9846 14.9124 40 19.9638 40C25.0151 40 30.0665 39.9938 30.5495 39.9692C31.9031 39.9055 32.6891 39.8 33.5581 39.5753C35.9546 38.9568 37.9389 37.3321 39.0186 35.1042C39.5616 33.9841 39.837 32.8948 39.9616 31.314C39.9886 30.9694 40 25.4745 40 19.9869C40 14.4985 39.9877 9.01368 39.9606 8.66903C39.8345 7.06274 39.5592 5.98266 38.9987 4.84102C38.5387 3.90648 38.0281 3.20856 37.2867 2.49499C35.9635 1.23087 34.3454 0.461571 32.4171 0.183398C31.4828 0.0483024 31.2967 0.00829984 26.5161 0H20.0065Z" fill="url(#instagram-gradient-hover-1)"></path><path d="M20.0065 0C11.6567 0 9.2147 0.0086172 8.74003 0.0479999C7.02651 0.190473 5.96026 0.460347 4.79861 1.03884C3.90341 1.48351 3.19738 1.99893 2.50058 2.72146C1.2316 4.03911 0.462512 5.66016 0.184097 7.5871C0.0487445 8.52256 0.00936147 8.71334 0.00136399 13.4916C-0.00170499 15.0844 0.00136399 17.1805 0.00136399 19.9921C0.00136399 28.3375 0.010586 30.7777 0.0505885 31.2516C0.189025 32.9194 0.450508 33.9687 1.00425 35.1165C2.06252 37.3136 4.08366 38.963 6.46477 39.5784C7.28923 39.7908 8.19983 39.9077 9.36883 39.9631C9.86413 39.9846 14.9124 40 19.9638 40C25.0151 40 30.0665 39.9938 30.5495 39.9692C31.9031 39.9055 32.6891 39.8 33.5581 39.5753C35.9546 38.9568 37.9389 37.3321 39.0186 35.1042C39.5616 33.9841 39.837 32.8948 39.9616 31.314C39.9886 30.9694 40 25.4745 40 19.9869C40 14.4985 39.9877 9.01368 39.9606 8.66903C39.8345 7.06274 39.5592 5.98266 38.9987 4.84102C38.5387 3.90648 38.0281 3.20856 37.2867 2.49499C35.9635 1.23087 34.3454 0.461571 32.4171 0.183398C31.4828 0.0483024 31.2967 0.00829984 26.5161 0H20.0065Z" fill="url(#instagram-gradient-hover-2)"></path><path d="M24.4807 10H15.5192C12.4759 10 10 12.476 10 15.5193V24.4808C10 27.5242 12.4759 30.0001 15.5192 30.0001H24.4807C27.5242 30.0001 30.0001 27.5241 30.0001 24.4808V15.5193C30.0003 12.476 27.5242 10 24.4807 10ZM28.2258 24.4808C28.2258 26.5458 26.5458 28.2256 24.4808 28.2256H15.5192C13.4544 28.2258 11.7745 26.5458 11.7745 24.4808V15.5193C11.7745 13.4545 13.4544 11.7745 15.5192 11.7745H24.4807C26.5456 11.7745 28.2256 13.4545 28.2256 15.5193V24.4808H28.2258Z" fill="currentColor"></path><path d="M19.9999 14.8466C17.1582 14.8466 14.8464 17.1585 14.8464 20.0002C14.8464 22.8417 17.1582 25.1535 19.9999 25.1535C22.8416 25.1535 25.1534 22.8417 25.1534 20.0002C25.1534 17.1585 22.8416 14.8466 19.9999 14.8466ZM19.9999 23.3788C18.1368 23.3788 16.6209 21.8632 16.6209 20C16.6209 18.1368 18.1367 16.621 19.9999 16.621C21.8631 16.621 23.3789 18.1368 23.3789 20C23.3789 21.8632 21.863 23.3788 19.9999 23.3788Z" fill="currentColor"></path><path d="M25.3696 13.342C25.0277 13.342 24.6919 13.4804 24.4504 13.7229C24.2078 13.9642 24.0683 14.3002 24.0683 14.6433C24.0683 14.9853 24.2079 15.3211 24.4504 15.5637C24.6917 15.805 25.0277 15.9446 25.3696 15.9446C25.7127 15.9446 26.0475 15.805 26.29 15.5637C26.5325 15.3211 26.6709 14.9852 26.6709 14.6433C26.6709 14.3002 26.5325 13.9642 26.29 13.7229C26.0487 13.4804 25.7127 13.342 25.3696 13.342Z" fill="currentColor"></path></g><defs><radialGradient id="instagram-gradient-hover-0" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(38.7084 18.7485) rotate(164.25) scale(25.5577 18.4131)"><stop stop-color="#FF005F" offset="0"></stop><stop offset="1" stop-color="#FC01D8"></stop></radialGradient><radialGradient id="instagram-gradient-hover-1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.6247 43.0808) rotate(-90) scale(31.9288 33.8757)"><stop stop-color="#FFCC00" offset="0"></stop><stop offset="0.1242" stop-color="#FFCC00"></stop><stop offset="0.5672" stop-color="#FE4A05"></stop><stop offset="0.6942" stop-color="#FF0F3F"></stop><stop offset="1" stop-color="#FE0657" stop-opacity="0"></stop></radialGradient><radialGradient id="instagram-gradient-hover-2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(5.42714 1.62879) rotate(164.274) scale(25.2742 8.61091)"><stop stop-color="#780CFF" offset="0"></stop><stop offset="1" stop-color="#820BFF" stop-opacity="0"></stop></radialGradient></defs></svg><svg class="block group-hover:hidden" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path id="Vector" d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(#instagram-gradient-0)"></path><path id="Vector_2" d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(#instagram-gradient-1)"></path><path id="Vector_3" d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(#instagram-gradient-2)"></path><path id="Vector_4" d="M12.0032 2C7.82833 2 6.60732 2.00431 6.36998 2.024C5.51322 2.09524 4.9801 2.23017 4.39928 2.51942C3.95167 2.74176 3.59866 2.99947 3.25026 3.36073C2.61577 4.01955 2.23123 4.83008 2.09202 5.79355C2.02434 6.26128 2.00465 6.35667 2.00065 8.7458C1.99912 9.54218 2.00065 10.5903 2.00065 11.9961C2.00065 16.1687 2.00526 17.3888 2.02526 17.6258C2.09448 18.4597 2.22522 18.9844 2.5021 19.5583C3.03123 20.6568 4.0418 21.4815 5.23235 21.7892C5.64459 21.8954 6.09988 21.9538 6.68439 21.9815C6.93204 21.9923 9.45617 22 11.9818 22C14.5075 22 17.0332 21.9969 17.2747 21.9846C17.9515 21.9528 18.3445 21.9 18.779 21.7877C19.9773 21.4784 20.9694 20.666 21.5093 19.5521C21.7808 18.992 21.9184 18.4474 21.9807 17.657C21.9943 17.4847 22 14.7372 22 11.9935C22 9.24923 21.9938 6.50684 21.9803 6.33451C21.9172 5.53137 21.7795 4.99133 21.4993 4.42051C21.2693 3.95324 21.014 3.60428 20.6433 3.24749C19.9817 2.61544 19.1727 2.23079 18.2085 2.0917C17.7414 2.02415 17.6483 2.00415 15.258 2H12.0032Z" fill="url(#instagram-gradient-3)"></path><path id="Vector_5" d="M12.0041 4.56804C9.98453 4.56804 9.73108 4.57686 8.93788 4.61293C8.14625 4.64916 7.60589 4.77439 7.13307 4.95815C6.64399 5.14794 6.22911 5.40182 5.81579 5.81499C5.40216 6.22802 5.14808 6.64258 4.95753 7.13114C4.77318 7.60376 4.64769 8.14387 4.61206 8.93462C4.57659 9.72722 4.56729 9.98063 4.56729 11.9987C4.56729 14.0167 4.57628 14.2692 4.61221 15.0618C4.64863 15.8528 4.77396 16.3928 4.95769 16.8653C5.14777 17.354 5.40184 17.7685 5.81532 18.1816C6.2285 18.5949 6.64337 18.8494 7.13214 19.0392C7.60526 19.2229 8.14579 19.3482 8.93726 19.3844C9.73046 19.4205 9.98375 19.4293 12.0031 19.4293C14.0228 19.4293 14.2755 19.4205 15.0687 19.3844C15.8603 19.3482 16.4013 19.2229 16.8744 19.0392C17.3634 18.8494 17.7776 18.5949 18.1908 18.1816C18.6044 17.7685 18.8585 17.354 19.049 16.8654C19.2318 16.3928 19.3573 15.8527 19.3945 15.0619C19.4301 14.2693 19.4394 14.0167 19.4394 11.9987C19.4394 9.98063 19.4301 9.72737 19.3945 8.93477C19.3573 8.14371 19.2318 7.60376 19.049 7.1313C18.8585 6.64258 18.6044 6.22801 18.1908 5.81499C17.7771 5.40166 17.3635 5.14778 16.874 4.95815C16.3999 4.77439 15.8592 4.64916 15.0676 4.61293C14.2744 4.57686 14.0219 4.56804 12.0017 4.56804H12.0041ZM11.337 5.9071C11.535 5.90679 11.7559 5.9071 12.0041 5.9071C13.9895 5.9071 14.2248 5.91422 15.0089 5.94983C15.7339 5.98296 16.1274 6.10401 16.3895 6.20572C16.7365 6.3404 16.984 6.5014 17.2441 6.76147C17.5043 7.02154 17.6654 7.26923 17.8005 7.61599C17.9023 7.87761 18.0236 8.27081 18.0566 8.9953C18.0922 9.77861 18.1 10.0139 18.1 11.997C18.1 13.98 18.0922 14.2153 18.0566 14.9986C18.0235 15.7231 17.9023 16.1163 17.8005 16.3779C17.6658 16.7247 17.5043 16.9716 17.2441 17.2315C16.9838 17.4916 16.7367 17.6526 16.3895 17.7873C16.1277 17.8895 15.7339 18.0102 15.0089 18.0433C14.225 18.0789 13.9895 18.0867 12.0041 18.0867C10.0185 18.0867 9.78313 18.0789 8.99923 18.0433C8.27421 18.0099 7.88072 17.8888 7.61844 17.7871C7.27141 17.6524 7.02354 17.4914 6.76328 17.2314C6.50301 16.9713 6.3419 16.7242 6.20681 16.3773C6.10502 16.1157 5.98372 15.7225 5.95073 14.998C5.91509 14.2147 5.90797 13.9794 5.90797 11.9951C5.90797 10.0108 5.91509 9.77675 5.95073 8.99344C5.98388 8.26895 6.10502 7.87575 6.20681 7.61382C6.34158 7.26706 6.50301 7.01937 6.76328 6.7593C7.02354 6.49923 7.27141 6.33823 7.61844 6.20324C7.88056 6.10107 8.27421 5.98033 8.99923 5.94704C9.68522 5.91608 9.95106 5.90679 11.337 5.90524L11.337 5.9071ZM15.9734 7.14089C15.4808 7.14089 15.0811 7.53983 15.0811 8.03226C15.0811 8.52454 15.4808 8.92394 15.9734 8.92394C16.4661 8.92394 16.8658 8.52454 16.8658 8.03226C16.8658 7.53998 16.4661 7.14059 15.9734 7.14059L15.9734 7.14089ZM12.0041 8.18273C9.89513 8.18273 8.18529 9.89131 8.18529 11.9987C8.18529 14.106 9.89513 15.8138 12.0041 15.8138C14.113 15.8138 15.8222 14.106 15.8222 11.9987C15.8222 9.89131 14.1128 8.18273 12.0039 8.18273H12.0041ZM12.0041 9.52179C13.3729 9.52179 14.4828 10.6307 14.4828 11.9987C14.4828 13.3665 13.3729 14.4755 12.0041 14.4755C10.635 14.4755 9.52534 13.3665 9.52534 11.9987C9.52534 10.6307 10.635 9.52179 12.0041 9.52179Z" fill="white"></path></g><defs><radialGradient id="instagram-gradient-0" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21.3542 11.3742) rotate(164.25) scale(12.7789 9.20656)"><stop stop-color="#FF005F" offset="0"></stop><stop offset="1" stop-color="#FC01D8"></stop></radialGradient><radialGradient id="instagram-gradient-1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.31232 23.5404) rotate(-90) scale(15.9644 16.9379)"><stop stop-color="#FFCC00" offset="0"></stop><stop offset="0.1242" stop-color="#FFCC00"></stop><stop offset="0.5672" stop-color="#FE4A05"></stop><stop offset="0.6942" stop-color="#FF0F3F"></stop><stop offset="1" stop-color="#FE0657" stop-opacity="0"></stop></radialGradient><radialGradient id="instagram-gradient-2" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12.5054 21.7179) rotate(-59.8703) scale(6.60141 8.59429)"><stop stop-color="#FFCC00" offset="0"></stop><stop offset="1" stop-color="#FFCC00" stop-opacity="0"></stop></radialGradient><radialGradient id="instagram-gradient-3" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4.71354 2.81439) rotate(164.274) scale(12.6371 4.30546)"><stop stop-color="#780CFF" offset="0"></stop><stop offset="1" stop-color="#820BFF" stop-opacity="0"></stop></radialGradient></defs></svg>', 2)
  ]));
}
const I6 = /* @__PURE__ */ tn(T6, [["render", M6]]), L6 = /* @__PURE__ */ x({
  __name: "TwitterLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(fc),
      class: "text-[22px]"
    }, null, 8, ["icon"]));
  }
}), _6 = /* @__PURE__ */ x({
  __name: "FacebookLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(dc),
      class: "text-[18px]"
    }, null, 8, ["icon"]));
  }
}), O6 = /* @__PURE__ */ x({
  __name: "WhatsappLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(gc),
      class: "text-[22px]"
    }, null, 8, ["icon"]));
  }
}), P6 = /* @__PURE__ */ x({
  __name: "YoutubeLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), {
      icon: p(hc),
      class: "text-[24px]"
    }, null, 8, ["icon"]));
  }
}), B6 = {};
function R6(t, e) {
  return u(), m("span", null, e[0] || (e[0] = [
    Ie('<svg class="hidden group-hover:block" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="426.896 102.499 170.207 200"><path d="M442.394 142c-1.736 0-3.197.61-3.934 1.803-.76 1.231-.645 2.818.166 4.424l19.503 33.761c.033.064.033.105 0 .164l-30.648 54.084c-.799 1.592-.76 3.191 0 4.425.736 1.187 2.033 1.966 3.771 1.966h28.844c4.312 0 6.393-2.91 7.867-5.57 0 0 29.973-53.01 31.14-55.068-.118-.19-19.83-34.58-19.83-34.58-1.439-2.557-3.606-5.41-8.03-5.41h-28.849z" fill="currentColor"></path><path d="M563.574 102.501c-4.309 0-6.176 2.714-7.723 5.494 0 0-62.14 110.2-64.188 113.818.105.196 40.984 75.191 40.984 75.191 1.432 2.558 3.641 5.494 8.06 5.494h28.81c1.738 0 3.096-.654 3.828-1.843.77-1.23.748-2.857-.059-4.458l-40.664-74.295a.167.167 0 0 1 0-.189l63.863-112.92c.803-1.594.82-3.22.061-4.452-.736-1.188-2.098-1.843-3.836-1.843h-29.139v.002h.003z" fill="currentColor"></path></svg><svg class="block group-hover:hidden" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="426.896 102.499 170.207 200"><path d="M442.394 142c-1.736 0-3.197.61-3.934 1.803-.76 1.231-.645 2.818.166 4.424l19.503 33.761c.033.064.033.105 0 .164l-30.648 54.084c-.799 1.592-.76 3.191 0 4.425.736 1.187 2.033 1.966 3.771 1.966h28.844c4.312 0 6.393-2.91 7.867-5.57 0 0 29.973-53.01 31.14-55.068-.118-.19-19.83-34.58-19.83-34.58-1.439-2.557-3.606-5.41-8.03-5.41h-28.849z" fill="#005a5f"></path><path d="M563.574 102.501c-4.309 0-6.176 2.714-7.723 5.494 0 0-62.14 110.2-64.188 113.818.105.196 40.984 75.191 40.984 75.191 1.432 2.558 3.641 5.494 8.06 5.494h28.81c1.738 0 3.096-.654 3.828-1.843.77-1.23.748-2.857-.059-4.458l-40.664-74.295a.167.167 0 0 1 0-.189l63.863-112.92c.803-1.594.82-3.22.061-4.452-.736-1.188-2.098-1.843-3.836-1.843h-29.139v.002h.003z" fill="#d4d600"></path></svg>', 2)
  ]));
}
const N6 = /* @__PURE__ */ tn(B6, [["render", R6]]), D6 = /* @__PURE__ */ x({
  __name: "WebsiteLogo",
  setup(t) {
    return (e, n) => (u(), D(p(Q), { icon: p(h2) }, null, 8, ["icon"]));
  }
}), Xr = "email", eo = "linkedin", to = "instagram", no = "twitter", ao = "facebook", io = "whatsapp", ro = "youtube", oo = "website", so = "xing", H6 = ["href"], F6 = /* @__PURE__ */ x({
  __name: "AnwLinkSocialMedia",
  props: {
    href: {},
    type: {}
  },
  setup(t) {
    const e = t, n = w(() => ({
      "anw-social-media-email": e.type === Xr,
      "anw-social-media-linkedin": e.type === eo,
      "anw-social-media-instagram": e.type === to,
      "anw-social-media-twitter": e.type === no,
      "anw-social-media-facebook": e.type === ao,
      "anw-social-media-whatsapp": e.type === io,
      "anw-social-media-youtube": e.type === ro,
      "anw-social-media-xing": e.type === so,
      "anw-social-media-website": e.type === oo
    })), a = w(() => {
      switch (e.type) {
        case Xr:
          return E6;
        case eo:
          return S6;
        case to:
          return I6;
        case no:
          return L6;
        case ao:
          return _6;
        case io:
          return O6;
        case ro:
          return P6;
        case so:
          return N6;
        case oo:
          return D6;
        default:
          return null;
      }
    });
    return (i, r) => (u(), m("a", {
      href: i.href,
      class: L(["anw-social-media group", n.value]),
      target: "_blank"
    }, [
      (u(), D(ht(a.value), { "aria-hidden": "true" })),
      r[0] || (r[0] = d("span", { class: "sr-only" }, "Link in einem neuen Tab öffnen", -1))
    ], 10, H6));
  }
});
var ks = /* @__PURE__ */ ((t) => (t.ASC = "asc", t.DESC = "desc", t))(ks || {}), da = /* @__PURE__ */ ((t) => (t.ASC = "ascending", t.DESC = "descending", t.OTHER = "other", t.NONE = "none", t))(da || {});
const V6 = ["aria-sort", "onClick"], z6 = { class: "flex" }, U6 = {
  key: 0,
  class: "mr-2 align-middle"
}, Q6 = { class: "overflow-hidden text-ellipsis whitespace-nowrap" }, j6 = /* @__PURE__ */ x({
  __name: "DataTableHeader",
  props: {
    sortingParams: {},
    columns: {}
  },
  emits: ["onSorting"],
  setup(t, { emit: e }) {
    const n = e, a = t, i = (c) => {
      n("onSorting", c);
    };
    function r(c) {
      return c === a.sortingParams.field;
    }
    function o() {
      return a.sortingParams.dir === ks.DESC;
    }
    function s(c) {
      let f = u2;
      return r(c) && (f = o() ? s2 : r2), f;
    }
    function l(c) {
      return r(c) ? o() ? da.DESC : da.ASC : da.NONE;
    }
    return (c, f) => (u(), m("tr", null, [
      (u(!0), m(U, null, ne(c.columns, (g) => (u(), m("th", {
        key: g.field,
        "aria-sort": l(g.field),
        class: L([
          "border-b border-solid border-primary p-2.5 text-left align-top",
          g.headerSort ? r(g.field) ? "cursor-pointer text-primary-50 hover:text-primary" : "cursor-pointer text-neutral-500 hover:text-neutral-600" : " pointer-events-none cursor-default text-neutral-500"
        ]),
        onClick: (v) => i(g.field)
      }, [
        d("div", z6, [
          g.headerSort ? (u(), m("span", U6, [
            M(p(Q), {
              icon: s(g.field),
              class: "text-[16px]"
            }, null, 8, ["icon"])
          ])) : T("", !0),
          d("span", Q6, k(g.title), 1)
        ])
      ], 10, V6))), 128))
    ]));
  }
});
function Z6(t) {
  const e = N(0), n = N(0), a = w(() => t.value ? e.value > n.value : !1), i = new ResizeObserver((r) => {
    var o, s;
    for (const l of r)
      l && (e.value = (o = t.value) == null ? void 0 : o.scrollWidth, n.value = (s = t.value) == null ? void 0 : s.clientWidth);
  });
  return Ct(() => {
    i.observe(t.value);
  }), uo(() => {
    i.unobserve(t.value);
  }), {
    isOverflown: a,
    ellipsisClasses: "overflow-hidden text-ellipsis whitespace-nowrap"
  };
}
const G6 = { class: "group relative border-b border-solid border-primary p-1 text-left align-top md:p-2.5" }, Y6 = ["innerHTML"], K6 = ["innerHTML"], $6 = /* @__PURE__ */ x({
  __name: "DataTableCell",
  props: {
    content: { type: [String, Number, Boolean] },
    isLastInRow: { type: Boolean },
    hasCustomContent: { type: Boolean }
  },
  setup(t) {
    const e = t, { hasCustomContent: n } = st(e), a = N(), i = N(), { isOverflown: r, ellipsisClasses: o } = Z6(
      n.value ? a : i
    );
    return (s, l) => (u(), m("td", G6, [
      d("div", {
        ref_key: "cellRef",
        ref: a,
        class: L(p(o))
      }, [
        p(n) ? pe(s.$slots, "default", { key: 0 }) : (u(), m("div", {
          key: 1,
          ref_key: "staticContentRef",
          ref: i,
          class: L(p(o)),
          innerHTML: s.content
        }, null, 10, Y6))
      ], 2),
      d("span", {
        class: L([[
          p(r) && "group-hover:flex",
          s.isLastInRow ? "right-[100%] translate-x-1/3" : "left-[100%] -translate-x-1/4"
        ], "absolute bottom-full hidden min-w-[100%] border border-solid border-neutral-200 bg-neutral-100 p-3 text-sm"])
      }, [
        p(n) ? pe(s.$slots, "default", { key: 0 }) : (u(), m("div", {
          key: 1,
          innerHTML: s.content
        }, null, 8, K6))
      ], 2)
    ]));
  }
}), J6 = /* @__PURE__ */ x({
  __name: "DataTableBody",
  props: {
    data: {},
    columns: {}
  },
  setup(t) {
    const e = fo();
    return (n, a) => (u(!0), m(U, null, ne(n.data, (i, r) => (u(), m("tr", { key: r }, [
      (u(!0), m(U, null, ne(n.columns, (o, s) => (u(), D($6, {
        key: `${r}-${o.field}`,
        content: i[o.field],
        "has-custom-content": !!p(e)[`${o.field}`],
        "is-last-in-row": s === n.columns.length - 1
      }, {
        default: le(() => [
          p(e)[`${o.field}`] ? pe(n.$slots, `${o.field}`, ge({
            key: 0,
            ref_for: !0
          }, i)) : T("", !0)
        ]),
        _: 2
      }, 1032, ["content", "has-custom-content", "is-last-in-row"]))), 128))
    ]))), 128));
  }
}), Ja = 5;
function W6(t, e, n) {
  const a = () => Math.ceil(t / n), i = () => a() > Ja ? Ja : a(), r = () => q6(a(), Ja, e), o = (v) => e === v, s = () => e - 1 < 1, l = () => e + 1 > a(), c = (v) => v ? "text-neutral-300" : "text-primary-50 hover:text-primary-100 bg-transparent", f = (v) => !isNaN(v) && v <= a() && v > 0, g = w(() => `Bitte wählen Sie einen Wert zwischen 1 und ${a()}`);
  return {
    getTotalNumberOfPages: a,
    getNumberOfPagesVisible: i,
    isActivePage: o,
    isPreviousDisabled: s,
    isNextDisabled: l,
    getCurrentPaginationSet: r,
    getClassesForButtons: c,
    isRequestedPageValid: f,
    getPageSelectErrorText: g
  };
}
function q6(t, e, n) {
  const a = Math.floor(e / 2);
  if (!t || !n) {
    const i = `Cannot generate pagination. Check params total: ${t}, perpage: ${e},  current: ${n}`;
    throw console.error(i), new Error(i);
  }
  return t < e ? ra(t, 1) : n - a <= 1 ? ra(e, 1) : n + a >= t ? ra(e, 1 + (t - e)) : ra(e, n - a);
}
function ra(t, e) {
  return Array.from({ length: t }, (n, a) => a + e);
}
const X6 = { class: "my-8 flex flex-col items-center lg:flex-row lg:items-start" }, e5 = { class: "flex px-3 text-sm lg:w-3/12" }, t5 = {
  class: "flex justify-center lg:w-6/12",
  "aria-label": "Seitennummerierung "
}, n5 = { class: "flex" }, a5 = { class: "inline-flex" }, i5 = ["disabled"], r5 = ["disabled", "title", "onClick"], o5 = { class: "inline-flex" }, s5 = ["disabled"], l5 = { class: "flex justify-end px-3 text-sm lg:w-3/12" }, c5 = { class: "text-center lg:text-left" }, u5 = { class: "font-bold" }, d5 = { class: "mt-1" }, f5 = { class: "font-bold" }, m5 = /* @__PURE__ */ x({
  __name: "DataTablePagination",
  props: {
    page: {},
    totalCount: {},
    perPage: {}
  },
  emits: ["onPageChange"],
  setup(t, { emit: e }) {
    const n = e, a = t, { totalCount: i, page: r, perPage: o } = st(a), {
      isPreviousDisabled: s,
      getTotalNumberOfPages: l,
      isActivePage: c,
      isNextDisabled: f,
      getCurrentPaginationSet: g,
      getClassesForButtons: v,
      isRequestedPageValid: A,
      getPageSelectErrorText: y
    } = W6(i.value, r.value, o.value), _ = (j) => {
      n("onPageChange", j);
    }, C = () => {
      s() || _(a.page - 1);
    }, b = () => {
      f() || _(a.page + 1);
    }, S = N(r.value.toString()), F = N(!1), V = (j) => {
      if (S.value = j, F.value = !1, !j) return;
      const q = Number(j);
      A(q) ? _(Number(q)) : F.value = !0;
    };
    return (j, q) => (u(), m("div", X6, [
      d("div", e5, [
        M(Yo, {
          id: "go-to-page",
          "wrapper-class": "w-full",
          "model-value": S.value,
          "error-message": F.value ? p(y) : "",
          label: "Gehe zu Seite",
          "debounce-timeout": 1e3,
          "onUpdate:modelValue": V
        }, null, 8, ["model-value", "error-message"])
      ]),
      d("nav", t5, [
        d("ul", n5, [
          d("li", a5, [
            d("button", {
              title: "Zurück",
              class: L([p(v)(p(s)()), "p-2"]),
              disabled: p(s)(),
              onClick: C
            }, [
              M(p(Q), {
                icon: p(E2),
                class: "text-[40px]"
              }, null, 8, ["icon"])
            ], 10, i5)
          ]),
          (u(!0), m(U, null, ne(p(g)(), (X) => (u(), m("li", {
            key: X,
            class: "inline-flex items-center"
          }, [
            d("button", {
              class: L([[
                "inline-flex bg-transparent xl:text-xl",
                p(c)(X) ? "font-semibold text-primary-100" : "hover:bg-neutral-100"
              ], "px-2 py-2 xl:px-4"]),
              disabled: p(c)(X),
              title: p(c)(X) ? `Seite ${X}` : `Zu Seite ${X}`,
              onClick: (we) => _(X)
            }, k(X), 11, r5)
          ]))), 128)),
          d("li", o5, [
            d("button", {
              class: L([p(v)(p(f)()), "p-1 xl:p-2"]),
              disabled: p(f)(),
              title: "Vor",
              onClick: b
            }, [
              M(p(Q), {
                icon: p(A2),
                class: "text-[40px]"
              }, null, 8, ["icon"])
            ], 10, s5)
          ])
        ])
      ]),
      d("div", l5, [
        d("div", c5, [
          d("div", null, [
            q[0] || (q[0] = J(" Seiten insgesamt: ")),
            d("span", u5, k(p(l)()), 1)
          ]),
          d("div", d5, [
            q[1] || (q[1] = J(" Treffer insgesamt: ")),
            d("span", f5, k(p(i)), 1)
          ])
        ])
      ])
    ]));
  }
}), p5 = {
  key: 0,
  class: "flex h-screen w-full flex-col"
}, g5 = { class: "awn-crm-table w-full table-fixed" }, h5 = /* @__PURE__ */ x({
  __name: "AnwDatatable",
  props: {
    isLoading: { type: Boolean },
    isError: { type: Boolean },
    data: {},
    sortingParams: {},
    columns: {},
    totalCount: {},
    page: {},
    perPage: {},
    headerOffset: {}
  },
  emits: ["sorting", "pageChange"],
  setup(t, { emit: e }) {
    const n = e, a = t, i = async (c) => {
      n("sorting", c);
    }, r = async (c) => {
      n("pageChange", c);
    }, o = N();
    function s() {
      if (o.value)
        if (!a.headerOffset)
          o.value.scrollIntoView({ behavior: "smooth", block: "start" });
        else {
          const f = o.value.getBoundingClientRect().top + window.scrollY - a.headerOffset;
          window.scrollTo({
            top: f,
            behavior: "smooth"
          });
        }
    }
    be(
      () => [a.page, a.isError],
      async (c, f) => {
        (c || f) && (await wi(), s());
      }
    );
    const l = fo();
    return (c, f) => (u(), m("div", {
      ref_key: "table",
      ref: o,
      class: "my-5 py-4"
    }, [
      c.isLoading ? (u(), m("div", p5, [
        (u(), m(U, null, ne(5, (g) => M(qt, {
          key: g,
          appearance: "generic",
          class: "mt-2 w-full"
        })), 64))
      ])) : (u(), m(U, { key: 1 }, [
        c.isError ? (u(), D(ls, {
          key: 0,
          class: "my-6",
          label: "Es gab einen Fehler. Bitte versuche es nochmal.",
          appearance: "error"
        })) : T("", !0),
        c.data && c.data.length && c.totalCount ? (u(), m(U, { key: 1 }, [
          d("table", g5, [
            M(j6, {
              columns: c.columns,
              "sorting-params": c.sortingParams,
              onOnSorting: i
            }, null, 8, ["columns", "sorting-params"]),
            M(J6, {
              data: c.data,
              columns: c.columns
            }, Hs({ _: 2 }, [
              ne(p(l), (g, v) => ({
                name: v,
                fn: le((A) => [
                  pe(c.$slots, v, Fs(Vs(A)))
                ])
              }))
            ]), 1032, ["data", "columns"])
          ]),
          M(m5, {
            page: c.page,
            "total-count": c.totalCount,
            "per-page": c.perPage,
            onOnPageChange: r
          }, null, 8, ["page", "total-count", "per-page"])
        ], 64)) : T("", !0)
      ], 64))
    ], 512));
  }
}), w5 = {
  install: (t) => {
    t.component("AnwAlert", ls), t.component("AnwHintBox", Kf), t.component("AnwInitialsBadge", e4), t.component("AnwInput", Yo), t.component("AnwButton", Hi), t.component("AnwRoundButton", G2), t.component("AnwGradientButton", is), t.component("AnwLoader", Ni), t.component("AnwPagination", y4), t.component("AnwPlaceholder", qt), t.component("AnwRadio", Ru), t.component("AnwTextarea", nu), t.component("AnwCheckbox", Vu), t.component("AnwToggle", Zu), t.component("AnwSelect", yu), t.component("AnwSearchSelect", _u), t.component("AnwProgressNavigation", td), t.component("AnwProfileSummary", Qd), t.component("AnwWrappedIcon", w6), t.component("AnwListGroup", r4), t.component("AnwLists", On), t.component("AnwGridProfile", Ys), t.component("AnwGridFooter", dl), t.component("AnwFooterAccessible", Fc), t.component("AnwRatingStars", je), t.component("AnwRatingText", r6), t.component("AnwRatingCount", Hn), t.component("AnwRatingBadge", d6), t.component("AnwAvatar", fi), t.component("AnwAvatarVideo", A0), t.component("AnwAvatarRating", E0), t.component("AnwPhoneInput", i2), t.component("AnwInputPassword", p2), t.component("AnwLinkMail", x6), t.component("AnwDatatable", h5), t.component("AnwLinkSocialMedia", F6), t.component("AnwTooltip", K4), t.component("AnwPopup", S4), t.component("AnwTabs", F4), t.component("AnwAccordion", o0), t.component("AnwAccordionPlus", d0), t.component("AnwQuote", W4), t.component("AnwCertificate", lf), t.component("AnwModal", La), t.component("AnwToast", U4), t.component("AnwCarousel", Df), t.component("AnwBreadcrumbs", jc), t.component("AnwApiMap", O4), t.component("AnwStaticMap", B4), t.component("AnwHeading", wt), t.component("AnwReadMore", e3), t.component("AnwReadMoreExternal", o3), t.component("AnwReadMoreFaded", l3), t.component("AnwCarouselModal", ws), t.component("AnwFlag", Aa), t.component("AnwCardLawyer", ys), t.component("AnwCardWithImage", Z3), t.component("AnwCarouselLawyers", J3), t.component("AnwRatingMinimal", b6), t.component("AnwCopyToClipboard", q3), t.component("AnwLink", _a), t.component("AnwBadge", n6), t.component("AnwGoogleRating", Ci), t.component("AnwSearchBar", Q2), t.component("AnwPill", a6), t.component("AnwProfileSummarySidebar", i0);
  }
};
export {
  o0 as AnwAccordion,
  d0 as AnwAccordionPlus,
  ls as AnwAlert,
  O4 as AnwApiMap,
  fi as AnwAvatar,
  E0 as AnwAvatarRating,
  A0 as AnwAvatarVideo,
  n6 as AnwBadge,
  jc as AnwBreadcrumbs,
  Hi as AnwButton,
  ys as AnwCardLawyer,
  Z3 as AnwCardWithImage,
  Df as AnwCarousel,
  J3 as AnwCarouselLawyers,
  ws as AnwCarouselModal,
  lf as AnwCertificate,
  Vu as AnwCheckbox,
  q3 as AnwCopyToClipboard,
  h5 as AnwDatatable,
  Aa as AnwFlag,
  Fc as AnwFooterAccessible,
  Ci as AnwGoogleRating,
  is as AnwGradientButton,
  dl as AnwGridFooter,
  Ys as AnwGridProfile,
  wt as AnwHeading,
  Kf as AnwHintBox,
  e4 as AnwInitialsBadge,
  Yo as AnwInput,
  p2 as AnwInputPassword,
  _a as AnwLink,
  x6 as AnwLinkMail,
  F6 as AnwLinkSocialMedia,
  r4 as AnwListGroup,
  On as AnwLists,
  Ni as AnwLoader,
  La as AnwModal,
  y4 as AnwPagination,
  i2 as AnwPhoneInput,
  a6 as AnwPill,
  qt as AnwPlaceholder,
  S4 as AnwPopup,
  Qd as AnwProfileSummary,
  i0 as AnwProfileSummarySidebar,
  td as AnwProgressNavigation,
  W4 as AnwQuote,
  Ru as AnwRadio,
  d6 as AnwRatingBadge,
  Hn as AnwRatingCount,
  b6 as AnwRatingMinimal,
  je as AnwRatingStars,
  e3 as AnwReadMore,
  o3 as AnwReadMoreExternal,
  l3 as AnwReadMoreFaded,
  G2 as AnwRoundButton,
  Q2 as AnwSearchBar,
  _u as AnwSearchSelect,
  yu as AnwSelect,
  B4 as AnwStaticMap,
  F4 as AnwTabs,
  nu as AnwTextarea,
  U4 as AnwToast,
  Zu as AnwToggle,
  K4 as AnwTooltip,
  w6 as AnwWrappedIcon,
  w5 as default,
  jd as useFormattedName,
  Zd as useGetProfileValues
};
